import { mediaSource } from '../shared/mediaSource';
import MediaImage from './MediaImage';
import { calculateCreationMaxHp } from '../shared/beingHealth';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../styles/App.css';
import cdoAI from '../cdo/cdoAI.js';
import cdoAITokenUsage from '../cdo/cdoAITokenUsage.js';
import cdoBeing from '../cdo/cdoBeing.js';
import cdoEntityRelate from '../cdo/cdoEntityRelate.js';
import cdoPlace from '../cdo/cdoPlace.js';
import cdoForm from '../cdo/cdoForm.js';
import cdoItem from '../cdo/cdoItem.js';
import cdoContainerList from '../cdo/cdoContainerList.js';
import cdoCurrencyList from '../cdo/cdoCurrencyList.js';
import cdoEventList from '../cdo/cdoEventList.js';
import cdoGeneralList from '../cdo/cdoGeneralList.js';
import cdoMaterialList from '../cdo/cdoMaterialList.js';
import cdoMasterType from '../cdo/cdoMasterType.js';
import cdoMythos from '../cdo/cdoMythos.js';
import cdoProvisionList from '../cdo/cdoProvisionList.js';
import cdoSpell from '../cdo/cdoSpell.js';
import cdoSpellList from '../cdo/cdoSpellList.js';
import cdoSpellUsage from '../cdo/cdoSpellUsage.js';
import cdoWeaponList from '../cdo/cdoWeaponList.js';
import cdoWornList from '../cdo/cdoWornList.js';
import BeingEditor from './BeingEditor.js';
import EntityEditorCatalog from './EntityEditorCatalog.js';
import CombatTestPanel from './CombatTestPanel.js';
// THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
import Explore from './Explore.js';
import GameplayPlayTestPanel from './GameplayPlayTestPanel.js';
import GenerateTown from './GenerateTown.js';
import ItemEditor from './ItemEditor.js';
import PlaceEditor from './PlaceEditor.js';
import { createOverviewGeometrySaver, getMovedOverviewPlaces } from './placeOverviewPersistence.js';
import ReferenceEditor from './ReferenceEditor.js';
import TemplateEditor from './TemplateEditor.js';
import { templateReferenceConfigs } from './templateReferenceConfigs.js';
import { resolveBeingMana } from '../shared/mana.js';
import { buildPortraitAppearanceGuidance } from '../shared/portraitAppearance.js';

const ENTITY_BEING = 1;
const ENTITY_PLACE = 3;
const ENTITY_ITEM = 39;
const RELATE_TYPE_CONTAINS = 6006;
const SparklesIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8L12 2zm7 12l.9 2.1L22 17l-2.1.9L19 20l-.9-2.1L16 17l2.1-.9L19 14zM5 14l1.1 2.9L9 18l-2.9 1.1L5 22l-1.1-2.9L1 18l2.9-1.1L5 14z"
      fill="currentColor"
    />
  </svg>
);

const PencilIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M3 17.2V21h3.8L18 9.8 14.2 6 3 17.2zm17.7-10.1a1 1 0 0 0 0-1.4L18.3 3.3a1 1 0 0 0-1.4 0L15 5.2 18.8 9l1.9-1.9z"
      fill="currentColor"
    />
  </svg>
);

const SendIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path d="M3 20l18-8L3 4v6l12 2-12 2v6z" fill="currentColor" />
  </svg>
);

const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M17.7 6.3A8 8 0 1 0 20 12h-2a6 6 0 1 1-1.8-4.2L13 11h8V3l-3.3 3.3z"
      fill="currentColor"
    />
  </svg>
);

const LogIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M5 3h14a1 1 0 0 1 1 1v16l-3-2-3 2-3-2-3 2-3-2-3 2V4a1 1 0 0 1 1-1zm3 5h8V6H8v2zm0 5h8v-2H8v2zm0 4h5v-2H8v2z"
      fill="currentColor"
    />
  </svg>
);

const BeingTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-3.33 0-6 1.79-6 4v1h12v-1c0-2.21-2.67-4-6-4z"
      fill="currentColor"
    />
  </svg>
);

const ItemTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5v-9zm8-2.2L7 8l5 2.8L17 8l-5-2.7zm-6 4.2v5.8l5 2.8v-5.8L6 9.5zm7 8.6 5-2.8V9.5l-5 2.8v5.8z"
      fill="currentColor"
    />
  </svg>
);

const PlaceTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z"
      fill="currentColor"
    />
  </svg>
);

const EventTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M7 2h2v2h6V2h2v2h3v16H4V4h3V2zm11 6H6v10h12V8zm-9 2h2v2H9v-2zm4 0h2v2h-2v-2zm-4 4h2v2H9v-2zm4 0h2v2h-2v-2z"
      fill="currentColor"
    />
  </svg>
);

const FlaskTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M9 2h6v2l-1 1v4.3l4.9 7.6A3 3 0 0 1 16.4 21H7.6a3 3 0 0 1-2.5-4.1L10 9.3V5L9 4V2zm2 7.9-4.2 6.5a1 1 0 0 0 .8 1.6h8.8a1 1 0 0 0 .8-1.6L13 9.9V5h-2v4.9z"
      fill="currentColor"
    />
  </svg>
);

const ReferenceTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M6 3h9l3 3v15H6V3zm2 2v14h8V7h-3V5H8zm2 4h4v2h-4V9zm0 4h6v2h-6v-2z"
      fill="currentColor"
    />
  </svg>
);

const MythosTabIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="button-icon">
    <path
      d="M5 4.5A2.5 2.5 0 0 1 7.5 2H20v17.5a.5.5 0 0 1-.8.4A4.5 4.5 0 0 0 16.5 19H7.5A2.5 2.5 0 0 1 5 16.5v-12zm2.5-.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a6.4 6.4 0 0 1 1.5.2V4H7.5zM4 6H3a1 1 0 0 0-1 1v11.5A3.5 3.5 0 0 0 5.5 22H17v-2H5.5A1.5 1.5 0 0 1 4 18.5V6z"
      fill="currentColor"
    />
  </svg>
);

const createEmptyBeing = () => ({
  idEntity: '',
  name: '',
  title: '',
  description: '',
  entityType: 'Being',
  createDateAge: '',
  createDateYear: '',
  createDateSeason: '',
  createDateDay: '',
  destroyDateAge: '',
  destroyDateYear: '',
  destroyDateSeason: '',
  destroyDateDay: '',
  level: '',
  beingType: '',
  strength: '',
  agility: '',
  constitution: '',
  intellect: '',
  wisdom: '',
  charisma: '',
  alignment: '',
  gender: '',
  heraldry: '',
  defaultForm: '',
  multipleForms: false,
  personality: '',
  objectivesShortTerm: '',
  objectivesLongTerm: '',
  maxHp: '',
  currentHp: '',
  maxStamina: 100,
  currentStamina: 100,
  hunger: 0,
  thirst: 0,
  intoxication: 0,
  lastVitalsAdvancedMinute: '',
  bleeding: 0,
  poisoned: 0,
  other: 0,
  otherDesc: '',
  stunned: 0,
  disabled: 0,
  maxPp: 0,
  currentPp: 0,
  ownedItems: [],
  currencies: [],
  relationships: [],
  itemSuggestions: [],
  routines: [],
  forms: [],
  spells: [],
});

const calculateBeingMaxHp = being => {
  const health = being?.primarySkills?.find(row => Number(row.idPrimarySkillList) === 1);
  const healthRank = being?.skillProfileMode === 'level_default' ? 2 * (Number(being.level) || 0) : Number(health?.level ?? health?.rank) || 0;
  return calculateCreationMaxHp(being?.constitution, healthRank);
};

const createEmptyItem = () => ({
  idEntity: '',
  name: '',
  title: '',
  description: '',
  entityType: 'Item',
  createDateAge: '',
  createDateYear: '',
  createDateSeason: '',
  createDateDay: '',
  destroyDateAge: '',
  destroyDateYear: '',
  destroyDateSeason: '',
  destroyDateDay: '',
  level: '',
  itemType: '',
  qualityLevel: '',
  magicLevel: '',
  weapon: '',
  heldWithBodyPart: '',
  carriedWithBodyPart: '',
  length: 1,
  weight: 1,
  height: 1,
  width: 1,
  value: 0,
  worn: '',
  provisionMaterial: '',
  containedIn: '',
  quantity: '',
  preparedType: '',
  container: '',
  capacity: '',
  volume: '',
  general: '',
  ownerId: '',
  ownerName: '',
  containedById: '',
  containedByName: '',
  containsItems: [],
  materials: [],
  spells: [],
});

const createEmptyPlace = () => ({
  idEntity: '',
  name: '',
  title: '',
  description: '',
  entityType: 'Place',
  createDateAge: '',
  createDateYear: '',
  createDateSeason: '',
  createDateDay: '',
  destroyDateAge: '',
  destroyDateYear: '',
  destroyDateSeason: '',
  destroyDateDay: '',
  level: '',
  placeType: '',
  zoneType: '',
  buildingType: '',
  transitPointType: '',
  location: { x: 0, y: 0, z: 0, maxRadius: 0 },
  shape: {
    idEntityShape: '',
    shapeType: 'Box',
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
    minZ: 0,
    maxZ: 0,
    shapeData: {},
  },
  biomes: [],
  composedOfParents: [],
  composedOfChildren: [],
  siblingPlaces: [],
  adjacentPlaces: [],
  containedItems: [],
  savedInhabitants: [],
  childPlaceSuggestions: [],
  adjacentPlaceSuggestions: [],
  inhabitantSuggestions: [],
  itemSuggestions: [],
});

const createEmptyMasterType = () => ({
  idMasterType: '',
  table: '',
  column: '',
  value: '',
  code: '',
});

const createEmptyMaterialList = () => ({
  idMaterialList: '',
  name: '',
  bonus_physical: '',
  bonus_magical: '',
});

const createEmptyProvisionList = () => ({
  idProvisionMaterial: '',
  idProvisionCategory: '',
  name: '',
  value: '',
});

const createEmptyWeaponList = () => ({
  idWeapon: '',
  name: '',
  class: '',
  range: '',
  damage: '',
  typicalLength: '',
  typicalWeight: '',
  value: '',
});

const createEmptyWornList = () => ({
  idWorn: '',
  name: '',
  class: '',
  wornWithBodyPart: '',
  value: '',
});

const createEmptyContainerList = () => ({
  idContainer: '',
  name: '',
  capacityLow: '',
  capacityHigh: '',
  value: '',
});

const createEmptyGeneralList = () => ({
  idGeneral: '',
  name: '',
  value: '',
});

const createEmptyCurrencyList = () => ({
  idCurrency: '',
  name: '',
  value: '',
});

const createEmptyBeingPortraitState = () => ({
  src: '',
  revisedPrompt: '',
  isGenerating: false,
  isSaving: false,
  isSaved: false,
  isLoadingSavedImage: false,
  hasCheckedSavedImage: false,
  error: '',
});

const createEmptyPlaceImageState = () => createEmptyBeingPortraitState();

const createEmptyEventList = () => ({
  idEventType: '',
  name: '',
  category: '',
  description: '',
  defaultImportance: 3,
  requiresDialog: false,
  requiresTransaction: false,
  requiresCombat: false,
});

const createEmptySpellList = () => ({
  idSpellList: '',
  name: '',
  description: '',
  gmNotes: '',
  factor: '',
  realm: '',
});

const createEmptySpellUsage = () => ({
  idSpellUsage: '',
  name: '',
  enchantmentCostGP: '',
});

const parseRoutineJson = (value) => {
  if (!value) {
    return {};
  }

  if (typeof value === 'object') {
    return value;
  }

  if (typeof value !== 'string') {
    return {};
  }

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
};

const toEditableRoutineStep = (step, routineStart = 0, routineEnd = 1440) => ({
  startMinute: step?.startMinute ?? routineStart,
  endMinute: step?.endMinute ?? routineEnd,
  action: step?.action ?? '',
  targetXYZ:
    step?.targetXYZ && typeof step.targetXYZ === 'object'
      ? {
          x: step.targetXYZ.x ?? '',
          y: step.targetXYZ.y ?? '',
          z: step.targetXYZ.z ?? '',
        }
      : null,
  interruptible: Boolean(step?.interruptible),
  checkInEveryMinutes: step?.checkInEveryMinutes ?? 10,
  notes: step?.notes ?? '',
});

const toEditableRoutine = (routine) => {
  const routineJson = parseRoutineJson(routine?.routineJson);
  const startMinute = routine?.startMinute ?? 0;
  const endMinute = routine?.endMinute ?? 1440;
  const steps = routine?.steps ?? routineJson.steps;

  return {
    idBeingRoutine: routine?.idBeingRoutine ?? '',
    idBeing: routine?.idBeing ?? '',
    idPlace: routine?.idPlace ?? '',
    startMinute,
    endMinute,
    sourceHash: routine?.sourceHash ?? '',
    summary: routine?.summary ?? routineJson.summary ?? '',
    steps: Array.isArray(steps) ? steps.map((step) => toEditableRoutineStep(step, startMinute, endMinute)) : [],
  };
};

const toEditableBeing = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;
  const base = createEmptyBeing();
  const forms = Array.isArray(source?.forms)
    ? source.forms.map((form) => ({
        idEntityForms: form?.idEntityForms ?? '',
        form: form?.form ?? form?.formType ?? '',
        description: form?.description ?? '',
        gmNotes: form?.gmNotes ?? '',
      }))
    : [];
  const generatedMaxHp =
    source?.maxHp ?? source?.max_hp ?? (source?.idEntity ? base.maxHp : calculateBeingMaxHp(source));
  const { maxPp: generatedMaxPp, currentPp: generatedCurrentPp } = resolveBeingMana(source);

  return {
    ...base,
    idEntity: source?.idEntity ?? base.idEntity,
    name: source?.name ?? base.name,
    title: source?.title ?? base.title,
    description: source?.description ?? base.description,
    entityType: source?.entityType ?? base.entityType,
    createDateAge: source?.createDateAge ?? base.createDateAge,
    createDateYear: source?.createDateYear ?? base.createDateYear,
    createDateSeason: source?.createDateSeason ?? base.createDateSeason,
    createDateDay: source?.createDateDay ?? base.createDateDay,
    destroyDateAge: source?.destroyDateAge ?? base.destroyDateAge,
    destroyDateYear: source?.destroyDateYear ?? base.destroyDateYear,
    destroyDateSeason: source?.destroyDateSeason ?? base.destroyDateSeason,
    destroyDateDay: source?.destroyDateDay ?? base.destroyDateDay,
    level: source?.level ?? base.level,
    beingType: source?.beingType ?? base.beingType,
    strength: source?.strength ?? base.strength,
    agility: source?.agility ?? base.agility,
    constitution: source?.constitution ?? base.constitution,
    intellect: source?.intellect ?? base.intellect,
    wisdom: source?.wisdom ?? base.wisdom,
    charisma: source?.charisma ?? base.charisma,
    alignment: source?.alignment ?? base.alignment,
    gender: source?.gender ?? base.gender,
    heraldry: source?.heraldry ?? base.heraldry,
    defaultForm: source?.defaultForm ?? base.defaultForm,
    multipleForms: forms.length > 1,
    personality: source?.personality ?? base.personality,
    objectivesShortTerm: source?.objectivesShortTerm ?? base.objectivesShortTerm,
    objectivesLongTerm: source?.objectivesLongTerm ?? base.objectivesLongTerm,
    maxHp: generatedMaxHp,
    currentHp: source?.currentHp ?? source?.current_hp ?? (source?.idEntity ? base.currentHp : generatedMaxHp),
    maxPp: generatedMaxPp,
    currentPp: generatedCurrentPp,
    maxStamina: source?.maxStamina ?? source?.max_stamina ?? base.maxStamina,
    currentStamina: source?.currentStamina ?? source?.current_stamina ?? source?.maxStamina ?? source?.max_stamina ?? base.currentStamina,
    hunger: source?.hunger ?? base.hunger,
    thirst: source?.thirst ?? base.thirst,
    intoxication: source?.intoxication ?? base.intoxication,
    lastVitalsAdvancedMinute: source?.lastVitalsAdvancedMinute ?? source?.last_vitals_advanced_minute ?? base.lastVitalsAdvancedMinute,
    bleeding: source?.bleeding ?? base.bleeding,
    poisoned: source?.poisoned ?? base.poisoned,
    other: source?.other ?? base.other,
    otherDesc: source?.otherDesc ?? source?.other_desc ?? base.otherDesc,
    stunned: source?.stunned ?? base.stunned,
    disabled: source?.disabled ?? base.disabled,
    ownedItems: Array.isArray(source?.ownedItems)
      ? source.ownedItems.map((item) => ({
          idEntity: item?.idEntity ?? '',
          name: item?.name ?? item?.entityName ?? '',
          title: item?.title ?? item?.entityTitle ?? '',
        }))
      : [],
    currencies: Array.isArray(source?.currencies ?? source?.currency)
      ? (source.currencies ?? source.currency).map((currency) => ({
          idCurrency: currency?.idCurrency ?? '',
          currencyName: currency?.currencyName ?? currency?.name ?? '',
          value: currency?.value ?? '',
          quantity: currency?.quantity ?? '',
        }))
      : [],
    relationships: Array.isArray(source?.relationships)
      ? source.relationships.map((relationship) => ({
          idEntity: relationship?.idEntity ?? '',
          idRelated: relationship?.idRelated ?? '',
          relateType: relationship?.relateType ?? '',
          otherEntityId: relationship?.otherEntityId ?? '',
          otherEntityName: relationship?.otherEntityName ?? '',
          otherEntityTitle: relationship?.otherEntityTitle ?? '',
          otherEntityType: relationship?.otherEntityType ?? '',
          direction: relationship?.direction ?? '',
          score: Number.isFinite(Number(relationship?.score)) ? Number(relationship.score) : 50,
          demeanor: relationship?.demeanor ?? '',
        }))
      : [],
    itemSuggestions: Array.isArray(source?.itemSuggestions)
      ? source.itemSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          level: suggestion?.level ?? '',
          description: suggestion?.description ?? '',
          ...(suggestion?.instruction ? { instruction: suggestion.instruction } : {}),
        }))
      : [],
    routines: Array.isArray(source?.routines)
      ? source.routines.map((routine) => toEditableRoutine(routine))
      : [],
    forms,
    spells: Array.isArray(source?.spells ?? source?.spell)
      ? (source.spells ?? source.spell).map((spell) => ({
          idSpell: spell?.idSpell ?? '',
          idSpellList: spell?.idSpellList ?? '',
          idSpellUsage: spell?.idSpellUsage ?? '',
          quantity: spell?.quantity ?? '',
          level: spell?.level ?? '',
          realm: spell?.realm ?? '',
          acquiredVia: spell?.acquiredVia ?? '',
          acquiredNotes: spell?.acquiredNotes ?? '',
        }))
      : [],
  };
};

const toEditableItem = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;
  const base = createEmptyItem();

  return {
    ...base,
    idEntity: source?.idEntity ?? base.idEntity,
    name: source?.name ?? source?.entityName ?? base.name,
    title: source?.title ?? source?.entityTitle ?? base.title,
    description: source?.description ?? source?.entityDesc ?? base.description,
    entityType: source?.entityType ?? base.entityType,
    createDateAge: source?.createDateAge ?? base.createDateAge,
    createDateYear: source?.createDateYear ?? base.createDateYear,
    createDateSeason: source?.createDateSeason ?? base.createDateSeason,
    createDateDay: source?.createDateDay ?? base.createDateDay,
    destroyDateAge: source?.destroyDateAge ?? base.destroyDateAge,
    destroyDateYear: source?.destroyDateYear ?? base.destroyDateYear,
    destroyDateSeason: source?.destroyDateSeason ?? base.destroyDateSeason,
    destroyDateDay: source?.destroyDateDay ?? base.destroyDateDay,
    level: source?.level ?? base.level,
    itemType: source?.itemType ?? base.itemType,
    qualityLevel: source?.qualityLevel ?? base.qualityLevel,
    magicLevel: source?.magicLevel ?? base.magicLevel,
    weapon: source?.weapon ?? source?.weaponName ?? source?.idWeapon ?? base.weapon,
    heldWithBodyPart: source?.heldWithBodyPart ?? base.heldWithBodyPart,
    carriedWithBodyPart: source?.carriedWithBodyPart ?? base.carriedWithBodyPart,
    length: source?.length ?? base.length,
    weight: source?.weight ?? base.weight,
    height: source?.height ?? base.height,
    width: source?.width ?? base.width,
    value: source?.value ?? base.value,
    worn: source?.worn ?? source?.wornName ?? source?.idWorn ?? base.worn,
    provisionMaterial:
      source?.provisionMaterial ?? source?.provisionMaterialName ?? source?.idProvisionMaterial ?? source?.idProvision ?? base.provisionMaterial,
    containedIn: source?.containedIn ?? base.containedIn,
    quantity: source?.quantity ?? base.quantity,
    preparedType: source?.preparedType ?? base.preparedType,
    container: source?.container ?? source?.containerName ?? source?.idContainer ?? base.container,
    capacity: source?.capacity ?? base.capacity,
    volume: source?.volume ?? base.volume,
    general: source?.general ?? source?.generalName ?? source?.idGeneral ?? base.general,
    ownerId: source?.ownerId ?? base.ownerId,
    ownerName: source?.ownerName ?? base.ownerName,
    containedById: source?.containedById ?? base.containedById,
    containedByName: source?.containedByName ?? base.containedByName,
    containsItems: Array.isArray(source?.containsItems)
      ? source.containsItems.map((relatedItem) => ({
          idEntity: relatedItem?.idEntity ?? '',
          name: relatedItem?.name ?? relatedItem?.entityName ?? '',
          title: relatedItem?.title ?? relatedItem?.entityTitle ?? '',
        }))
      : [],
    materials: Array.isArray(source?.materials)
      ? source.materials.map((materialRow) =>
          typeof materialRow === 'object' ? materialRow?.name ?? '' : materialRow ?? ''
        )
      : [],
    spells: Array.isArray(source?.spells ?? source?.spell)
      ? (source.spells ?? source.spell).map((spell) => ({
          idSpell: spell?.idSpell ?? '',
          idSpellList: spell?.idSpellList ?? '',
          idSpellUsage: spell?.idSpellUsage ?? '',
          quantity: spell?.quantity ?? '',
          level: spell?.level ?? '',
          realm: spell?.realm ?? '',
          acquiredVia: spell?.acquiredVia ?? '',
          acquiredNotes: spell?.acquiredNotes ?? '',
        }))
      : [],
  };
};

export const toEditablePlace = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;
  const base = createEmptyPlace();
  const location = source?.location ?? {};
  const rawShapeData = source?.shape?.shapeData ?? source?.shapeData;
  let shapeData = base.shape.shapeData;

  if (rawShapeData && typeof rawShapeData === 'object') {
    shapeData = rawShapeData;
  } else if (typeof rawShapeData === 'string') {
    try {
      shapeData = JSON.parse(rawShapeData);
    } catch {
      shapeData = base.shape.shapeData;
    }
  }

  return {
    ...base,
    idEntity: source?.idEntity ?? base.idEntity,
    name: source?.name ?? source?.entityName ?? base.name,
    title: source?.title ?? source?.entityTitle ?? base.title,
    description: source?.description ?? source?.entityDesc ?? base.description,
    publicLabel: source?.publicLabel ?? '',
    publicDescription: source?.publicDescription ?? '',
    signs: Array.isArray(source?.signs) ? source.signs.map(sign => ({ ...sign })) : [],
    placePresentationLoaded: source?.placePresentationLoaded,
    signageAvailable: source?.signageAvailable,
    entityType: source?.entityType ?? base.entityType,
    createDateAge: source?.createDateAge ?? base.createDateAge,
    createDateYear: source?.createDateYear ?? base.createDateYear,
    createDateSeason: source?.createDateSeason ?? base.createDateSeason,
    createDateDay: source?.createDateDay ?? base.createDateDay,
    destroyDateAge: source?.destroyDateAge ?? base.destroyDateAge,
    destroyDateYear: source?.destroyDateYear ?? base.destroyDateYear,
    destroyDateSeason: source?.destroyDateSeason ?? base.destroyDateSeason,
    destroyDateDay: source?.destroyDateDay ?? base.destroyDateDay,
    level: source?.level ?? base.level,
    placeType: source?.placeType ?? base.placeType,
    zoneType: source?.zoneType ?? base.zoneType,
    buildingType: source?.buildingType ?? base.buildingType,
    transitPointType: source?.transitPointType ?? base.transitPointType,
    location: {
      x: location?.x ?? source?.x ?? base.location.x,
      y: location?.y ?? source?.y ?? base.location.y,
      z: location?.z ?? source?.z ?? base.location.z,
      maxRadius: location?.maxRadius ?? source?.maxRadius ?? base.location.maxRadius,
    },
    shape: {
      idEntityShape: source?.shape?.idEntityShape ?? source?.idEntityShape ?? base.shape.idEntityShape,
      shapeType: source?.shape?.shapeType ?? source?.shapeType ?? base.shape.shapeType,
      minX: source?.shape?.minX ?? source?.minX ?? base.shape.minX,
      maxX: source?.shape?.maxX ?? source?.maxX ?? base.shape.maxX,
      minY: source?.shape?.minY ?? source?.minY ?? base.shape.minY,
      maxY: source?.shape?.maxY ?? source?.maxY ?? base.shape.maxY,
      minZ: source?.shape?.minZ ?? source?.minZ ?? base.shape.minZ,
      maxZ: source?.shape?.maxZ ?? source?.maxZ ?? base.shape.maxZ,
      shapeData,
    },
    biomes: Array.isArray(source?.biomes)
      ? source.biomes.map(link => ({ ...link, idBiome: Number(link.idBiome) }))
      : [],
    composedOfParents: Array.isArray(source?.composedOfParents) ? source.composedOfParents : [],
    composedOfChildren: Array.isArray(source?.composedOfChildren) ? source.composedOfChildren : [],
    siblingPlaces: Array.isArray(source?.siblingPlaces) ? source.siblingPlaces : [],
    adjacentPlaces: Array.isArray(source?.adjacentPlaces) ? source.adjacentPlaces : [],
    containedItems: Array.isArray(source?.containedItems)
      ? source.containedItems.map((item) => ({
          idEntity: item?.idEntity ?? '',
          name: item?.name ?? item?.entityName ?? '',
          title: item?.title ?? item?.entityTitle ?? '',
          description: item?.description ?? item?.entityDesc ?? '',
          level: item?.level ?? '',
        }))
      : [],
    currencies: Array.isArray(source?.currencies ?? source?.currency)
      ? (source.currencies ?? source.currency).map((currency) => ({
          idCurrency: currency?.idCurrency ?? '',
          currencyName: currency?.currencyName ?? currency?.name ?? '',
          value: currency?.value ?? '',
          quantity: currency?.quantity ?? '',
        }))
      : [],
    savedInhabitants: Array.isArray(source?.savedInhabitants)
      ? source.savedInhabitants.map((being) => ({
          idEntity: being?.idEntity ?? '',
          name: being?.name ?? being?.entityName ?? '',
          title: being?.title ?? being?.entityTitle ?? '',
          description: being?.description ?? '',
          level: being?.level ?? '',
          beingType: being?.beingType ?? '',
          alignment: being?.alignment ?? '',
          personality: being?.personality ?? '',
        }))
      : [],
    childPlaceSuggestions: Array.isArray(source?.childPlaceSuggestions)
      ? source.childPlaceSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          placeType: suggestion?.placeType ?? '',
          zoneType: suggestion?.zoneType ?? '',
          buildingType: suggestion?.buildingType ?? '',
          transitPointType: suggestion?.transitPointType ?? '',
          description: suggestion?.description ?? '',
        }))
      : [],
    adjacentPlaceSuggestions: Array.isArray(source?.adjacentPlaceSuggestions)
      ? source.adjacentPlaceSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          placeType: suggestion?.placeType ?? '',
          zoneType: suggestion?.zoneType ?? '',
          buildingType: '',
          transitPointType: suggestion?.transitPointType ?? '',
          adjacentEdge: suggestion?.adjacentEdge ?? '',
          description: suggestion?.description ?? '',
        }))
      : [],
    inhabitantSuggestions: Array.isArray(source?.inhabitantSuggestions)
      ? source.inhabitantSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          level: suggestion?.level ?? 1,
          title: suggestion?.title ?? '',
          beingType: suggestion?.beingType ?? '',
          description: suggestion?.description ??
            [suggestion?.role, suggestion?.characterDescription].filter(Boolean).join(': '),
          memberOfPlaceId: suggestion?.memberOfPlaceId ?? '',
          placeRelationships: Array.isArray(suggestion?.placeRelationships)
            ? suggestion.placeRelationships.map((relationship) => ({
                targetPlaceId: relationship?.targetPlaceId ?? '',
                relateType: relationship?.relateType ?? '',
                reason: relationship?.reason ?? '',
              }))
            : [],
        }))
      : [],
    itemSuggestions: Array.isArray(source?.itemSuggestions)
      ? source.itemSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          level: suggestion?.level ?? '',
          description: suggestion?.description ?? '',
          ...(suggestion?.instruction ? { instruction: suggestion.instruction } : {}),
        }))
      : [],
  };
};

const normalizeNullableId = (fieldValue) => {
  if (fieldValue === undefined || fieldValue === null || fieldValue === '' || fieldValue === 0) {
    return null;
  }

  return fieldValue;
};

const normalizeOptionalNumber = (fieldValue) => {
  if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
    return null;
  }

  const parsed = Number(fieldValue);
  return Number.isNaN(parsed) ? fieldValue : parsed;
};

const normalizeRequiredNumber = (fieldValue) => {
  const parsed = Number(fieldValue);
  return Number.isNaN(parsed) ? fieldValue : parsed;
};

const normalizeRealmId = (fieldValue) => {
  if (fieldValue === undefined || fieldValue === null || fieldValue === '' || fieldValue === 0) {
    return 450;
  }

  return fieldValue;
};

const normalizeRoutineTargetPayload = (targetXYZ) => {
  if (!targetXYZ || typeof targetXYZ !== 'object') {
    return null;
  }

  const coordinates = [targetXYZ.x, targetXYZ.y, targetXYZ.z];
  if (coordinates.every((value) => value === '' || value === null || value === undefined)) {
    return null;
  }

  const [x, y, z] = coordinates.map((value) => Number(value));
  if (![x, y, z].every(Number.isFinite)) {
    return { x, y, z };
  }

  return { x, y, z };
};

const normalizeRoutinePayloadRows = (routines) =>
  Array.isArray(routines)
    ? routines.map((routine) => ({
        idBeingRoutine: normalizeNullableId(routine?.idBeingRoutine),
        idBeing: normalizeNullableId(routine?.idBeing),
        idPlace: normalizeNullableId(routine?.idPlace),
        startMinute: normalizeRequiredNumber(routine?.startMinute ?? 0),
        endMinute: normalizeRequiredNumber(routine?.endMinute ?? 1440),
        sourceHash: routine?.sourceHash ?? 'editor',
        routineJson: {
          summary: routine?.summary ?? '',
          steps: Array.isArray(routine?.steps)
            ? routine.steps.map((step) => ({
                startMinute: normalizeRequiredNumber(step?.startMinute ?? routine?.startMinute ?? 0),
                endMinute: normalizeRequiredNumber(step?.endMinute ?? routine?.endMinute ?? 1440),
                action: step?.action ?? '',
                targetXYZ: normalizeRoutineTargetPayload(step?.targetXYZ),
                interruptible: Boolean(step?.interruptible),
                checkInEveryMinutes: normalizeRequiredNumber(step?.checkInEveryMinutes ?? 10),
                notes: step?.notes ?? '',
              }))
            : [],
        },
      }))
    : [];

const callCdoSelect = (cdo, idEntity) =>
  new Promise((resolve, reject) => {
    cdo.select(idEntity, (err, response) => {
      if (err) {
        reject(err);
        return;
      }

      resolve(response ?? null);
    });
  });

const createInitialCombatState = () => ({
  distanceFeet: 300,
  firstCombatantPosition: { x: 0, y: 0, z: 0 },
  secondCombatantPosition: { x: 300, y: 0, z: 0 },
  itemLocations: {},
  activeSpellEffects: [],
  spellEffectHistory: [],
  roundNumber: 0,
});

const normalizeCombatDistanceFeet = (distanceFeet, fallback = 300) => {
  const parsedDistance = Number(distanceFeet);

  if (Number.isFinite(parsedDistance) && parsedDistance >= 0) {
    return parsedDistance;
  }

  return fallback;
};

const formatCombatFeet = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return '0';
  }

  return String(Math.round(numericValue));
};

const cloneCombatSpellEffect = (effect = {}) => ({
  ...effect,
  modifiers: { ...(effect?.modifiers ?? {}) },
});

const cloneCombatPosition = (position = {}) => ({
  x: Number(position?.x) || 0,
  y: Number(position?.y) || 0,
  z: Number(position?.z) || 0,
});

const getCombatantPositionByKey = (combatState, combatantKey) =>
  cloneCombatPosition(
    combatantKey === 'firstCombatant'
      ? combatState?.firstCombatantPosition
      : combatState?.secondCombatantPosition
  );

const normalizeCombatEntityId = (value) => String(value ?? '').trim().toLowerCase();

const getDefaultCombatItemState = (item, currentCombatItem = null) => {
  const itemId = normalizeCombatEntityId(item?.idEntity);
  const activeCombatItemId = normalizeCombatEntityId(currentCombatItem);

  if (String(item?.itemType ?? '').trim().toLowerCase() === 'worn') {
    return 'worn';
  }

  if (isAmmoLikeCombatItem(item)) {
    return 'carried';
  }

  if (item?.combatHeld) {
    return 'held';
  }

  if (activeCombatItemId && itemId === activeCombatItemId) {
    return 'held';
  }

  if (String(item?.heldWithBodyPart ?? '').trim()) {
    if (String(item?.weapon ?? '').trim() && activeCombatItemId && itemId !== activeCombatItemId) {
      return 'carried';
    }

    return 'held';
  }

  return 'carried';
};

const createCombatItemLocationRecord = (item, ownerKey, state, overrides = {}) => ({
  idEntity: item?.idEntity ?? overrides.idEntity ?? '',
  label: overrides.label ?? buildCombatAssociatedItemLabel(item) ?? '',
  ownerKey: overrides.ownerKey ?? ownerKey ?? null,
  state,
  relativeTo: overrides.relativeTo ?? (ownerKey ? ownerKey : null),
  embeddedIn: overrides.embeddedIn ?? null,
  position: overrides.position ? cloneCombatPosition(overrides.position) : null,
  notes: overrides.notes ?? '',
});

const buildCombatItemLocations = (firstCombatant, secondCombatant, existingLocations = {}) => {
  const nextLocations = { ...(existingLocations ?? {}) };
  const ownedItems = [
    ['firstCombatant', Array.isArray(firstCombatant?.ownedItems) ? firstCombatant.ownedItems : []],
    ['secondCombatant', Array.isArray(secondCombatant?.ownedItems) ? secondCombatant.ownedItems : []],
  ];

  ownedItems.forEach(([ownerKey, items]) => {
    const owner =
      ownerKey === 'firstCombatant'
        ? firstCombatant
        : secondCombatant;
    const currentCombatItem = normalizeCombatEntityId(owner?.currentCombatItem);

    items.forEach((item) => {
      if (!item?.idEntity) {
        return;
      }

      nextLocations[item.idEntity] = createCombatItemLocationRecord(
        item,
        ownerKey,
        getDefaultCombatItemState(item, currentCombatItem),
        {
          label: buildCombatAssociatedItemLabel(item),
        }
      );
    });
  });

  return nextLocations;
};

const refreshCombatOwnedItemLocations = (combatState, firstCombatant, secondCombatant) => ({
  ...combatState,
  itemLocations: buildCombatItemLocations(
    firstCombatant,
    secondCombatant,
    combatState?.itemLocations ?? {}
  ),
});

const syncCombatantReadiedItemLocations = (combatState, combatantKey, being) => {
  if (!combatState || !being || !Array.isArray(being.ownedItems)) {
    return combatState;
  }

  const activeCombatItemId = normalizeCombatEntityId(being.currentCombatItem);
  if (!activeCombatItemId) {
    return combatState;
  }

  const nextItemLocations = { ...(combatState.itemLocations ?? {}) };

  being.ownedItems.forEach((item) => {
    if (!item?.idEntity) {
      return;
    }

    const itemId = normalizeCombatEntityId(item.idEntity);
    const existingEntry = nextItemLocations[item.idEntity];
    const defaultState = getDefaultCombatItemState(item, being.currentCombatItem);
    const nextState = itemId === activeCombatItemId ? 'held' : defaultState;

    nextItemLocations[item.idEntity] = {
      ...(existingEntry ?? {}),
      ...createCombatItemLocationRecord(item, combatantKey, nextState, {
        label: buildCombatAssociatedItemLabel(item),
        ownerKey: combatantKey,
        relativeTo: combatantKey,
      }),
      state: nextState,
      ownerKey: combatantKey,
      relativeTo: combatantKey,
      embeddedIn: null,
      position: null,
    };
  });

  return {
    ...combatState,
    itemLocations: nextItemLocations,
  };
};

const updateCombatStateItemLocation = (combatState, item, nextLocation) => {
  if (!item?.idEntity) {
    return combatState;
  }

  return {
    ...combatState,
    itemLocations: {
      ...(combatState?.itemLocations ?? {}),
      [item.idEntity]: createCombatItemLocationRecord(item, null, nextLocation.state, nextLocation),
    },
  };
};

const actionDescriptionIndicatesDrop = (actionDescription) => {
  const normalized = String(actionDescription ?? '').trim().toLowerCase();
  return (
    normalized.includes('drop ') ||
    normalized.includes('drops ') ||
    normalized.includes('dropped ') ||
    normalized.includes('let go') ||
    normalized.includes('loose his grip') ||
    normalized.includes('loose her grip')
  );
};

const buildCombatStatusLine = (being) => {
  if (!being) {
    return '';
  }

  const statuses = [];
  const currentHp = Number(being.currentHp);
  const maxHp = Math.max(0, Number(being.maxHp) || 0);

  if (Number.isFinite(currentHp) && currentHp <= -maxHp && maxHp > 0) {
    statuses.push('Dead');
  } else if (Number.isFinite(currentHp) && currentHp <= 0) {
    statuses.push('Unconscious');
  }

  if (Number(being.bleeding) > 0) {
    statuses.push(`Bleeding ${being.bleeding}`);
  }

  if (Number(being.parryRounds) > 0) {
    statuses.push(`Parry ${being.parryRounds}`);
  }

  if (Number(being.poisoned) > 0) {
    statuses.push(`Poisoned ${being.poisoned}`);
  }

  if (Number(being.stunned) > 0) {
    statuses.push(`Stunned ${being.stunned}`);
  }

  if (Number(being.disabled) > 0) {
    statuses.push(`Disabled ${being.disabled}`);
  }

  if (Number(being.other) > 0) {
    statuses.push(being.otherDesc ? being.otherDesc : `Other ${being.other}`);
  }

  return statuses.join(', ');
};

const getCombatantIncapacitation = (being) => {
  if (!being) {
    return null;
  }

  const currentHp = Number(being.currentHp);
  const maxHp = Math.max(0, Number(being.maxHp) || 0);

  if (Number.isFinite(currentHp) && currentHp <= -maxHp && maxHp > 0) {
    return {
      type: 'Dead',
      description: 'Dead and cannot take an action.',
    };
  }

  if (Number.isFinite(currentHp) && currentHp <= 0) {
    return {
      type: 'Unconscious',
      description: 'Unconscious and cannot take an action.',
    };
  }

  return null;
};

const isCombatantDead = (being) => getCombatantIncapacitation(being)?.type === 'Dead';
const canCombatantUseObForDefense = (being) => Number(being?.disabled) <= 0;

const calculateCombatantDb = (being, options = {}) => {
  if (!being) {
    return 0;
  }

  const incapacitationType = getCombatantIncapacitation(being)?.type;
  const canActivelyDefend = incapacitationType !== 'Unconscious' && incapacitationType !== 'Dead';
  const agility = canActivelyDefend ? Number(being.agility) || 0 : 0;
  const wornClassTotal = Array.isArray(being.ownedItems)
    ? being.ownedItems.reduce((total, item) => {
        if (String(item?.itemType ?? '').trim().toLowerCase() !== 'worn') {
          return total;
        }

        if ((!canActivelyDefend || options.excludeShields) && isShieldLikeItem(item)) {
          return total;
        }

        return (
          total +
          (Number(item?.class) || 0) +
          (Number(item?.qualityLevel) || 0) +
          (Number(item?.magicLevel) || 0)
        );
      }, 0)
    : 0;

  return agility + wornClassTotal;
};

const normalizeCombatActionForStatus = (being, actionResult) => {
  if (!actionResult) {
    return actionResult;
  }

  const resolveAssociatedReference = (value) => {
    if (!being?.ownedItems || value === null || value === undefined || value === '') {
      return value;
    }

    if (typeof value === 'object') {
      return value;
    }

    const normalizedValue = String(value).trim();
    if (!normalizedValue) {
      return value;
    }

    return (
      being.ownedItems.find((item) => String(item?.idEntity ?? '').trim() === normalizedValue) ||
      value
    );
  };

  const normalizedActionResult = {
    ...actionResult,
    associatedItem: resolveAssociatedReference(actionResult.associatedItem),
    secondaryAssociatedItem: resolveAssociatedReference(actionResult.secondaryAssociatedItem),
  };

  if (Number(being?.disabled) > 0) {
    return {
      ...normalizedActionResult,
      offensiveBonus: 0,
      reservedDefenseBonus: 0,
    };
  }

  if (Number(being?.stunned) > 0) {
    return {
      ...normalizedActionResult,
      offensiveBonus: 0,
      reservedDefenseBonus: 50,
    };
  }

  if (Number(being?.parryRounds) > 0) {
    return {
      ...normalizedActionResult,
      offensiveBonus: 0,
      reservedDefenseBonus: 100,
    };
  }

  return normalizedActionResult;
};

const calculateCombatantDbForAction = (being, actionResult, combatState = null, combatantKey = null) => {
  const normalizedActionResult = normalizeCombatActionForStatus(being, actionResult);
  const incapacitationType = getCombatantIncapacitation(being)?.type;
  const canActivelyDefend = incapacitationType !== 'Unconscious' && incapacitationType !== 'Dead';
  const canUseObForDefense = canActivelyDefend && canCombatantUseObForDefense(being);
  const spellBonuses = combatantKey ? collectCombatSpellBonuses(combatState, combatantKey) : null;
  const baseDb = calculateCombatantDb(being, {
    excludeShields: Boolean(
      normalizedActionResult?.associatedItem && isBowLikeActionItem(normalizedActionResult.associatedItem)
    ),
  });

  return (
    baseDb +
    (canUseObForDefense ? Number(normalizedActionResult?.reservedDefenseBonus) || 0 : 0) +
    (Number(spellBonuses?.defensiveBonus) || 0)
  );
};

const combatantLabel = (being) => {
  if (!being) {
    return '';
  }

  return being.title ? `${being.name} (${being.title})` : being.name;
};

const getCombatAssociatedItemText = (associatedItem) => {
  if (!associatedItem) {
    return '';
  }

  if (typeof associatedItem === 'string') {
    return associatedItem.trim();
  }

  if (typeof associatedItem === 'object') {
    if (associatedItem.idEntity) {
      const builtLabel = buildCombatAssociatedItemLabel(associatedItem);
      if (builtLabel) {
        return builtLabel;
      }
    }

    const parts = [
      associatedItem.name,
      associatedItem.title,
      associatedItem.weapon,
      associatedItem.worn,
      associatedItem.general,
      associatedItem.container,
      associatedItem.description,
    ]
      .filter(Boolean)
      .map((part) => String(part).trim())
      .filter(Boolean);

    return parts.join(' ');
  }

  return String(associatedItem).trim();
};

const isShieldLikeItem = (item) => {
  const wornName = String(item?.worn ?? item?.wornName ?? item?.name ?? '').trim().toLowerCase();
  return wornName.includes('shield') || wornName.includes('buckler') || wornName.includes('pavise');
};

const isBowLikeActionItem = (associatedItem) => {
  const normalized = getCombatAssociatedItemText(associatedItem).toLowerCase();
  return normalized.includes('bow');
};

const isWeaponLikeCombatItem = (associatedItem) => {
  const normalized = getCombatAssociatedItemText(associatedItem).toLowerCase();

  if (!normalized) {
    return false;
  }

  return (
    normalized.includes('weapon:') ||
    normalized.includes('bow') ||
    normalized.includes('crossbow') ||
    normalized.includes('sling') ||
    normalized.includes('javelin') ||
    normalized.includes('dart') ||
    normalized.includes('sword') ||
    normalized.includes('axe') ||
    normalized.includes('mace') ||
    normalized.includes('spear') ||
    normalized.includes('dagger')
  );
};

const isRangedActionItem = (associatedItem) => {
  const normalized = getCombatAssociatedItemText(associatedItem).toLowerCase();
  return (
    normalized.includes('bow') ||
    normalized.includes('crossbow') ||
    normalized.includes('sling') ||
    normalized.includes('javelin') ||
    normalized.includes('thrown') ||
    normalized.includes('dart')
  );
};

const isAmmoLikeCombatItem = (item) => {
  const identifyingText = [
    item?.name,
    item?.title,
    item?.general,
    item?.weapon,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return (
    identifyingText.includes('arrow') ||
    identifyingText.includes('bolt') ||
    identifyingText.includes('quarrel') ||
    identifyingText.includes('shot')
  );
};

const getCombatItemRemainingCount = (item) => {
  const parsedQuantity = Number(item?.quantity);

  if (Number.isFinite(parsedQuantity)) {
    return Math.max(0, parsedQuantity);
  }

  return item ? 1 : 0;
};

const hasCombatItemRemainingCount = (item) => getCombatItemRemainingCount(item) > 0;

const buildCombatAssociatedItemLabel = (item) => {
  if (!item?.idEntity) {
    return '';
  }

  const parts = [];
  if (item.name) {
    parts.push(item.name);
  }
  if (item.title) {
    parts.push(item.title);
  }

  const details = [
    item.weapon && !isAmmoLikeCombatItem(item) ? `weapon: ${item.weapon}` : null,
    item.worn ? `worn: ${item.worn}` : null,
    item.general ? `general: ${item.general}` : null,
    item.container ? `container: ${item.container}` : null,
    item.provisionMaterial ? `provision: ${item.provisionMaterial}` : null,
  ].filter(Boolean);

  const baseLabel = parts.length ? parts.join(' | ') : item.idEntity;
  const detailSuffix = details.length ? ` [${details.join(', ')}]` : '';

  return `${baseLabel}${detailSuffix}`;
};

const findCombatAssociatedItem = (being, associatedItemLabel) => {
  if (!being || !associatedItemLabel || !Array.isArray(being.ownedItems)) {
    return null;
  }

  if (typeof associatedItemLabel === 'object' && associatedItemLabel.idEntity) {
    const matchedById = being.ownedItems.find(
      (item) => normalizeCombatEntityId(item?.idEntity) === normalizeCombatEntityId(associatedItemLabel.idEntity)
    );

    if (matchedById) {
      return matchedById;
    }
  }

  const normalizedAssociatedLabel = getCombatAssociatedItemText(associatedItemLabel);

  const matchedById = being.ownedItems.find(
    (item) => normalizeCombatEntityId(item?.idEntity) === normalizeCombatEntityId(normalizedAssociatedLabel)
  );

  if (matchedById) {
    return matchedById;
  }

  return (
    being.ownedItems.find((item) => buildCombatAssociatedItemLabel(item) === normalizedAssociatedLabel) ||
    null
  );
};

const findCombatAmmoItem = (being, actionResult) => {
  if (!being || !Array.isArray(being.ownedItems) || !isBowLikeActionItem(actionResult?.associatedItem)) {
    return null;
  }

  if (!actionResult?.secondaryAssociatedItem) {
    return null;
  }

  const explicitAmmo = findCombatAssociatedItem(being, actionResult.secondaryAssociatedItem);
  if (!explicitAmmo || !isAmmoLikeCombatItem(explicitAmmo) || !hasCombatItemRemainingCount(explicitAmmo)) {
    return null;
  }

  return explicitAmmo;
};

const getRapidInitiativeBonus = (being, combatState = null, combatantKey = null) => {
  const constantRapidBonus = [
    ...(Array.isArray(being?.spells) ? being.spells : []),
    ...(Array.isArray(being?.ownedItems)
      ? being.ownedItems.flatMap((item) => (Array.isArray(item?.spells) ? item.spells : []))
      : []),
  ].reduce((total, spell) => {
    if (
      normalizeCombatSpellName(spell?.idSpellList) === 'rapid' &&
      String(spell?.idSpellUsage ?? '').trim() === CONSTANT_SPELL_USAGE
    ) {
      return total + (Number(spell?.level) || 0);
    }

    return total;
  }, 0);
  const spellBonuses = combatantKey ? collectCombatSpellBonuses(combatState, combatantKey) : null;
  return constantRapidBonus + (Number(spellBonuses?.initiativeBonus) || 0);
};

const rollSingleDie100 = () => Math.floor(Math.random() * 100) + 1;

const rollOpenEndedDie100 = () => {
  const rolls = [];
  let total = 0;
  let direction = 1;

  while (true) {
    const value = rollSingleDie100();
    rolls.push({
      value,
      direction,
    });
    total += value * direction;

    if (value >= 96) {
      direction = 1;
      continue;
    }

    if (value <= 5) {
      direction *= -1;
      continue;
    }

    break;
  }

  return {
    total,
    rolls,
  };
};
const CONSTANT_SPELL_USAGE = 'Constant/Permanent';
const CAST_SPELL_USAGE = 'Cast';
const INITIATIVE_TICKS_PER_ACTION = 120;
const MELEE_ENGAGE_FEET = 10;

const getCombatSpellUsageName = (spell) => String(spell?.idSpellUsage ?? '').trim();

const isConstantCombatSpell = (spell) => getCombatSpellUsageName(spell) === CONSTANT_SPELL_USAGE;

const isCastCombatSpell = (spell) => getCombatSpellUsageName(spell) === CAST_SPELL_USAGE;

const isQuantityLimitedCombatSpell = (spell) => !isConstantCombatSpell(spell) && !isCastCombatSpell(spell);

const hasCombatSpellRemainingQuantity = (spell) => {
  const quantity = Number(spell?.quantity);
  return !Number.isFinite(quantity) || quantity > 0;
};

const getCombatSpellPowerPointCost = (spell) => Math.max(0, Number(spell?.level) || 0);

const getCombatSpellCurrentPp = (entity) => {
  const currentPp = Number(entity?.currentPp);
  return Number.isFinite(currentPp) ? currentPp : 0;
};

const cloneCombatantDetail = (being) => ({
  ...being,
  parryRounds: Number(being?.parryRounds) || 0,
  activeResistances: { ...(being?.activeResistances ?? {}) },
  currentCombatItem: being?.currentCombatItem ?? null,
  spells: Array.isArray(being?.spells) ? being.spells.map((spell) => ({ ...spell })) : [],
  ownedItems: Array.isArray(being?.ownedItems)
    ? being.ownedItems.map((item) => ({
        ...item,
        combatHeld: Boolean(item?.combatHeld),
        spells: Array.isArray(item?.spells) ? item.spells.map((spell) => ({ ...spell })) : [],
      }))
    : [],
});

const getInitialCombatItem = (being) => {
  if (!Array.isArray(being?.ownedItems)) {
    return null;
  }

  const heldWeapons = being.ownedItems.filter((item) => {
    const heldBodyPart = String(item?.heldWithBodyPart ?? '').trim();
    return (
      Boolean(heldBodyPart) &&
      !isAmmoLikeCombatItem(item) &&
      isWeaponLikeCombatItem(buildCombatAssociatedItemLabel(item))
    );
  });

  if (heldWeapons.length !== 1) {
    return null;
  }

  return getCombatWeaponKey(being, heldWeapons[0]);
};

const getCombatWeaponKey = (being, associatedItem) => {
  if (!associatedItem) {
    return '';
  }

  if (typeof associatedItem === 'object' && associatedItem.idEntity) {
    return normalizeCombatEntityId(associatedItem.idEntity);
  }

  const associatedLabel = getCombatAssociatedItemText(associatedItem);
  const matchedItem = findCombatAssociatedItem(being, associatedLabel);

  if (matchedItem?.idEntity) {
    return normalizeCombatEntityId(matchedItem.idEntity);
  }

  return normalizeCombatEntityId(associatedLabel);
};

const validateCombatActionSelection = (being, actionResult) => {
  if (!actionResult || typeof actionResult !== 'object') {
    return {
      isValid: false,
      message: 'No combat action was produced.',
    };
  }

  if (actionResult.intent && actionResult.intent !== 'action') {
    return {
      isValid: false,
      message: String(actionResult.responseMessage ?? '').trim() || 'No combat action was provided.',
      intent: actionResult.intent,
    };
  }

  const actionType = String(actionResult?.action ?? '').trim();
  if (!actionType) {
    return {
      isValid: false,
      message: 'No combat action was chosen.',
    };
  }

  if (actionType === 'Magic') {
    if (!findCombatSpell(being, actionResult?.associatedItem)) {
      return {
        isValid: false,
        message: 'That spell is not currently available to the acting being.',
      };
    }

    return { isValid: true };
  }

  if (actionType === 'Combat') {
    if (actionResult?.associatedItem && !findCombatAssociatedItem(being, actionResult.associatedItem)) {
      return {
        isValid: false,
        message: 'That combat item is not currently available to the acting being.',
      };
    }

    if (
      isBowLikeActionItem(actionResult?.associatedItem) &&
      !hasRequiredCombatAmmo(being, actionResult)
    ) {
      return {
        isValid: false,
        message:
          'You do not have another carried arrow or bolt available for that shot. Choose a different action, switch weapons, move, or cast a spell.',
      };
    }

    return { isValid: true };
  }

  if (actionType === 'Physical') {
    if (!actionResult?.associatedItem) {
      return { isValid: true };
    }

    const hasItem = Boolean(findCombatAssociatedItem(being, actionResult.associatedItem));
    const hasSpell = Boolean(findCombatSpell(being, actionResult.associatedItem));

    if (!hasItem && !hasSpell) {
      return {
        isValid: false,
        message: 'That intended follow-up item or spell is not currently available to the acting being.',
      };
    }
  }

  return { isValid: true };
};

const createCombatReadyBeing = (being) => {
  const clonedBeing = cloneCombatantDetail(being);
  const maxHp = Math.max(0, Number(clonedBeing?.maxHp) || 0);
  const { maxPp } = resolveBeingMana(clonedBeing);

  return {
    ...clonedBeing,
    currentHp: maxHp,
    maxPp,
    currentPp: maxPp,
    bleeding: 0,
    poisoned: 0,
    stunned: 0,
    disabled: 0,
    other: 0,
    otherDesc: '',
    parryRounds: 0,
    activeResistances: {},
    currentCombatItem: getInitialCombatItem(clonedBeing),
  };
};

const calculateCombatActionItemBonus = (being, actionResult) => {
  if (!being || !actionResult?.associatedItem) {
    return 0;
  }

  const associatedItem = findCombatAssociatedItem(being, actionResult.associatedItem);
  if (!associatedItem) {
    return 0;
  }

  let totalBonus = (Number(associatedItem.qualityLevel) || 0) + (Number(associatedItem.magicLevel) || 0);

  if (isBowLikeActionItem(actionResult.associatedItem)) {
    const ammoItem = findCombatAmmoItem(being, actionResult);

    if (ammoItem) {
      totalBonus += (Number(ammoItem.qualityLevel) || 0) + (Number(ammoItem.magicLevel) || 0);
    }
  }

  return totalBonus;
};

const describeActionRollQuality = (dieRoll) => {
  const rawDieRoll = Number(dieRoll) || 0;

  if (rawDieRoll <= -76) {
    return 'disastrous';
  }

  if (rawDieRoll <= -41) {
    return 'awkward';
  }

  if (rawDieRoll <= 0) {
    return 'labored';
  }

  if (rawDieRoll <= 40) {
    return 'ordinary';
  }

  if (rawDieRoll <= 75) {
    return 'strong';
  }

  if (rawDieRoll <= 95) {
    return 'swift';
  }

  return 'explosive';
};

const calculateCombatActionRoll = (being, actionResult, combatState = null, combatantKey = null) => {
  const dieRollResult = rollOpenEndedDie100();
  const levelBonus = (Number(being?.level) || 0) * 10;
  const spellBonuses = combatantKey ? collectCombatSpellBonuses(combatState, combatantKey) : null;
  const resolvedSpellMatch =
    String(actionResult?.action ?? '').trim() === 'Magic'
      ? findCombatSpell(being, actionResult?.associatedItem)
      : null;
  const itemBonus =
    String(actionResult?.action ?? '').trim() === 'Physical'
      ? 0
      : calculateCombatActionItemBonus(being, actionResult);
  const spellLevelBonus =
    String(actionResult?.action ?? '').trim() === 'Magic'
      ? (Number(resolvedSpellMatch?.spell?.level) || 0) * 10
      : 0;
  const spellActionBonus = Number(spellBonuses?.actionBonus) || 0;
  const spellMovementBonus =
    String(actionResult?.action ?? '').trim() === 'Physical' ? Number(spellBonuses?.movementBonus) || 0 : 0;

  return {
    dieRoll: dieRollResult.total,
    dieRolls: dieRollResult.rolls,
    levelBonus,
    itemBonus,
    spellLevelBonus,
    spellActionBonus,
    spellMovementBonus,
    quality: describeActionRollQuality(dieRollResult.total),
    total:
      dieRollResult.total +
      levelBonus +
      itemBonus +
      spellLevelBonus +
      spellActionBonus +
      spellMovementBonus,
  };
};

const getCombatBaseDamage = (being, actionResult) => {
  if (String(actionResult?.action ?? '').trim() === 'Magic') {
    const spellMatch = findCombatSpell(being, actionResult?.associatedItem);
    return Math.max(0, Number(spellMatch?.spell?.level) || 0);
  }

  const associatedItem = findCombatAssociatedItem(being, actionResult?.associatedItem);
  return (Number(associatedItem?.damage) || 0) / 2;
};

const consumeCombatAmmoItem = (being, actionResult) => {
  if (
    !being ||
    !Array.isArray(being.ownedItems) ||
    String(actionResult?.action ?? '').trim() !== 'Combat' ||
    !isBowLikeActionItem(actionResult?.associatedItem)
  ) {
    return null;
  }

  const ammoItem = findCombatAmmoItem(being, actionResult);
  if (!ammoItem?.idEntity) {
    return null;
  }

  const remainingCount = getCombatItemRemainingCount(ammoItem);

  if (Number.isFinite(Number(ammoItem?.quantity))) {
    let spentAmmo = null;
    being.ownedItems = being.ownedItems
      .map((item) => {
        if (item?.idEntity !== ammoItem.idEntity) {
          return item;
        }

        const nextQuantity = Math.max(0, remainingCount - 1);
        spentAmmo = nextQuantity === 0 ? { ...item, quantity: 0 } : null;

        if (nextQuantity === 0) {
          return null;
        }

        return {
          ...item,
          quantity: nextQuantity,
        };
      })
      .filter(Boolean);

    return spentAmmo;
  }

  being.ownedItems = being.ownedItems.filter((item) => item?.idEntity !== ammoItem.idEntity);
  return ammoItem;
};

const applyDroppedCurrentItem = (actingKey, being, actionDescription, combatState) => {
  if (!being?.currentCombatItem || !actionDescriptionIndicatesDrop(actionDescription)) {
    return combatState;
  }

  const droppedItem = findCombatAssociatedItem(being, being.currentCombatItem);
  if (!droppedItem?.idEntity) {
    return combatState;
  }

  being.currentCombatItem = null;
  if (Array.isArray(being.ownedItems)) {
    being.ownedItems = being.ownedItems.map((item) => ({
      ...item,
      combatHeld: false,
    }));
  }

  return updateCombatStateItemLocation(combatState, droppedItem, {
    state: 'ground',
    ownerKey: null,
    relativeTo: null,
    embeddedIn: null,
    position: getCombatantPositionByKey(combatState, actingKey),
    notes: 'Dropped during combat.',
  });
};

const applySpentAmmoLocation = (combatState, ammoItem, targetKey, outcome) => {
  if (!ammoItem?.idEntity) {
    return combatState;
  }

  const targetPosition = getCombatantPositionByKey(combatState, targetKey);
  const embedded = Number(outcome?.totalDamage) > 0;

  return updateCombatStateItemLocation(combatState, ammoItem, {
    state: embedded ? 'embedded' : 'ground',
    ownerKey: null,
    relativeTo: embedded ? targetKey : null,
    embeddedIn: embedded ? targetKey : null,
    position: embedded ? null : targetPosition,
    notes: embedded ? 'Embedded in target.' : 'Spent ammunition on the field.',
  });
};

const hasRequiredCombatAmmo = (being, actionResult) => {
  if (!isBowLikeActionItem(actionResult?.associatedItem)) {
    return true;
  }

  return Boolean(findCombatAmmoItem(being, actionResult));
};

const formatDamageValue = (value) => {
  if (!Number.isFinite(value)) {
    return '0';
  }

  return Number.isInteger(value) ? String(value) : value.toFixed(1);
};

const resolveCombatDamageTable = (adjustedRoll, baseDamage) => {
  if (adjustedRoll < 80) {
    return {
      adjustedRoll,
      damage: 0,
      damageLabel: '0',
      critBonus: null,
      critBonusLabel: 'None',
    };
  }

  if (adjustedRoll < 90) {
    return {
      adjustedRoll,
      damage: 1,
      damageLabel: '1',
      critBonus: null,
      critBonusLabel: 'None',
    };
  }

  if (adjustedRoll < 100) {
    return {
      adjustedRoll,
      damage: baseDamage,
      damageLabel: `WC (${formatDamageValue(baseDamage)})`,
      critBonus: -30,
      critBonusLabel: '-30',
    };
  }

  const step = Math.floor((adjustedRoll - 100) / 10);
  const multiplier = 1.5 + step * 0.5;
  const damage = baseDamage * multiplier;
  const critBonus = Math.min(50, step * 10);

  return {
    adjustedRoll,
    damage,
    damageLabel: `WC * ${multiplier} (${formatDamageValue(damage)})`,
    critBonus,
    critBonusLabel: String(critBonus),
  };
};

const resolveCritTable = (critTotal) => {
  let cumulative = {};
  let matchedRow = CRIT_EFFECT_ROWS[CRIT_EFFECT_ROWS.length - 1];

  for (const row of CRIT_EFFECT_ROWS) {
    cumulative = mergeCritDeltas(cumulative, row.deltas);
    if (critTotal <= row.max) {
      matchedRow = row;
      break;
    }
  }

  return {
    damage: matchedRow.damage,
    cumulative: cumulative,
    effect: formatCumulativeCritEffect(cumulative),
  };
};

const getCombatSpellName = (spell) => String(spell?.idSpellList ?? '').trim();

const normalizeCombatSpellName = (value) => getCombatSpellName({ idSpellList: value }).toLowerCase();

const getOpposingCombatantKey = (combatantKey) =>
  combatantKey === 'firstCombatant' ? 'secondCombatant' : 'firstCombatant';

const selectCombatSpellFromItem = (item) => {
  const itemSpells = Array.isArray(item?.spells) ? item.spells : [];
  const availableSpells = itemSpells.filter((spell) => {
    if (isConstantCombatSpell(spell) || isCastCombatSpell(spell)) {
      return true;
    }

    return hasCombatSpellRemainingQuantity(spell);
  });

  const candidateSpells = availableSpells.length > 0 ? availableSpells : itemSpells;
  if (candidateSpells.length === 0) {
    return null;
  }

  return candidateSpells
    .slice()
    .sort((left, right) => (Number(right?.level) || 0) - (Number(left?.level) || 0))[0];
};

const findCombatSpell = (being, associatedSpell) => {
  if (!being) {
    return null;
  }

  const normalizedAssociatedSpell = String(associatedSpell ?? '').trim().toLowerCase();
  const associatedItemId =
    associatedSpell && typeof associatedSpell === 'object' && associatedSpell.idEntity
      ? String(associatedSpell.idEntity).trim().toLowerCase()
      : '';

  const matchesSpell = (spell) => {
    const spellId = String(spell?.idSpell ?? '').trim().toLowerCase();
    const spellName = getCombatSpellName(spell).toLowerCase();
    return spellId === normalizedAssociatedSpell || spellName === normalizedAssociatedSpell;
  };

  const directSpell =
    normalizedAssociatedSpell && Array.isArray(being?.spells)
    ? being.spells.find((spell) => {
        return matchesSpell(spell);
      })
    : null;

  if (directSpell) {
    return {
      spell: directSpell,
      sourceType: 'being',
      item: null,
    };
  }

  if (!Array.isArray(being?.ownedItems)) {
    return null;
  }

  for (const item of being.ownedItems) {
    const normalizedItemId = String(item?.idEntity ?? '').trim().toLowerCase();
    const normalizedItemLabel = buildCombatAssociatedItemLabel(item).trim().toLowerCase();
    const matchesItemSelection =
      Boolean(normalizedAssociatedSpell) &&
      (normalizedItemId === normalizedAssociatedSpell || normalizedItemLabel === normalizedAssociatedSpell);
    const matchesAssociatedItemObject = Boolean(associatedItemId) && normalizedItemId === associatedItemId;

    if (matchesItemSelection || matchesAssociatedItemObject) {
      const selectedSpell = selectCombatSpellFromItem(item);
      if (selectedSpell) {
        return {
          spell: selectedSpell,
          sourceType: 'item',
          item,
        };
      }
    }

    const itemSpell = Array.isArray(item?.spells)
      ? item.spells.find((spell) => {
          if (!normalizedAssociatedSpell) {
            return false;
          }
          return matchesSpell(spell);
        })
      : null;

    if (itemSpell) {
      return {
        spell: itemSpell,
        sourceType: 'item',
        item,
      };
    }
  }

  return null;
};

const shouldConsumeCombatSpellCharge = (spell) =>
  isQuantityLimitedCombatSpell(spell) && hasCombatSpellRemainingQuantity(spell);

const consumeCombatSpellLocally = (being, spellMatch) => {
  if (!being || !spellMatch?.spell?.idSpell) {
    return null;
  }

  if (spellMatch.sourceType === 'being') {
    let nextSpell = null;
    being.spells = Array.isArray(being.spells)
      ? being.spells.map((spell) => {
          if (String(spell?.idSpell ?? '').trim() !== String(spellMatch.spell.idSpell).trim()) {
            return spell;
          }

          nextSpell = {
            ...spell,
            quantity: Math.max(0, (Number(spell.quantity) || 0) - 1),
          };
          return nextSpell;
        })
      : [];

    return nextSpell;
  }

  let nextSpell = null;
  being.ownedItems = Array.isArray(being.ownedItems)
    ? being.ownedItems.map((item) => {
        if (String(item?.idEntity ?? '').trim() !== String(spellMatch.item?.idEntity ?? '').trim()) {
          return item;
        }

        return {
          ...item,
          spells: Array.isArray(item?.spells)
            ? item.spells.map((spell) => {
                if (String(spell?.idSpell ?? '').trim() !== String(spellMatch.spell.idSpell).trim()) {
                  return spell;
                }

                nextSpell = {
                  ...spell,
                  quantity: Math.max(0, (Number(spell.quantity) || 0) - 1),
                };
                return nextSpell;
              })
            : [],
        };
      })
    : [];

  return nextSpell;
};

const consumeCombatSpellPowerPointsLocally = (being, spellMatch) => {
  if (!being || !spellMatch?.spell) {
    return null;
  }

  const spellCost = getCombatSpellPowerPointCost(spellMatch.spell);

  if (spellMatch.sourceType === 'item' && spellMatch.item) {
    let nextCurrentPp = null;
    const targetItemId = String(spellMatch.item.idEntity ?? '').trim();

    being.ownedItems = Array.isArray(being.ownedItems)
      ? being.ownedItems.map((item) => {
          if (String(item?.idEntity ?? '').trim() !== targetItemId) {
            return item;
          }

          nextCurrentPp = Math.max(0, getCombatSpellCurrentPp(item) - spellCost);
          spellMatch.item.currentPp = nextCurrentPp;
          return {
            ...item,
            currentPp: nextCurrentPp,
          };
        })
      : [];

    return nextCurrentPp;
  }

  const nextCurrentPp = Math.max(0, getCombatSpellCurrentPp(being) - spellCost);
  being.currentPp = nextCurrentPp;
  return nextCurrentPp;
};

const buildCombatSpellEffectModifiers = (spell, effectiveLevel = null) => {
  const normalizedName = normalizeCombatSpellName(spell?.idSpellList);
  const spellLevel =
    effectiveLevel === null || effectiveLevel === undefined
      ? Math.max(1, Number(spell?.level) || 1)
      : Math.max(0, Number(effectiveLevel) || 0);

  switch (normalizedName) {
    case 'inspire':
      return {
        actionBonus: spellLevel * 5,
        defensiveBonus: spellLevel * 5,
      };
    case 'rapid':
      return {
        initiativeBonus: spellLevel,
        movementBonus: spellLevel * 5,
      };
    case 'shield':
      return {
        defensiveBonus: spellLevel,
      };
    case 'resist':
      return {
        defensiveBonus: spellLevel * 5,
      };
    default:
      return {};
  }
};

const scaleCombatSpellEffectLevel = (spellLevel, actionRollTotal) => {
  const baseLevel = Math.max(1, Number(spellLevel) || 1);
  const scaledLevel = Math.floor((baseLevel * Math.max(0, Number(actionRollTotal) || 0)) / 100);
  return Math.max(0, scaledLevel);
};

const isLikelyOffensiveCombatSpell = (spellOrName) => {
  const normalizedName =
    typeof spellOrName === 'string'
      ? String(spellOrName).trim().toLowerCase()
      : getCombatSpellName(spellOrName).toLowerCase();

  if (!normalizedName) {
    return false;
  }

  return [
    'fire',
    'flame',
    'burn',
    'bolt',
    'ball',
    'blast',
    'lightning',
    'shock',
    'ice',
    'frost',
    'cold',
    'acid',
    'death',
    'pain',
    'strike',
    'storm',
    'arrow',
    'hammer',
    'dark',
  ].some((token) => normalizedName.includes(token));
};

const buildCombatSpellEffectNotes = (spell) => {
  const spellName = getCombatSpellName(spell);
  const notes = [];
  const normalizedName = spellName.toLowerCase();

  if (normalizedName === 'inspire') {
    notes.push('Bolsters the chosen side with battlefield morale.');
  } else if (normalizedName === 'rapid') {
    notes.push('Quickens the chosen side for faster reactions.');
  } else if (normalizedName === 'shield') {
    notes.push('Wraps the chosen side in layered protection.');
  } else if (normalizedName === 'resist') {
    notes.push('Hardens the chosen side against incoming force.');
  } else if (spellName) {
    notes.push(`${spellName} is now influencing the combat state.`);
  }

  if (String(spell?.acquiredNotes ?? '').trim()) {
    notes.push(String(spell.acquiredNotes).trim());
  }

  return notes.join(' ');
};

const resolveCombatSpellTargetSide = (spell, actingKey) => {
  const normalizedName = normalizeCombatSpellName(spell?.idSpellList);

  if (['dark', 'lock', 'sound', 'illusions', 'insect', 'arachnid'].includes(normalizedName)) {
    return getOpposingCombatantKey(actingKey);
  }

  return actingKey;
};

const createCombatSpellEffect = (spell, caster, actingKey, roundNumber, actionRollTotal = null) => {
  const spellName = getCombatSpellName(spell);
  const baseSpellLevel = Math.max(1, Number(spell?.level) || 1);
  const appliesToSide = resolveCombatSpellTargetSide(spell, actingKey);
  const isConstant = String(spell?.idSpellUsage ?? '').trim() === CONSTANT_SPELL_USAGE;
  const effectiveSpellLevel =
    actionRollTotal === null || actionRollTotal === undefined
      ? baseSpellLevel
      : scaleCombatSpellEffectLevel(baseSpellLevel, actionRollTotal);
  const roundsRemaining = isConstant ? null : effectiveSpellLevel;

  return {
    id: `${actingKey}-${spell?.idSpell ?? spellName}-${roundNumber}`,
    spellId: spell?.idSpell ?? '',
    spellName,
    spellUsage: spell?.idSpellUsage ?? '',
    realm: spell?.realm ?? '',
    level: baseSpellLevel,
    effectiveLevel: effectiveSpellLevel,
    castRollTotal: actionRollTotal,
    castBy: actingKey,
    castByName: combatantLabel(caster),
    appliesToSide,
    roundsRemaining,
    initialRounds: roundsRemaining,
    startedRound: roundNumber,
    status: 'active',
    notes: buildCombatSpellEffectNotes(spell),
    modifiers: buildCombatSpellEffectModifiers(spell, effectiveSpellLevel),
  };
};

const applyCombatSpellEffectToState = (combatState, effect) => ({
  ...combatState,
  activeSpellEffects: [...(Array.isArray(combatState?.activeSpellEffects) ? combatState.activeSpellEffects : []), effect],
});

const collectCombatSpellBonuses = (combatState, combatantKey) => {
  const totals = {
    initiativeBonus: 0,
    actionBonus: 0,
    defensiveBonus: 0,
    movementBonus: 0,
  };

  const activeEffects = Array.isArray(combatState?.activeSpellEffects) ? combatState.activeSpellEffects : [];
  activeEffects.forEach((effect) => {
    if (!effect || effect.appliesToSide !== combatantKey || effect.status !== 'active') {
      return;
    }

    totals.initiativeBonus += Number(effect?.modifiers?.initiativeBonus) || 0;
    totals.actionBonus += Number(effect?.modifiers?.actionBonus) || 0;
    totals.defensiveBonus += Number(effect?.modifiers?.defensiveBonus) || 0;
    totals.movementBonus += Number(effect?.modifiers?.movementBonus) || 0;
  });

  return totals;
};

const advanceCombatSpellEffects = (combatState, roundNumber) => {
  const activeEffects = Array.isArray(combatState?.activeSpellEffects) ? combatState.activeSpellEffects : [];
  const nextActiveEffects = [];
  const expiredEffects = [];

  activeEffects.forEach((effect) => {
    if (!effect || effect.status !== 'active') {
      return;
    }

    if (effect.roundsRemaining === null) {
      nextActiveEffects.push(cloneCombatSpellEffect(effect));
      return;
    }

    const nextRoundsRemaining = Math.max(0, (Number(effect.roundsRemaining) || 0) - 1);
    const nextEffect = cloneCombatSpellEffect({
      ...effect,
      roundsRemaining: nextRoundsRemaining,
    });

    if (nextRoundsRemaining > 0) {
      nextActiveEffects.push(nextEffect);
      return;
    }

    expiredEffects.push(
      cloneCombatSpellEffect({
        ...nextEffect,
        status: 'expired',
        expiredRound: roundNumber,
      })
    );
  });

  return {
    ...combatState,
    activeSpellEffects: nextActiveEffects,
    spellEffectHistory: [
      ...(Array.isArray(combatState?.spellEffectHistory) ? combatState.spellEffectHistory : []),
      ...expiredEffects,
    ],
    roundNumber,
  };
};

const summarizeCombatSpellEffect = (effect) => {
  if (!effect) {
    return '';
  }

  const modifierParts = [];
  if (Number(effect?.modifiers?.initiativeBonus)) {
    modifierParts.push(`Init ${formatSignedValue(effect.modifiers.initiativeBonus)}`);
  }
  if (Number(effect?.modifiers?.actionBonus)) {
    modifierParts.push(`Action ${formatSignedValue(effect.modifiers.actionBonus)}`);
  }
  if (Number(effect?.modifiers?.defensiveBonus)) {
    modifierParts.push(`DB ${formatSignedValue(effect.modifiers.defensiveBonus)}`);
  }
  if (Number(effect?.modifiers?.movementBonus)) {
    modifierParts.push(`Move ${formatSignedValue(effect.modifiers.movementBonus)} ft`);
  }

  const durationLabel =
    effect.roundsRemaining === null ? 'Combat-long' : `${Math.max(0, Number(effect.roundsRemaining) || 0)} rounds left`;

  const potencyLabel =
    effect.castRollTotal === null || effect.castRollTotal === undefined
      ? ''
      : `Magic ${Math.floor(Number(effect.castRollTotal) || 0)} -> EffLvl ${Math.max(
          0,
          Number(effect.effectiveLevel) || 0
        )}`;

  return [modifierParts.join(', '), durationLabel, potencyLabel, effect.notes].filter(Boolean).join(' | ');
};

const findShieldDefenseSpell = (defender) => {
  if (!Array.isArray(defender?.ownedItems)) {
    return null;
  }

  for (const item of defender.ownedItems) {
    const spells = Array.isArray(item?.spells) ? item.spells : [];
    for (const spell of spells) {
      if (
        spell?.idSpell &&
        String(spell?.idSpellList ?? '').trim().toLowerCase() === 'shield' &&
        isQuantityLimitedCombatSpell(spell) &&
        hasCombatSpellRemainingQuantity(spell)
      ) {
        return { item, spell };
      }
    }
  }

  return null;
};

const consumeShieldDefenseSpellLocally = (defender, spellId) => {
  if (!Array.isArray(defender?.ownedItems)) {
    return;
  }

  defender.ownedItems.forEach((item) => {
    if (!Array.isArray(item?.spells)) {
      return;
    }

    item.spells.forEach((spell) => {
      if (spell.idSpell === spellId) {
        spell.quantity = Math.max(0, (Number(spell.quantity) || 0) - 1);
      }
    });
  });
};

const callSpellUpdate = (spellPayload) =>
  new Promise((resolve, reject) => {
    cdoSpell.update(spellPayload, (err, response) => {
      if (err) {
        reject({ err, response });
        return;
      }

      resolve(response);
    });
  });

const callBeingUpdate = (beingPayload) =>
  new Promise((resolve, reject) => {
    cdoBeing.update(beingPayload, (err, response) => {
      if (err) {
        reject({ err, response });
        return;
      }

      resolve(response);
    });
  });

const callItemUpdate = (itemPayload) =>
  new Promise((resolve, reject) => {
    cdoItem.update(itemPayload, (err, response) => {
      if (err) {
        reject({ err, response });
        return;
      }

      resolve(response);
    });
  });

const persistCombatantHealth = async () => undefined;

const consumeCombatLockoutRound = async (being) => {
  if (!being) {
    return null;
  }

  const incapacitation = getCombatantIncapacitation(being);
  if (incapacitation) {
    return incapacitation;
  }

  if (Number(being.disabled) > 0) {
    being.disabled = Math.max(0, Number(being.disabled) - 1);
    await persistCombatantHealth(being);
    return {
      type: 'Disabled',
      description: 'Disabled this round and cannot take an action.',
    };
  }

  if (Number(being.stunned) > 0) {
    being.stunned = Math.max(0, Number(being.stunned) - 1);
    await persistCombatantHealth(being);
    return {
      type: 'Stunned',
      description: 'Stunned this round and cannot take an action.',
    };
  }

  if (Number(being.parryRounds) > 0) {
    being.parryRounds = Math.max(0, Number(being.parryRounds) - 1);
    await persistCombatantHealth(being);
    return {
      type: 'Parry',
      description: 'Must parry this round and cannot take another action.',
    };
  }

  return null;
};

const applyCritStateToCombatant = async (being, cumulative) => {
  if (!being || !cumulative) {
    return;
  }

  being.parryRounds = (Number(being.parryRounds) || 0) + (Number(cumulative.mustParryNextRound) || 0);
  being.stunned = (Number(being.stunned) || 0) + (Number(cumulative.stunnedRounds) || 0);
  being.disabled = (Number(being.disabled) || 0) + (Number(cumulative.unableRounds) || 0);
  being.bleeding = (Number(being.bleeding) || 0) + (Number(cumulative.bleedingHits) || 0);

  if (cumulative.fightsPenalty) {
    being.other = Math.max(Number(being.other) || 0, Number(cumulative.fightsPenalty) || 0);
    being.otherDesc = `Fights -${cumulative.fightsPenalty}`;
  }

  if (cumulative.instantDeath) {
    const maxHp = Math.max(0, Number(being.maxHp) || 0);
    being.currentHp = -maxHp;
  }

  await persistCombatantHealth(being);
};

const applyDamageToCombatant = async (being, damageAmount) => {
  const appliedDamage = Math.max(0, Number(damageAmount) || 0);
  const maxHp = Math.max(0, Number(being?.maxHp) || 0);
  const currentHp = Number.isFinite(Number(being?.currentHp))
    ? Number(being.currentHp)
    : maxHp;
  const nextCurrentHp = currentHp - appliedDamage;

  being.currentHp = nextCurrentHp;

  await persistCombatantHealth(being);

  return nextCurrentHp;
};

const resolveCombatSpellCast = async (caster, actionResult) => {
  const spellMatch = findCombatSpell(caster, actionResult?.associatedItem);
  const spell = spellMatch?.spell ?? null;
  const spellName = spell ? getCombatSpellName(spell) : String(actionResult?.associatedItem ?? '').trim();

  if (!spell) {
    return {
      spellMatch: null,
      spell: null,
      spellName,
      remainingQuantity: null,
      failureOutcome: {
        spellName,
        spellFailed: true,
        effectSummary: 'The named spell was not found on the caster.',
      },
    };
  }

  let remainingQuantity = Number(spell?.quantity);
  let remainingPowerPoints = null;

  if (isCastCombatSpell(spell)) {
    const powerPointSource = spellMatch?.sourceType === 'item' ? spellMatch?.item : caster;
    const currentPp = getCombatSpellCurrentPp(powerPointSource);
    const spellCost = getCombatSpellPowerPointCost(spell);

    if (currentPp < spellCost) {
      return {
        spellMatch,
        spell,
        spellName,
        remainingQuantity: Number.isFinite(remainingQuantity) ? remainingQuantity : null,
        remainingPowerPoints: currentPp,
        failureOutcome: {
          spellName,
          spellFailed: true,
          effectSummary: 'Not enough current power points to cast this spell in combat.',
          powerPointsRemaining: currentPp,
        },
      };
    }

    remainingPowerPoints = consumeCombatSpellPowerPointsLocally(caster, spellMatch);
    if (spellMatch?.sourceType === 'item' && spellMatch?.item) {
      await callItemUpdate(normalizeItemPayload(spellMatch.item));
    } else {
      await callBeingUpdate(normalizeBeingPayload(caster));
    }
    remainingQuantity = Number.isFinite(remainingQuantity) ? remainingQuantity : null;
  } else if (isQuantityLimitedCombatSpell(spell) && !hasCombatSpellRemainingQuantity(spell)) {
    return {
      spellMatch,
      spell,
      spellName,
      remainingQuantity: Number.isFinite(remainingQuantity) ? Math.max(0, remainingQuantity) : 0,
      remainingPowerPoints,
      failureOutcome: {
        spellName,
        spellFailed: true,
        effectSummary: 'No remaining spell quantity to cast it in combat.',
      },
    };
  }

  if (shouldConsumeCombatSpellCharge(spell)) {
    const updatedSpell = consumeCombatSpellLocally(caster, spellMatch);
    remainingQuantity = Number(updatedSpell?.quantity) || 0;
    await callSpellUpdate({
      ...spell,
      quantity: remainingQuantity,
    });
  } else {
    remainingQuantity = Number.isFinite(remainingQuantity) ? remainingQuantity : null;
  }

  return {
    spellMatch,
    spell,
    spellName,
    remainingQuantity,
    remainingPowerPoints,
    failureOutcome: null,
  };
};

const resolveCombatMagicActionOutcome = async (
  caster,
  defender,
  actionResult,
  defenderActionResult,
  actionRoll,
  combatState,
  actingKey,
  roundNumber,
  defenderKey = null
) => {
  const castResolution = await resolveCombatSpellCast(caster, actionResult);
  if (castResolution.failureOutcome) {
    return {
      combatState,
      outcome: castResolution.failureOutcome,
    };
  }

  const { spellMatch, spell, spellName, remainingQuantity, remainingPowerPoints } = castResolution;

  if (isLikelyOffensiveCombatSpell(spell)) {
    const attackOutcome = await resolveCombatActionOutcome(
      caster,
      defender,
      { ...actionResult, action: 'Magic' },
      defenderActionResult,
      actionRoll,
      combatState,
      defenderKey
    );

    return {
      combatState,
      outcome: {
        ...attackOutcome,
        spellCast: true,
        spellName,
        spellLevel: Number(spell?.level) || 0,
        spellUsage: spell?.idSpellUsage ?? '',
        spellSource:
          spellMatch?.sourceType === 'item'
            ? spellMatch?.item?.name || spellMatch?.item?.title || spellMatch?.item?.idEntity || 'item'
            : 'being',
        quantityRemaining: remainingQuantity,
        powerPointsRemaining: remainingPowerPoints,
        effectSummary: 'Resolved as an offensive spell attack.',
      },
    };
  }

  const effect = createCombatSpellEffect(spell, caster, actingKey, roundNumber, actionRoll?.total);
  if (!effect || (effect.roundsRemaining !== null && Number(effect.roundsRemaining) <= 0)) {
    return {
      combatState,
      outcome: {
        spellCast: true,
        spellName,
        spellLevel: Number(spell?.level) || 0,
        spellUsage: spell?.idSpellUsage ?? '',
        spellSource:
          spellMatch?.sourceType === 'item'
            ? spellMatch?.item?.name || spellMatch?.item?.title || spellMatch?.item?.idEntity || 'item'
            : 'being',
        spellFailed: true,
        effectSummary: `Magic ${Math.floor(Number(actionRoll?.total) || 0)} reduced the effect below 1 effective level.`,
        quantityRemaining: remainingQuantity,
        powerPointsRemaining: remainingPowerPoints,
      },
    };
  }
  const nextCombatState = applyCombatSpellEffectToState(combatState, effect);

  return {
    combatState: nextCombatState,
    outcome: {
      spellCast: true,
      spellName,
      spellLevel: Number(spell?.level) || 0,
      spellUsage: spell?.idSpellUsage ?? '',
      spellSource:
        spellMatch?.sourceType === 'item'
          ? spellMatch?.item?.name || spellMatch?.item?.title || spellMatch?.item?.idEntity || 'item'
          : 'being',
      spellFailed: false,
      effectSummary: summarizeCombatSpellEffect(effect),
      effect,
      quantityRemaining: remainingQuantity,
      powerPointsRemaining: remainingPowerPoints,
    },
  };
};

const resolveCombatActionOutcome = async (
  attacker,
  defender,
  actionResult,
  defenderActionResult,
  actionRoll,
  combatState,
  defenderKey = null
) => {
  const actionType = String(actionResult?.action ?? '').trim();
  const isCombatAttack = actionType === 'Combat' || actionType === 'Magic';

  if (!isCombatAttack) {
    return {
      defenderDb: 0,
      adjustedRoll: actionRoll.total,
      damageResult: null,
      critRoll: null,
      critResult: null,
    };
  }

  const distanceFeet = Math.max(0, Number(combatState?.distanceFeet) || 0);
  const isRangedAttack = actionType === 'Magic' ? true : isRangedActionItem(actionResult?.associatedItem);
  const requiresMeleeRange = !isRangedAttack;

  if (actionType === 'Combat' && !hasRequiredCombatAmmo(attacker, actionResult)) {
    return {
      defenderDb: 0,
      adjustedRoll: null,
      damageResult: null,
      shieldDefense: null,
      totalDamage: 0,
      critRoll: null,
      critResult: null,
      outOfAmmo: true,
    };
  }

  if (requiresMeleeRange && distanceFeet > 0) {
    return {
      defenderDb: 0,
      adjustedRoll: null,
      damageResult: null,
      shieldDefense: null,
      totalDamage: 0,
      critRoll: null,
      critResult: null,
      outOfRange: true,
      distanceFeet,
    };
  }

  const defenderDb = calculateCombatantDbForAction(defender, defenderActionResult, combatState, defenderKey);
  let adjustedRoll = actionRoll.total - defenderDb;
  let shieldDefense = null;
  const baseDamage = getCombatBaseDamage(attacker, actionResult);
  let damageResult = resolveCombatDamageTable(adjustedRoll, baseDamage);

  if (damageResult.critBonus !== null) {
    const shieldDefenseSpell = findShieldDefenseSpell(defender);
    if (shieldDefenseSpell) {
      const shieldReduction = 10;
      adjustedRoll -= shieldReduction;
      damageResult = resolveCombatDamageTable(adjustedRoll, baseDamage);
      shieldDefense = {
        itemName: shieldDefenseSpell.item?.name || shieldDefenseSpell.item?.title || 'Shield item',
        spellId: shieldDefenseSpell.spell.idSpell,
        reduction: shieldReduction,
        remainingQuantity: Math.max(0, (Number(shieldDefenseSpell.spell.quantity) || 0) - 1),
      };

      consumeShieldDefenseSpellLocally(defender, shieldDefenseSpell.spell.idSpell);
      await callSpellUpdate({
        ...shieldDefenseSpell.spell,
        quantity: shieldDefense.remainingQuantity,
      });
    }
  }

  if (damageResult.critBonus === null) {
    await applyDamageToCombatant(defender, damageResult.damage);

    return {
      defenderDb,
      adjustedRoll,
      damageResult,
      shieldDefense,
      totalDamage: damageResult.damage,
      critRoll: null,
      critResult: null,
    };
  }

  const critDieRoll = rollSingleDie100();
  const critTotal = critDieRoll + damageResult.critBonus;
  const critResult = resolveCritTable(critTotal);
  const totalDamage = (Number(damageResult.damage) || 0) + (Number(critResult.damage) || 0);
  await applyDamageToCombatant(defender, totalDamage);
  await applyCritStateToCombatant(defender, critResult.cumulative);

  return {
    defenderDb,
    adjustedRoll,
    damageResult,
    shieldDefense,
    totalDamage,
    critRoll: {
      dieRoll: critDieRoll,
      dieRolls: [critDieRoll],
      bonus: damageResult.critBonus,
      total: critTotal,
    },
    critResult,
  };
};

const calculateWeaponInitiativePenalty = (being, actionResult) => {
  const nextAssociatedItem = actionResult?.associatedItem ?? null;
  const nextCombatItem = getCombatWeaponKey(being, nextAssociatedItem);

  if (!isWeaponLikeCombatItem(nextAssociatedItem)) {
    return 0;
  }

  const currentCombatItem = normalizeCombatEntityId(being?.currentCombatItem);

  if (!currentCombatItem) {
    return -10;
  }

  if (currentCombatItem !== nextCombatItem) {
    return -20;
  }

  return 0;
};

const calculateInitiativeRoll = (being, actionResult, combatState = null, combatantKey = null) => {
  const dieRollResult = rollOpenEndedDie100();
  const agilityBonus = Number(being?.agility) || 0;
  const rapidBonus = getRapidInitiativeBonus(being, combatState, combatantKey);
  const weaponChangePenalty = calculateWeaponInitiativePenalty(being, actionResult);

  return {
    dieRoll: dieRollResult.total,
    dieRolls: dieRollResult.rolls,
    agilityBonus,
    rapidBonus,
    weaponChangePenalty,
    total: dieRollResult.total + agilityBonus + rapidBonus + weaponChangePenalty,
  };
};

const updateCombatantReadiedItem = (being, actionResult) => {
  if (!being) {
    return;
  }

  const nextAssociatedItem = actionResult?.associatedItem ?? null;
  const nextCombatItem = getCombatWeaponKey(being, nextAssociatedItem);

  if (!isWeaponLikeCombatItem(nextAssociatedItem)) {
    return;
  }

  being.currentCombatItem = nextCombatItem;

  if (Array.isArray(being.ownedItems)) {
    being.ownedItems = being.ownedItems.map((item) => ({
      ...item,
      combatHeld:
        normalizeCombatEntityId(item?.idEntity) === normalizeCombatEntityId(nextCombatItem),
    }));
  }
};

const getInitiativeGapTicks = (firstInitiative, secondInitiative) =>
  Math.abs((Number(firstInitiative?.total) || 0) - (Number(secondInitiative?.total) || 0));

const getPositiveInitiativeTicks = (initiativeResult) =>
  Math.max(0, Math.min(INITIATIVE_TICKS_PER_ACTION, Number(initiativeResult?.total) || 0));

const getInitiativeActionCount = (initiativeResult) =>
  Math.max(0, Math.ceil(Math.max(0, Number(initiativeResult?.total) || 0) / INITIATIVE_TICKS_PER_ACTION));

const scaleActionTotalByTicks = (actionRoll, ticks) =>
  ((Number(actionRoll?.total) || 0) * Math.max(0, Math.min(ticks, INITIATIVE_TICKS_PER_ACTION))) /
  INITIATIVE_TICKS_PER_ACTION;

const calculateTicksNeededToReachDistance = (actionRoll, distanceFeet) => {
  const totalMovementFeet = Math.max(0, Number(actionRoll?.total) || 0);
  const distance = Math.max(0, Number(distanceFeet) || 0);

  if (totalMovementFeet <= 0 || distance <= 0) {
    return 0;
  }

  return (distance * INITIATIVE_TICKS_PER_ACTION) / totalMovementFeet;
};

const applyMovementFeet = (actingKey, combatState, requestedFeet) => {
  const nextState = {
    distanceFeet: combatState.distanceFeet,
    firstCombatantPosition: { ...combatState.firstCombatantPosition },
    secondCombatantPosition: { ...combatState.secondCombatantPosition },
    itemLocations: { ...(combatState?.itemLocations ?? {}) },
    activeSpellEffects: Array.isArray(combatState?.activeSpellEffects)
      ? combatState.activeSpellEffects.map((effect) => cloneCombatSpellEffect(effect))
      : [],
    spellEffectHistory: Array.isArray(combatState?.spellEffectHistory)
      ? combatState.spellEffectHistory.map((effect) => cloneCombatSpellEffect(effect))
      : [],
    roundNumber: Number(combatState?.roundNumber) || 0,
  };
  const feetMoved = Math.min(Math.max(0, Number(requestedFeet) || 0), nextState.distanceFeet);

  if (actingKey === 'firstCombatant') {
    nextState.firstCombatantPosition.x += feetMoved;
  } else {
    nextState.secondCombatantPosition.x -= feetMoved;
  }

  nextState.distanceFeet = Math.max(
    0,
    Math.abs(nextState.secondCombatantPosition.x - nextState.firstCombatantPosition.x)
  );

  return {
    feetMoved,
    nextState,
  };
};

const resolvePhysicalMovement = (actingKey, combatState, actionRoll, ticksAvailable) => {
  return applyMovementFeet(
    actingKey,
    combatState,
    scaleActionTotalByTicks(actionRoll, ticksAvailable)
  );
};

const canEngageMeleeFromCurrentDistance = (actionResult, combatState) => {
  if (isRangedActionItem(actionResult?.associatedItem)) {
    return false;
  }

  const distanceFeet = Math.max(0, Number(combatState?.distanceFeet) || 0);
  return distanceFeet > 0 && Math.round(distanceFeet) <= MELEE_ENGAGE_FEET;
};

const engageIntoMelee = (actingKey, combatState) =>
  applyMovementFeet(actingKey, combatState, Number(combatState?.distanceFeet) || 0);

const CRIT_EFFECT_ROWS = [
  { max: 25, damage: 0, deltas: {} },
  { max: 30, damage: 1, deltas: {} },
  { max: 35, damage: 2, deltas: {} },
  { max: 40, damage: 3, deltas: { loseCurrentRoundActions: true } },
  { max: 45, damage: 4, deltas: {} },
  { max: 50, damage: 5, deltas: {} },
  { max: 55, damage: 6, deltas: { mustParryNextRound: 1 } },
  { max: 60, damage: 7, deltas: {} },
  { max: 65, damage: 8, deltas: {} },
  { max: 70, damage: 9, deltas: { stunnedRounds: 1 } },
  { max: 80, damage: 10, deltas: { stunnedRounds: 1 } },
  { max: 90, damage: 11, deltas: { unableRounds: 1 } },
  { max: 100, damage: 12, deltas: { unableRounds: 1 } },
  { max: 110, damage: 13, deltas: { stunnedRounds: 1, unableRounds: 1 } },
  { max: 120, damage: 14, deltas: { bleedingHits: 1 } },
  { max: 130, damage: 15, deltas: { stunnedRounds: 1, unableRounds: 1 } },
  { max: 135, damage: 20, deltas: { fightsPenalty: 10, bleedingHits: 1 } },
  { max: 140, damage: 30, deltas: { stunnedRounds: 1, unableRounds: 1 } },
  { max: 145, damage: 40, deltas: { fightsPenalty: 10, specialCritTableRoll: true } },
  { max: 149, damage: 50, deltas: { organDamage: true, bleedingHits: 5 } },
  { max: Infinity, damage: null, deltas: { instantDeath: true } },
];

const mergeCritDeltas = (totals, deltas = {}) => ({
  stunnedRounds: (totals.stunnedRounds || 0) + (deltas.stunnedRounds || 0),
  unableRounds: (totals.unableRounds || 0) + (deltas.unableRounds || 0),
  mustParryNextRound: (totals.mustParryNextRound || 0) + (deltas.mustParryNextRound || 0),
  bleedingHits: (totals.bleedingHits || 0) + (deltas.bleedingHits || 0),
  fightsPenalty: Math.max(totals.fightsPenalty || 0, deltas.fightsPenalty || 0),
  loseCurrentRoundActions: Boolean(totals.loseCurrentRoundActions || deltas.loseCurrentRoundActions),
  specialCritTableRoll: Boolean(totals.specialCritTableRoll || deltas.specialCritTableRoll),
  organDamage: Boolean(totals.organDamage || deltas.organDamage),
  instantDeath: Boolean(totals.instantDeath || deltas.instantDeath),
});

const formatCumulativeCritEffect = (totals = {}) => {
  if (totals.instantDeath) {
    return 'Instant death';
  }

  const effects = [];
  if (totals.loseCurrentRoundActions) {
    effects.push('Lose current round actions');
  }
  if (totals.mustParryNextRound) {
    effects.push(`${totals.mustParryNextRound} round parry next round`);
  }
  if (totals.stunnedRounds) {
    effects.push(`${totals.stunnedRounds} round${totals.stunnedRounds === 1 ? '' : 's'} stunned`);
  }
  if (totals.unableRounds) {
    effects.push(`${totals.unableRounds} round${totals.unableRounds === 1 ? '' : 's'} unable`);
  }
  if (totals.bleedingHits) {
    effects.push(`Bleeding ${totals.bleedingHits} hits`);
  }
  if (totals.fightsPenalty) {
    effects.push(`Fights -${totals.fightsPenalty}`);
  }
  if (totals.organDamage) {
    effects.push('Organ damage');
  }
  if (totals.specialCritTableRoll) {
    effects.push('Special crit table roll');
  }

  return effects.join(', ') || 'None';
};

const formatSignedValue = (value) => {
  const numericValue = Number(value) || 0;
  return numericValue >= 0 ? `+${numericValue}` : String(numericValue);
};

const formatCombatLogText = (value, fallback = '') => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (typeof value === 'object') {
    if (typeof value.description === 'string' && value.description.trim()) {
      return value.description;
    }

    if (typeof value.effect === 'string' && value.effect.trim()) {
      return value.effect;
    }

    try {
      return JSON.stringify(value);
    } catch {
      return fallback;
    }
  }

  return fallback;
};

const formatRollSequence = (rolls) =>
  Array.isArray(rolls) && rolls.length > 0
    ? rolls
        .map((roll) => {
          if (typeof roll === 'number') {
            return String(roll);
          }

          if (roll && typeof roll === 'object') {
            const value = Number(roll.value) || 0;
            const direction = Number(roll.direction) || 1;
            return direction < 0 ? `-${value}` : `${value}`;
          }

          return String(roll);
        })
        .join(', ')
    : '0';

const buildInitiativeLogLine = (initiative) => {
  if (!initiative) {
    return 'Init: n/a';
  }

  return `Init ${initiative.total} = ${initiative.dieRoll} (${formatRollSequence(initiative.dieRolls)}) ${formatSignedValue(
    initiative.agilityBonus
  )} Agi ${formatSignedValue(initiative.rapidBonus)} Rapid ${formatSignedValue(
    initiative.weaponChangePenalty
  )} Ready`;
};

const buildActionLogLine = (action) => {
  if (!action) {
    return 'Action: n/a';
  }

  return `Action ${action.total} = ${action.dieRoll} (${formatRollSequence(action.dieRolls)}) ${formatSignedValue(
    action.levelBonus
  )} Lvl ${formatSignedValue(action.itemBonus)} Item ${formatSignedValue(
    action.spellLevelBonus
  )} SpellLvl ${formatSignedValue(
    action.spellActionBonus
  )} Spell ${formatSignedValue(action.spellMovementBonus)} Move`;
};

const buildOutcomeLogLine = (outcome, skipped, skipReason) => {
  if (skipped) {
    return `Skipped: ${formatCombatLogText(skipReason, 'No action.')}`;
  }

  if (!outcome) {
    return 'No resolved outcome.';
  }

  if (outcome.outOfAmmo) {
    return 'Out of ammo.';
  }

  if (outcome.outOfRange) {
    return `Out of range at ${formatCombatFeet(outcome.distanceFeet)} ft.`;
  }

  if (outcome.spellCast && outcome.damageResult) {
    const parts = [
      `Spell ${formatCombatLogText(outcome.spellName, 'Unknown')}`,
      outcome.spellSource ? `Source ${formatCombatLogText(outcome.spellSource)}` : '',
      `DB ${outcome.defenderDb ?? 0}`,
      `Adj ${outcome.adjustedRoll ?? 0}`,
      `Dmg ${outcome.damageResult.damageLabel}`,
      `Total ${formatDamageValue(outcome.totalDamage ?? 0)}`,
    ];

    if (outcome.shieldDefense) {
      parts.push(`Shield -${outcome.shieldDefense.reduction}`);
    }

    if (outcome.critRoll && outcome.critResult) {
      parts.push(
        `Crit ${outcome.critRoll.total} = ${outcome.critRoll.dieRoll} (${formatRollSequence(
          outcome.critRoll.dieRolls
        )}) ${formatSignedValue(outcome.critRoll.bonus)} => ${formatDamageValue(
          outcome.critResult.damage
        )} ${formatCombatLogText(outcome.critResult.effect)}`
      );
    }

    if (outcome.quantityRemaining !== null && outcome.quantityRemaining !== undefined) {
      parts.push(`Qty ${outcome.quantityRemaining}`);
    }

    if (outcome.powerPointsRemaining !== null && outcome.powerPointsRemaining !== undefined) {
      parts.push(`PP ${outcome.powerPointsRemaining}`);
    }

    return parts.filter(Boolean).join(' | ');
  }

  if (outcome.spellCast || outcome.spellFailed) {
    const spellParts = [
      outcome.spellFailed ? 'Spell failed' : `Spell ${formatCombatLogText(outcome.spellName, 'Unknown')}`,
      outcome.spellSource ? `Source ${formatCombatLogText(outcome.spellSource)}` : '',
      outcome.effectSummary,
    ];

    if (outcome.quantityRemaining !== null && outcome.quantityRemaining !== undefined) {
      spellParts.push(`Qty ${outcome.quantityRemaining}`);
    }

    if (outcome.powerPointsRemaining !== null && outcome.powerPointsRemaining !== undefined) {
      spellParts.push(`PP ${outcome.powerPointsRemaining}`);
    }

    return spellParts.filter(Boolean).join(' | ');
  }

  if (!outcome.damageResult) {
    return `Adjusted ${outcome.adjustedRoll ?? 0}.`;
  }

  const parts = [
    `DB ${outcome.defenderDb ?? 0}`,
    `Adj ${outcome.adjustedRoll ?? 0}`,
    `Dmg ${outcome.damageResult.damageLabel}`,
    `Total ${formatDamageValue(outcome.totalDamage ?? 0)}`,
  ];

  if (outcome.shieldDefense) {
    parts.push(`Shield -${outcome.shieldDefense.reduction}`);
  }

  if (outcome.critRoll && outcome.critResult) {
    parts.push(
      `Crit ${outcome.critRoll.total} = ${outcome.critRoll.dieRoll} (${formatRollSequence(
        outcome.critRoll.dieRolls
      )}) ${formatSignedValue(outcome.critRoll.bonus)} => ${formatDamageValue(
        outcome.critResult.damage
      )} ${formatCombatLogText(outcome.critResult.effect)}`
    );
  }

  return parts.join(' | ');
};

const buildMovementLogLine = (movement) => {
  if (!movement) {
    return '';
  }

  const parts = [
    `Move ${formatCombatFeet(movement.feetMoved)} ft`,
    `Ticks ${formatCombatFeet(movement.ticksUsed)}`,
  ];

  if (movement.followUpActionAvailable) {
    parts.push('Follow-up available');
  }

  return parts.join(' | ');
};

const normalizeBeingPayload = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;

  return {
    entityName: source?.name ?? '',
    idEntity: source?.idEntity ?? '',
    entityTitle: source?.title ?? '',
    entityDesc: source?.description ?? '',
    entityType: normalizeNullableId(source?.entityType) ?? ENTITY_BEING,
    createDateAge: normalizeNullableId(source?.createDateAge),
    createDateYear: normalizeOptionalNumber(source?.createDateYear),
    createDateSeason: normalizeNullableId(source?.createDateSeason),
    createDateDay: normalizeOptionalNumber(source?.createDateDay),
    destroyDateAge: normalizeNullableId(source?.destroyDateAge),
    destroyDateYear: normalizeOptionalNumber(source?.destroyDateYear),
    destroyDateSeason: normalizeNullableId(source?.destroyDateSeason),
    destroyDateDay: normalizeOptionalNumber(source?.destroyDateDay),
    level: normalizeOptionalNumber(source?.level),
    beingType: normalizeNullableId(source?.beingType),
    strength: normalizeOptionalNumber(source?.strength),
    agility: normalizeOptionalNumber(source?.agility),
    constitution: normalizeOptionalNumber(source?.constitution),
    intellect: normalizeOptionalNumber(source?.intellect),
    wisdom: normalizeOptionalNumber(source?.wisdom),
    charisma: normalizeOptionalNumber(source?.charisma),
    alignment: normalizeNullableId(source?.alignment),
    gender: normalizeNullableId(source?.gender),
    heraldry: source?.heraldry ?? '',
    defaultForm: normalizeNullableId(source?.defaultForm),
    multipleForms: Array.isArray(source?.forms) ? source.forms.length > 1 : Boolean(source?.multipleForms),
    personality: source?.personality ?? '',
    objectivesShortTerm: source?.objectivesShortTerm ?? '',
    objectivesLongTerm: source?.objectivesLongTerm ?? '',
    maxHp: normalizeOptionalNumber(source?.maxHp),
    currentHp: normalizeOptionalNumber(source?.currentHp),
    maxPp: normalizeOptionalNumber(source?.maxPp),
    currentPp: normalizeOptionalNumber(source?.currentPp),
    maxStamina: normalizeOptionalNumber(source?.maxStamina),
    currentStamina: normalizeOptionalNumber(source?.currentStamina),
    hunger: normalizeOptionalNumber(source?.hunger) ?? 0,
    thirst: normalizeOptionalNumber(source?.thirst) ?? 0,
    intoxication: normalizeOptionalNumber(source?.intoxication) ?? 0,
    lastVitalsAdvancedMinute: normalizeOptionalNumber(source?.lastVitalsAdvancedMinute),
    bleeding: normalizeOptionalNumber(source?.bleeding) ?? 0,
    poisoned: normalizeOptionalNumber(source?.poisoned) ?? 0,
    other: normalizeOptionalNumber(source?.other) ?? 0,
    otherDesc: source?.otherDesc ?? '',
    stunned: normalizeOptionalNumber(source?.stunned) ?? 0,
    disabled: normalizeOptionalNumber(source?.disabled) ?? 0,
    forms: Array.isArray(source?.forms)
      ? source.forms.map((form) => ({
          idEntityForms: normalizeNullableId(form?.idEntityForms),
          formType: normalizeNullableId(form?.form),
          description: form?.description ?? '',
          gmNotes: form?.gmNotes ?? '',
        }))
      : [],
    spells: Array.isArray(source?.spells ?? source?.spell)
      ? (source.spells ?? source.spell).map((spell) => ({
          idSpell: normalizeNullableId(spell?.idSpell),
          idSpellList: normalizeNullableId(spell?.idSpellList),
          idSpellUsage: normalizeNullableId(spell?.idSpellUsage),
          quantity: normalizeOptionalNumber(spell?.quantity),
          level: normalizeRequiredNumber(spell?.level ?? 0),
          realm: normalizeRealmId(spell?.realm),
          acquiredVia: normalizeNullableId(spell?.acquiredVia),
          acquiredNotes: spell?.acquiredNotes ?? '',
        }))
      : [],
    currencies: Array.isArray(source?.currencies ?? source?.currency)
      ? (source.currencies ?? source.currency).map((currency) => ({
          idCurrency: normalizeNullableId(currency?.idCurrency),
          quantity: normalizeOptionalNumber(currency?.quantity) ?? 0,
        }))
      : [],
    routines: normalizeRoutinePayloadRows(source?.routines),
  };
};

const normalizeItemPayload = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;

  return {
    entityName: source?.name ?? '',
    idEntity: source?.idEntity ?? '',
    entityTitle: source?.title ?? '',
    entityDesc: source?.description ?? '',
    entityType: normalizeNullableId(source?.entityType) ?? ENTITY_ITEM,
    createDateAge: normalizeNullableId(source?.createDateAge),
    createDateYear: normalizeOptionalNumber(source?.createDateYear),
    createDateSeason: normalizeNullableId(source?.createDateSeason),
    createDateDay: normalizeOptionalNumber(source?.createDateDay),
    destroyDateAge: normalizeNullableId(source?.destroyDateAge),
    destroyDateYear: normalizeOptionalNumber(source?.destroyDateYear),
    destroyDateSeason: normalizeNullableId(source?.destroyDateSeason),
    destroyDateDay: normalizeOptionalNumber(source?.destroyDateDay),
    level: normalizeOptionalNumber(source?.level),
    itemType: normalizeNullableId(source?.itemType),
    qualityLevel: normalizeOptionalNumber(source?.qualityLevel),
    magicLevel: normalizeOptionalNumber(source?.magicLevel),
    weapon: normalizeNullableId(source?.weapon),
    heldWithBodyPart: normalizeNullableId(source?.heldWithBodyPart),
    carriedWithBodyPart: normalizeNullableId(source?.carriedWithBodyPart),
    length: normalizeOptionalNumber(source?.length),
    weight: normalizeOptionalNumber(source?.weight),
    height: normalizeOptionalNumber(source?.height),
    width: normalizeOptionalNumber(source?.width),
    value: normalizeOptionalNumber(source?.value),
    worn: normalizeNullableId(source?.worn),
    provisionMaterial: normalizeNullableId(source?.provisionMaterial),
    containedIn: normalizeNullableId(source?.containedIn),
    quantity: normalizeOptionalNumber(source?.quantity),
    preparedType: normalizeNullableId(source?.preparedType),
    container: normalizeNullableId(source?.container),
    capacity: normalizeOptionalNumber(source?.capacity),
    volume: normalizeOptionalNumber(source?.volume),
    general: normalizeNullableId(source?.general),
    materials: Array.isArray(source?.materials)
      ? source.materials
          .map((materialRow) => (typeof materialRow === 'object' ? materialRow?.name : materialRow))
          .filter(Boolean)
      : [],
    spells: Array.isArray(source?.spells ?? source?.spell)
      ? (source.spells ?? source.spell).map((spell) => ({
          idSpell: normalizeNullableId(spell?.idSpell),
          idSpellList: normalizeNullableId(spell?.idSpellList),
          idSpellUsage: normalizeNullableId(spell?.idSpellUsage),
          quantity: normalizeOptionalNumber(spell?.quantity),
          level: normalizeRequiredNumber(spell?.level ?? 0),
          realm: normalizeRealmId(spell?.realm),
          acquiredVia: normalizeNullableId(spell?.acquiredVia),
          acquiredNotes: spell?.acquiredNotes ?? '',
        }))
      : [],
  };
};

export const normalizePlacePayload = (value) => {
  const source = value?.response && typeof value.response === 'object' ? value.response : value;

  return {
    entityName: source?.name ?? '',
    publicLabel: source?.publicLabel,
    publicDescription: source?.publicDescription,
    signs: source?.signs,
    placePresentationLoaded: source?.placePresentationLoaded,
    idEntity: source?.idEntity ?? '',
    entityTitle: source?.title ?? '',
    entityDesc: source?.description ?? '',
    entityType: normalizeNullableId(source?.entityType) ?? ENTITY_PLACE,
    createDateAge: normalizeNullableId(source?.createDateAge),
    createDateYear: normalizeOptionalNumber(source?.createDateYear),
    createDateSeason: normalizeNullableId(source?.createDateSeason),
    createDateDay: normalizeOptionalNumber(source?.createDateDay),
    destroyDateAge: normalizeNullableId(source?.destroyDateAge),
    destroyDateYear: normalizeOptionalNumber(source?.destroyDateYear),
    destroyDateSeason: normalizeNullableId(source?.destroyDateSeason),
    destroyDateDay: normalizeOptionalNumber(source?.destroyDateDay),
    level: normalizeOptionalNumber(source?.level),
    placeType: normalizeNullableId(source?.placeType),
    zoneType: normalizeNullableId(source?.zoneType),
    buildingType: normalizeNullableId(source?.buildingType),
    transitPointType:
      String(source?.placeType ?? '').trim().toLowerCase() === 'transit point'
        ? normalizeNullableId(source?.transitPointType)
        : null,
    location: {
      x: normalizeRequiredNumber(source?.location?.x ?? source?.x ?? 0),
      y: normalizeRequiredNumber(source?.location?.y ?? source?.y ?? 0),
      z: normalizeRequiredNumber(source?.location?.z ?? source?.z ?? 0),
      maxRadius: normalizeOptionalNumber(source?.location?.maxRadius ?? source?.maxRadius),
    },
    shape: {
      idEntityShape: normalizeNullableId(source?.shape?.idEntityShape ?? source?.idEntityShape),
      shapeType: source?.shape?.shapeType ?? source?.shapeType ?? '',
      minX: normalizeOptionalNumber(source?.shape?.minX ?? source?.minX),
      maxX: normalizeOptionalNumber(source?.shape?.maxX ?? source?.maxX),
      minY: normalizeOptionalNumber(source?.shape?.minY ?? source?.minY),
      maxY: normalizeOptionalNumber(source?.shape?.maxY ?? source?.maxY),
      minZ: normalizeOptionalNumber(source?.shape?.minZ ?? source?.minZ),
      maxZ: normalizeOptionalNumber(source?.shape?.maxZ ?? source?.maxZ),
      shapeData: source?.shape?.shapeData ?? source?.shapeData ?? {},
    },
    // Omission preserves existing links; an explicit empty array removes them.
    biomes: Array.isArray(source?.biomes) ? source.biomes.map(link => ({ ...link })) : undefined,
    currencies: Array.isArray(source?.currencies ?? source?.currency)
      ? (source.currencies ?? source.currency).map((currency) => ({
          idCurrency: normalizeNullableId(currency?.idCurrency),
          quantity: normalizeOptionalNumber(currency?.quantity) ?? 0,
        }))
      : [],
    childPlaceSuggestions: Array.isArray(source?.childPlaceSuggestions)
      ? source.childPlaceSuggestions.map((suggestion) => ({
          name: suggestion?.name ?? '',
          placeType: normalizeNullableId(suggestion?.placeType),
          zoneType: normalizeNullableId(suggestion?.zoneType),
          buildingType: normalizeNullableId(suggestion?.buildingType),
          transitPointType:
            String(suggestion?.placeType ?? '').trim().toLowerCase() === 'transit point'
              ? normalizeNullableId(suggestion?.transitPointType)
              : null,
          description: suggestion?.description ?? '',
        }))
      : [],
  };
};

const formatErrorMessage = (err, response) => {
  const source = response?.error ?? response ?? err;

  if (typeof source === 'string') {
    return source;
  }

  if (typeof source === 'number') {
    return `Request failed with status ${source}.`;
  }

  if (!source || typeof source !== 'object') {
    return 'Request failed.';
  }

  const parts = [];
  if (source.stage) {
    parts.push(`Stage: ${source.stage}`);
  }
  if (source.code) {
    parts.push(`Code: ${source.code}`);
  }
  if (source.message) {
    parts.push(source.message);
  } else if (source.sqlMessage) {
    parts.push(source.sqlMessage);
  } else if (source.error && typeof source.error === 'string') {
    parts.push(source.error);
  }

  if (parts.length > 0) {
    return parts.join(' | ');
  }

  try {
    const serialized = JSON.stringify(source);
    if (serialized && serialized !== '{}') {
      return serialized;
    }
  } catch {
    // Fall through to status-based fallback below.
  }

  if (typeof err === 'number') {
    return `Request failed with status ${err}.`;
  }

  return 'Request failed.';
};

const validateBeingForSave = (payload) => {
  if (!payload.entityName || !payload.entityTitle || !payload.beingType) {
    return 'Save requires a valid being result with name, title, and beingType.';
  }

  if (payload.level !== null && payload.level !== undefined) {
    const level = Number(payload.level);
    if (Number.isNaN(level) || level < 0 || level > 255) {
      return 'Level must be between 0 and 255.';
    }
  }

  const invalidCurrency = (Array.isArray(payload.currencies) ? payload.currencies : [])
    .some((currency) => !currency.idCurrency || !Number.isFinite(Number(currency.quantity)));

  if (invalidCurrency) {
    return 'Currency rows require a currency and numeric quantity.';
  }

  const invalidRoutine = (Array.isArray(payload.routines) ? payload.routines : []).some((routine) => {
    const startMinute = Number(routine.startMinute);
    const endMinute = Number(routine.endMinute);

    return (
      !routine.idPlace ||
      !Number.isFinite(startMinute) ||
      !Number.isFinite(endMinute) ||
      startMinute < 0 ||
      endMinute > 1440 ||
      startMinute >= endMinute
    );
  });

  if (invalidRoutine) {
    return 'Routine rows require a place and a valid start/end minute range.';
  }

  const invalidRoutineStep = (Array.isArray(payload.routines) ? payload.routines : []).some((routine) =>
    (Array.isArray(routine.routineJson?.steps) ? routine.routineJson.steps : []).some((step) => {
      const startMinute = Number(step.startMinute);
      const endMinute = Number(step.endMinute);
      const checkInEveryMinutes = Number(step.checkInEveryMinutes);
      const invalidTarget =
        step.targetXYZ &&
        ![step.targetXYZ.x, step.targetXYZ.y, step.targetXYZ.z].every((value) => Number.isFinite(Number(value)));

      return (
        !String(step.action ?? '').trim() ||
        !Number.isFinite(startMinute) ||
        !Number.isFinite(endMinute) ||
        startMinute < 0 ||
        endMinute > 1440 ||
        startMinute >= endMinute ||
        !Number.isFinite(checkInEveryMinutes) ||
        checkInEveryMinutes < 1 ||
        invalidTarget
      );
    })
  );

  if (invalidRoutineStep) {
    return 'Routine steps require action text, valid minute ranges, and a positive check-in interval.';
  }

  return '';
};

const validateItemForSave = (payload) => {
  if (!payload.entityTitle || !payload.itemType) {
    return 'Save requires at least title and itemType.';
  }

  if (String(payload.itemType ?? '').trim().toLowerCase() === 'container' && !payload.container) {
    return 'Container items require a Container selection.';
  }

  const dimensions = [payload.length, payload.width, payload.height, payload.weight];
  if (dimensions.some((value) => !Number.isFinite(Number(value)) || Number(value) <= 0)) {
    return 'Length, width, height, and weight must be positive numbers.';
  }

  if (!Number.isFinite(Number(payload.value)) || Number(payload.value) < 0) {
    return 'Value must be a non-negative number.';
  }

  return '';
};

const validatePlaceForSave = (payload) => {
  if (!payload.entityTitle || !payload.placeType) {
    return 'Save requires at least title and placeType.';
  }

  if (!payload.shape?.shapeType) {
    return 'Shape type is required.';
  }

  const coordinates = [payload.location?.x, payload.location?.y, payload.location?.z];
  if (coordinates.some((value) => Number.isNaN(Number(value)))) {
    return 'Location x, y, and z must be numeric.';
  }

  const invalidCurrency = (Array.isArray(payload.currencies) ? payload.currencies : [])
    .some((currency) => !currency.idCurrency || !Number.isFinite(Number(currency.quantity)));

  if (invalidCurrency) {
    return 'Currency rows require a currency and numeric quantity.';
  }

  return '';
};

const normalizeEntityList = (rows, fallbackLabel) =>
  (Array.isArray(rows) ? rows : [])
    .filter((row) => row?.idEntity)
    .map((row) => ({
      idEntity: row.idEntity,
      name: row.entityName || row.entityTitle || row.name || fallbackLabel,
      title: row.entityTitle || row.title || '',
      itemType: row.itemType || '',
      beingType: row.beingType || '',
      description: row.entityDesc || row.description || '',
    }))
    .sort((left, right) => left.name.localeCompare(right.name));

const normalizePlaceList = (rows) =>
  (Array.isArray(rows) ? rows : [])
    .filter((row) => row?.idEntity)
    .map((row) => ({
      idEntity: row.idEntity,
      name: row.entityName || row.entityTitle || row.name || '(Unnamed Place)',
      title: row.entityTitle || row.title || '',
      placeType: row.placeType || '',
      description: row.entityDesc || row.description || '',
      zoneType: row.zoneType || '',
      buildingType: row.buildingType || '',
      composedOfParentIds: Array.isArray(row.composedOfParentIds) ? row.composedOfParentIds : [],
      composedOfChildIds: Array.isArray(row.composedOfChildIds) ? row.composedOfChildIds : [],
    }))
    .sort((left, right) => left.name.localeCompare(right.name));

const mergeNamedOptions = (...collections) => {
  const values = collections
    .flatMap((collection) => (Array.isArray(collection) ? collection : []))
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .filter(Boolean);

  return [...new Set(values)].sort((left, right) => left.localeCompare(right)).map((value) => ({
    value,
    label: value,
  }));
};

function App() {
  const [activeTab, setActiveTab] = useState('Generate New');
  const [editExistingTab, setEditExistingTab] = useState('Being');
  const [testTab, setTestTab] = useState('Combat');
  const [referenceTable, setReferenceTable] = useState('MasterType');
  const [aogYear, setAogYear] = useState('21000');
  const [prompt, setPrompt] = useState('');
  const [generatorType, setGeneratorType] = useState('Being');
  const [limitExistingBeingContextToGods, setLimitExistingBeingContextToGods] = useState(true);
  const [masterTypes, setMasterTypes] = useState([]);
  const [spellLists, setSpellLists] = useState([]);
  const [spellUsages, setSpellUsages] = useState([]);
  const [currencyLists, setCurrencyLists] = useState([]);
  const [itemMetadata, setItemMetadata] = useState({
    weapons: [],
    worn: [],
    materials: [],
    provisionMaterials: [],
    containers: [],
    general: [],
  });
  const [generatedBeing, setGeneratedBeing] = useState(null);
  const [generatedItem, setGeneratedItem] = useState(null);
  const [generatedPlace, setGeneratedPlace] = useState(null);
  const [generatedImage, setGeneratedImage] = useState(null);
  const [generatedBeingPortrait, setGeneratedBeingPortrait] = useState(() => createEmptyBeingPortraitState());
  const [generatedPlaceImage, setGeneratedPlaceImage] = useState(() => createEmptyPlaceImageState());
  const [existingBeing, setExistingBeing] = useState(() => createEmptyBeing());
  const [existingBeingPortrait, setExistingBeingPortrait] = useState(() => createEmptyBeingPortraitState());
  const [existingItem, setExistingItem] = useState(() => createEmptyItem());
  const [existingPlace, setExistingPlace] = useState(() => createEmptyPlace());
  const [existingPlaceImage, setExistingPlaceImage] = useState(() => createEmptyPlaceImageState());
  const generatedBeingPortraitLoadRef = useRef(0);
  const existingBeingPortraitLoadRef = useRef(0);
  const existingPlaceImageLoadRef = useRef(0);
  const overviewGeometrySaverRef = useRef(null);
  if (!overviewGeometrySaverRef.current) {
    overviewGeometrySaverRef.current = createOverviewGeometrySaver({
      select: cdoPlace.select,
      update: cdoPlace.update,
      toEditable: toEditablePlace,
      normalize: normalizePlacePayload,
      validate: validatePlaceForSave,
    });
  }
  const [existingBeings, setExistingBeings] = useState([]);
  const [existingItems, setExistingItems] = useState([]);
  const [existingPlaces, setExistingPlaces] = useState([]);
  const [mythosChapters, setMythosChapters] = useState([]);
  const [referenceRecords, setReferenceRecords] = useState([]);
  const [referenceEditorValue, setReferenceEditorValue] = useState(null);
  const [selectedExistingBeingId, setSelectedExistingBeingId] = useState('');
  const [selectedExistingItemId, setSelectedExistingItemId] = useState('');
  const [selectedExistingPlaceId, setSelectedExistingPlaceId] = useState('');
  const [selectedGeneratedPlaceParentId, setSelectedGeneratedPlaceParentId] = useState('');
  const [selectedReferenceId, setSelectedReferenceId] = useState('');
  const [selectedMythosChapterNumber, setSelectedMythosChapterNumber] = useState('');
  const [selectedCombatantOneId, setSelectedCombatantOneId] = useState('');
  const [selectedCombatantTwoId, setSelectedCombatantTwoId] = useState('');
  const [combatantOneDetail, setCombatantOneDetail] = useState(null);
  const [combatantTwoDetail, setCombatantTwoDetail] = useState(null);
  const [combatRefreshToken, setCombatRefreshToken] = useState(0);
  const [combatAction, setCombatAction] = useState('');
  const [combatActionResult, setCombatActionResult] = useState(null);
  const [combatResponseActionResult, setCombatResponseActionResult] = useState(null);
  const [combatRollResults, setCombatRollResults] = useState(null);
  const [combatPendingActionDescription, setCombatPendingActionDescription] = useState('');
  const [combatState, setCombatState] = useState(() => createInitialCombatState());
  const [, setCombatNarration] = useState(null);
  const [combatHistoryEntries, setCombatHistoryEntries] = useState([]);
  const previousCombatantPairRef = useRef('');
  const combatHistoryEndRef = useRef(null);
  const [isGeneratingCombatNarration, setIsGeneratingCombatNarration] = useState(false);
  const [isSubmittingCombatAction, setIsSubmittingCombatAction] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGeneratedSaving, setIsGeneratedSaving] = useState(false);
  const [isGeneratedPlaceDescriptionLoading, setIsGeneratedPlaceDescriptionLoading] = useState(false);
  const [isGeneratedPlaceSuggestionLoading, setIsGeneratedPlaceSuggestionLoading] = useState(false);
  const [isGeneratedPlaceInhabitantSuggestionLoading, setIsGeneratedPlaceInhabitantSuggestionLoading] = useState(false);
  const [isGeneratedPlaceInhabitantRelationshipLoading, setIsGeneratedPlaceInhabitantRelationshipLoading] = useState(false);
  const [isGeneratedPlaceItemSuggestionLoading, setIsGeneratedPlaceItemSuggestionLoading] = useState(false);
  const [isGeneratedPlaceItemBulkCreating, setIsGeneratedPlaceItemBulkCreating] = useState(false);
  const [isGeneratedBeingItemSuggestionLoading, setIsGeneratedBeingItemSuggestionLoading] = useState(false);
  const [isGeneratedBeingItemBulkCreating, setIsGeneratedBeingItemBulkCreating] = useState(false);
  const [isGeneratedBeingRoutineGenerating, setIsGeneratedBeingRoutineGenerating] = useState(false);
  const [isExistingBeingSaving, setIsExistingBeingSaving] = useState(false);
  const [isExistingItemSaving, setIsExistingItemSaving] = useState(false);
  const [isExistingPlaceSaving, setIsExistingPlaceSaving] = useState(false);
  const [isExistingPlaceDescriptionLoading, setIsExistingPlaceDescriptionLoading] = useState(false);
  const [isExistingBeingItemSuggestionLoading, setIsExistingBeingItemSuggestionLoading] = useState(false);
  const [isExistingBeingItemBulkCreating, setIsExistingBeingItemBulkCreating] = useState(false);
  const [isExistingBeingRoutineGenerating, setIsExistingBeingRoutineGenerating] = useState(false);
  const [isExistingPlaceSuggestionLoading, setIsExistingPlaceSuggestionLoading] = useState(false);
  const [isExistingPlaceInhabitantSuggestionLoading, setIsExistingPlaceInhabitantSuggestionLoading] = useState(false);
  const [isExistingPlaceInhabitantRelationshipLoading, setIsExistingPlaceInhabitantRelationshipLoading] = useState(false);
  const [isExistingPlaceItemSuggestionLoading, setIsExistingPlaceItemSuggestionLoading] = useState(false);
  const [isExistingPlaceItemBulkCreating, setIsExistingPlaceItemBulkCreating] = useState(false);
  const [isGeneratedItemOwnerSaving, setIsGeneratedItemOwnerSaving] = useState(false);
  const [isExistingItemOwnerSaving, setIsExistingItemOwnerSaving] = useState(false);
  const [isLoadingExistingBeingList, setIsLoadingExistingBeingList] = useState(false);
  const [isLoadingExistingItemList, setIsLoadingExistingItemList] = useState(false);
  const [isLoadingExistingPlaceList, setIsLoadingExistingPlaceList] = useState(false);
  const [isLoadingReferenceList, setIsLoadingReferenceList] = useState(false);
  const [isLoadingMythos, setIsLoadingMythos] = useState(false);
  const [isLoadingExistingBeing, setIsLoadingExistingBeing] = useState(false);
  const [isLoadingExistingItem, setIsLoadingExistingItem] = useState(false);
  const [isLoadingExistingPlace, setIsLoadingExistingPlace] = useState(false);
  const [formError, setFormError] = useState('');

  const [generatedSaveMessage, setGeneratedSaveMessage] = useState('');
  const [existingBeingSaveMessage, setExistingBeingSaveMessage] = useState('');
  const [existingItemSaveMessage, setExistingItemSaveMessage] = useState('');
  const [existingPlaceSaveMessage, setExistingPlaceSaveMessage] = useState('');
  const [referenceSaveMessage, setReferenceSaveMessage] = useState('');
  const [mythosError, setMythosError] = useState('');
  const [isReferenceSaving, setIsReferenceSaving] = useState(false);
  const [isBeingJsonModalOpen, setIsBeingJsonModalOpen] = useState(false);
  const [beingJsonDraft, setBeingJsonDraft] = useState('');
  const [beingJsonError, setBeingJsonError] = useState('');
  const [beingJsonTarget, setBeingJsonTarget] = useState('generated');
  const [isRelationshipModalOpen, setIsRelationshipModalOpen] = useState(false);
  const [relationshipSuggestions, setRelationshipSuggestions] = useState([]);
  const [relationshipModalTitle, setRelationshipModalTitle] = useState('Inhabitant Relationships');
  const [relationshipModalCopy, setRelationshipModalCopy] = useState('Review suggested entity relationships between saved inhabitants.');
  const [relationshipModalMessage, setRelationshipModalMessage] = useState('');
  const [isCreatingRelationshipSuggestions, setIsCreatingRelationshipSuggestions] = useState(false);
  const [isTokenUsageLogOpen, setIsTokenUsageLogOpen] = useState(false);
  const [isTokenUsageLogLoading, setIsTokenUsageLogLoading] = useState(false);
  const [tokenUsageLog, setTokenUsageLog] = useState([]);
  const [tokenUsageLogError, setTokenUsageLogError] = useState('');
  const [tokenUsageCopyMessage, setTokenUsageCopyMessage] = useState('');

  const editExistingTabConfig = [
    { label: 'Being', icon: <BeingTabIcon /> },
    { label: 'Template', icon: <BeingTabIcon /> },
    { label: 'Item', icon: <ItemTabIcon /> },
    { label: 'Place', icon: <PlaceTabIcon /> },
    { label: 'Event', icon: <EventTabIcon /> },
  ];

  const appTabConfig = [
    { label: 'Generate New', icon: <SparklesIcon /> },
    { label: 'Edit Existing', icon: <PencilIcon /> },
    { label: 'Mythos', icon: <MythosTabIcon /> },
    { label: 'Reference', icon: <ReferenceTabIcon /> },
    { label: 'Test', icon: <FlaskTabIcon /> },
  ];

  const testTabConfig = [{ label: 'Combat' }, { label: 'Explore' }, { label: 'Play' }];

  const generatorTabConfig = [
    { label: 'Being', icon: <BeingTabIcon /> },
    { label: 'Item', icon: <ItemTabIcon /> },
    { label: 'Place', icon: <PlaceTabIcon /> },
    { label: 'Place Tree', icon: <PlaceTabIcon /> },
    { label: 'Image', icon: <SparklesIcon /> },
    { label: 'Event', icon: <EventTabIcon /> },
  ];

  const loadBeingPortrait = useCallback((idEntity, setPortrait, suppressErrors = false, requestRef = null) => {
    const requestId = requestRef ? ++requestRef.current : 0;
    if (!idEntity) {
      setPortrait(createEmptyBeingPortraitState());
      return;
    }

    setPortrait({ ...createEmptyBeingPortraitState(), isLoadingSavedImage: true });
    cdoBeing.selectPortraitImage(idEntity, (err, response) => {
      if (requestRef && requestId !== requestRef.current) {
        return;
      }
      if (err || response?.error) {
        setPortrait({
          ...createEmptyBeingPortraitState(),
          isLoadingSavedImage: false,
          error: suppressErrors ? '' : formatErrorMessage(err, response),
        });
        return;
      }

      setPortrait(
        mediaSource(response)
          ? {
              src: mediaSource(response),
              revisedPrompt: response.revisedPrompt || '',
              isGenerating: false,
              isSaving: false,
              isSaved: true,
              isLoadingSavedImage: false,
              hasCheckedSavedImage: true,
              error: '',
            }
          : { ...createEmptyBeingPortraitState(), hasCheckedSavedImage: true }
      );
    });
  }, []);

  const loadPlaceImage = useCallback((idEntity, setImage, suppressErrors = false, requestRef = null) => {
    const requestId = requestRef ? ++requestRef.current : 0;
    if (!idEntity) {
      setImage(createEmptyPlaceImageState());
      return;
    }

    setImage({ ...createEmptyPlaceImageState(), isLoadingSavedImage: true });
    cdoPlace.selectApproachImage(idEntity, (err, response) => {
      if (requestRef && requestId !== requestRef.current) {
        return;
      }
      if (err || response?.error) {
        setImage({
          ...createEmptyPlaceImageState(),
          isLoadingSavedImage: false,
          error: suppressErrors ? '' : formatErrorMessage(err, response),
        });
        return;
      }

      setImage(
        mediaSource(response)
          ? {
              src: mediaSource(response),
              revisedPrompt: response.revisedPrompt || '',
              isGenerating: false,
              isSaving: false,
              isSaved: true,
              isLoadingSavedImage: false,
              hasCheckedSavedImage: true,
              error: '',
            }
          : { ...createEmptyPlaceImageState(), hasCheckedSavedImage: true }
      );
    });
  }, []);

  const generatePlaceImage = useCallback((payload, setImage, setSaveMessage, options = {}) => {
    const place = payload?.place;
    if (!place?.idEntity) {
      setSaveMessage('Save the place before generating an image.');
      return;
    }

    if (!payload?.overviewSnapshotImageBase64) {
      setSaveMessage('Top-down overview snapshot is required before generating an image.');
      return;
    }

    setImage((current) => ({
      ...current,
      isGenerating: true,
      isSaved: false,
      error: '',
    }));
    setSaveMessage('Generating place image...');

    cdoAI.generatePlaceApproachImage(
      {
        aogYear: Number(aogYear) || 0,
        size: '1536x1024',
        place,
        visibleOverviewPlaces: payload.visibleOverviewPlaces ?? [],
        overviewFrame: payload.overviewFrame,
        overviewSnapshotMediaType: payload.overviewSnapshotMediaType || 'image/png',
        overviewSnapshotImageBase64: payload.overviewSnapshotImageBase64,
      },
      (err, response) => {
        if (err || response?.error) {
          setImage((current) => ({
            ...current,
            isGenerating: false,
            error: formatErrorMessage(err, response),
          }));
          setSaveMessage('');
          return;
        }

        const generatedImage = {
          src: response?.imageBase64 ? `data:${response?.mimeType || 'image/png'};base64,${response.imageBase64}` : '',
          revisedPrompt: response?.revisedPrompt || '',
          isGenerating: false,
          isSaving: false,
          isSaved: false,
          isLoadingSavedImage: false,
          hasCheckedSavedImage: true,
          error: response?.imageBase64 ? '' : 'Image generation returned no image data.',
        };
        setImage(generatedImage);
        setSaveMessage(response?.imageBase64 ? 'Generated place image.' : '');
        if (response?.imageBase64 && typeof options.onGenerated === 'function') {
          options.onGenerated(generatedImage);
        }
      }
    );
  }, [aogYear]);

  const savePlaceImage = useCallback((place, image, setImage, setSaveMessage) => {
    if (!place?.idEntity || !image?.src) {
      return;
    }

    const base64Marker = ';base64,';
    const markerIndex = image.src.indexOf(base64Marker);
    if (markerIndex < 0) {
      setImage((current) => ({
        ...current,
        error: 'Generated image data is not in a savable format.',
      }));
      return;
    }

    const mediaType = image.src.slice(5, markerIndex) || 'image/png';
    const imageBase64 = image.src.slice(markerIndex + base64Marker.length);

    setImage((current) => ({
      ...current,
      isSaving: true,
      error: '',
    }));
    setSaveMessage('Saving place image...');

    cdoPlace.saveApproachImage(
      {
        idEntity: place.idEntity,
        name: place.name,
        title: place.title || place.name,
        mediaType,
        imageBase64,
        revisedPrompt: image.revisedPrompt || '',
      },
      (err, response) => {
        if (err || response?.error) {
          setImage((current) => ({
            ...current,
            isSaving: false,
            error: formatErrorMessage(err, response),
          }));
          setSaveMessage('');
          return;
        }

        setImage((current) => ({
          ...current,
          isSaving: false,
          isSaved: true,
          error: '',
        }));
        setSaveMessage('Saved place image.');
      }
    );
  }, []);

  const buildBeingPortraitPrompt = useCallback((being) => {
    const statSummary = ['strength', 'agility', 'constitution', 'intellect', 'wisdom', 'charisma']
      .map((field) => `${field}: ${being?.[field] ?? ''}`)
      .join(', ');
    const formSummary = Array.isArray(being?.forms) && being.forms.length
      ? being.forms.map((form) => `${form.form || 'Unnamed form'}: ${form.description || 'No description'}`).join('\n')
      : 'No alternate forms.';
    const spellSummary = Array.isArray(being?.spells) && being.spells.length
      ? being.spells
          .map((spell) => `${spell.idSpellList || spell.name || 'Spell'}${spell.level ? ` level ${spell.level}` : ''}`)
          .join(', ')
      : 'None listed.';

    return `Create a square 1:1 portrait image of this Adenrel being.

Name: ${being?.name || 'Unnamed'}
Title: ${being?.title || 'None'}
Entity type: ${being?.entityType || 'Being'}
Level: ${being?.level || 'Unspecified'}
Being type: ${being?.beingType || 'Unspecified'}
Default form: ${being?.defaultForm || being?.beingType || 'Unspecified'}
Alignment: ${being?.alignment || 'Unspecified'}
Heraldry: ${being?.heraldry || 'None'}
Description: ${being?.description || 'No description provided.'}
Personality: ${being?.personality || 'Unspecified'}
Short-term objective: ${being?.objectivesShortTerm || 'Unspecified'}
Long-term objective: ${being?.objectivesLongTerm || 'Unspecified'}
Stats: ${statSummary}
Forms:
${formSummary}
Spells: ${spellSummary}

${buildPortraitAppearanceGuidance(being)}

Visual requirements:
- Preserve the supplied description's concrete features; use the appearance direction for attractiveness.
- Compose for a square 1:1 portrait.
- Show the being clearly as the main subject.
- Use heraldry as optional visual inspiration for colors, symbols, clothing, jewelry, armor, or background motifs.
- Do not include text, captions, UI, logos, watermarks, or labels.`;
  }, []);

  const generateBeingPortrait = useCallback((being, setPortrait, setSaveMessage, options = {}) => {
    if (!being?.idEntity) {
      setSaveMessage('Save the being before generating an image.');
      return;
    }

    setPortrait((current) => ({
      ...current,
      isGenerating: true,
      isSaved: false,
      error: '',
    }));
    setSaveMessage('Generating being image...');

    cdoAI.generateImage(
      {
        aogYear: Number(aogYear) || 0,
        size: '1024x1024',
        prompt: buildBeingPortraitPrompt(being),
        beingId: being.idEntity,
      },
      (err, response) => {
        if (err || response?.error) {
          setPortrait((current) => ({
            ...current,
            isGenerating: false,
            error: formatErrorMessage(err, response),
          }));
          setSaveMessage('');
          return;
        }

        const generatedPortrait = {
          src: response?.imageBase64 ? `data:${response?.mimeType || 'image/png'};base64,${response.imageBase64}` : '',
          revisedPrompt: response?.revisedPrompt || '',
          isGenerating: false,
          isSaving: false,
          isSaved: false,
          isLoadingSavedImage: false,
          hasCheckedSavedImage: true,
          error: response?.imageBase64 ? '' : 'Image generation returned no image data.',
        };
        setPortrait(generatedPortrait);
        setSaveMessage(response?.imageBase64 ? 'Generated being image.' : '');
        if (response?.imageBase64 && typeof options.onGenerated === 'function') {
          options.onGenerated(generatedPortrait);
        }
      }
    );
  }, [aogYear, buildBeingPortraitPrompt]);

  const saveBeingPortrait = useCallback((being, portrait, setPortrait, setSaveMessage) => {
    if (!being?.idEntity || !portrait?.src) {
      return;
    }

    const base64Marker = ';base64,';
    const markerIndex = portrait.src.indexOf(base64Marker);
    if (markerIndex < 0) {
      setPortrait((current) => ({
        ...current,
        error: 'Generated image data is not in a savable format.',
      }));
      return;
    }

    const mediaType = portrait.src.slice(5, markerIndex) || 'image/png';
    const imageBase64 = portrait.src.slice(markerIndex + base64Marker.length);

    setPortrait((current) => ({
      ...current,
      isSaving: true,
      error: '',
    }));
    setSaveMessage('Saving being image...');

    cdoBeing.savePortraitImage(
      {
        idEntity: being.idEntity,
        name: being.name,
        title: being.title || being.name,
        mediaType,
        imageBase64,
        revisedPrompt: portrait.revisedPrompt || '',
      },
      (err, response) => {
        if (err || response?.error) {
          setPortrait((current) => ({
            ...current,
            isSaving: false,
            error: formatErrorMessage(err, response),
          }));
          setSaveMessage('');
          return;
        }

        setPortrait((current) => ({
          ...current,
          isSaving: false,
          isSaved: true,
          error: '',
        }));
        setSaveMessage('Saved being image.');
      }
    );
  }, []);

  const referenceTableOptions = [
    { value: 'AbilityList', label: 'Ability List' },
    { value: 'Biome', label: 'Biome' },
    { value: 'ContainerList', label: 'ContainerList' },
    { value: 'CurrencyList', label: 'CurrencyList' },
    { value: 'EventList', label: 'EventList' },
    { value: 'GeneralList', label: 'GeneralList' },
    { value: 'MasterType', label: 'MasterType' },
    { value: 'MaterialList', label: 'MaterialList' },
    { value: 'ProvisionList', label: 'ProvisionList' },
    { value: 'SpellList', label: 'SpellList' },
    { value: 'SpellUsage', label: 'SpellUsage' },
    { value: 'WeaponList', label: 'WeaponList' },
    { value: 'WornList', label: 'WornList' },
  ];

  const getMasterTypeRangeOptions = useCallback(
    (minId, maxId) =>
      masterTypes
        .filter((masterType) => {
          const id = Number(masterType.idMasterType);
          return Number.isFinite(id) && id >= minId && id <= maxId;
        })
        .map((masterType) => ({
          value: Number(masterType.idMasterType),
          label: masterType.value,
        }))
        .sort((left, right) => left.label.localeCompare(right.label)),
    [masterTypes]
  );

  const referenceConfigs = useMemo(
    () => ({
      ...templateReferenceConfigs,
      MasterType: {
      title: 'Master Type Editor',
      copy: 'Select a master type to edit it, or add a new row.',
      listTitle: 'Master Types',
      idField: 'idMasterType',
      emptyFactory: createEmptyMasterType,
      selectAll: cdoMasterType.selectAll,
      create: cdoMasterType.create,
      update: cdoMasterType.update,
      fields: [
        { key: 'idMasterType', label: 'ID', type: 'number' },
        { key: 'table', label: 'Table', type: 'text' },
        { key: 'column', label: 'Column', type: 'text' },
        { key: 'value', label: 'Value', type: 'text' },
        { key: 'code', label: 'Code', type: 'text' },
      ],
      normalize: (value) => ({
        idMasterType:
          value.idMasterType === '' || value.idMasterType === null || value.idMasterType === undefined
            ? ''
            : Number(value.idMasterType),
        table: value.table ?? '',
        column: value.column ?? '',
        value: value.value ?? '',
        code: value.code ?? '',
      }),
      validate: (value) => {
        if (!value.table || !value.column || !value.value) {
          return 'MasterType requires table, column, and value.';
        }

        return '';
      },
      getRecordLabel: (record) => record.value || `(MasterType ${record.idMasterType})`,
      getRecordMeta: (record) => `${record.table}.${record.column}`,
      findSavedRecordId: (records, payload) => {
        const match = records.find(
          (record) =>
            record.table === payload.table &&
            record.column === payload.column &&
            record.value === payload.value &&
            (record.code ?? '') === (payload.code ?? '')
        );
        return match ? String(match.idMasterType) : '';
      },
      },
      MaterialList: {
      title: 'Material List Editor',
      copy: 'Select a material to edit it, or add a new row.',
      listTitle: 'Material List',
      idField: 'idMaterialList',
      emptyFactory: createEmptyMaterialList,
      selectAll: cdoMaterialList.selectAll,
      create: cdoMaterialList.create,
      update: cdoMaterialList.update,
      fields: [
        { key: 'idMaterialList', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'bonus_physical', label: 'Bonus Physical', type: 'number' },
        { key: 'bonus_magical', label: 'Bonus Magical', type: 'number' },
      ],
      normalize: (value) => ({
        idMaterialList:
          value.idMaterialList === '' || value.idMaterialList === null || value.idMaterialList === undefined
            ? ''
            : Number(value.idMaterialList),
        name: value.name ?? '',
        bonus_physical:
          value.bonus_physical === '' || value.bonus_physical === null || value.bonus_physical === undefined
            ? null
            : Number(value.bonus_physical),
        bonus_magical:
          value.bonus_magical === '' || value.bonus_magical === null || value.bonus_magical === undefined
            ? null
            : Number(value.bonus_magical),
      }),
      validate: (value) => {
        if (value.idMaterialList === '' || !value.name) {
          return 'MaterialList requires idMaterialList and name.';
        }

        return '';
      },
      getRecordLabel: (record) => record.name || `(Material ${record.idMaterialList})`,
      getRecordMeta: (record) =>
        `Physical ${record.bonus_physical ?? 0} | Magical ${record.bonus_magical ?? 0}`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idMaterialList) === Number(payload.idMaterialList));
        return match ? String(match.idMaterialList) : '';
      },
    },
    ProvisionList: {
      title: 'Provision List Editor',
      copy: 'Select a provision material row to edit it, or add a new row.',
      listTitle: 'Provision List',
      idField: 'idProvisionMaterial',
      emptyFactory: createEmptyProvisionList,
      selectAll: cdoProvisionList.selectAll,
      create: cdoProvisionList.create,
      update: cdoProvisionList.update,
      fields: [
        { key: 'idProvisionMaterial', label: 'ID', type: 'number' },
        { key: 'idProvisionCategory', label: 'Provision Category', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'value', label: 'Value GP', type: 'number' },
      ],
      normalize: (value) => ({
        idProvisionMaterial:
          value.idProvisionMaterial === '' || value.idProvisionMaterial === null || value.idProvisionMaterial === undefined
            ? ''
            : Number(value.idProvisionMaterial),
        idProvisionCategory:
          value.idProvisionCategory === '' || value.idProvisionCategory === null || value.idProvisionCategory === undefined
            ? null
            : Number(value.idProvisionCategory),
        name: value.name ?? '',
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) =>
        !value.name || value.idProvisionCategory === null || value.value === null
          ? 'ProvisionList requires idProvisionCategory, name, and value.'
          : '',
      getRecordLabel: (record) => record.name || `(Provision ${record.idProvisionMaterial})`,
      getRecordMeta: (record) => `Category ${record.idProvisionCategory ?? ''} | Value ${record.value ?? 0} gp`,
      findSavedRecordId: (records, payload) => {
        const match = records.find(
          (record) =>
            Number(record.idProvisionMaterial) === Number(payload.idProvisionMaterial) ||
            (record.name === payload.name &&
              Number(record.idProvisionCategory) === Number(payload.idProvisionCategory))
        );
        return match ? String(match.idProvisionMaterial) : '';
      },
    },
    WeaponList: {
      title: 'Weapon List Editor',
      copy: 'Select a weapon list row to edit it, or add a new row.',
      listTitle: 'Weapon List',
      idField: 'idWeapon',
      emptyFactory: createEmptyWeaponList,
      selectAll: cdoWeaponList.selectAll,
      create: cdoWeaponList.create,
      update: cdoWeaponList.update,
      fields: [
        { key: 'idWeapon', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        {
          key: 'class',
          label: 'Class',
          type: 'number',
          options: [
            { value: 1, label: 'Melee' },
            { value: 2, label: 'Range' },
            { value: 3, label: 'Both' },
            { value: 4, label: 'Two Handed' },
            { value: 5, label: 'Siege' },
          ],
        },
        { key: 'range', label: 'Range', type: 'number' },
        { key: 'damage', label: 'Damage', type: 'number' },
        { key: 'typicalLength', label: 'Typical Length', type: 'number' },
        { key: 'typicalWeight', label: 'Typical Weight', type: 'number' },
        { key: 'value', label: 'Value GP', type: 'number' },
      ],
      normalize: (value) => ({
        idWeapon: value.idWeapon === '' ? '' : Number(value.idWeapon),
        name: value.name ?? '',
        class: value.class === '' ? null : Number(value.class),
        range: value.range === '' ? null : Number(value.range),
        damage: value.damage === '' ? null : Number(value.damage),
        typicalLength: value.typicalLength === '' ? null : Number(value.typicalLength),
        typicalWeight: value.typicalWeight === '' ? null : Number(value.typicalWeight),
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) => (value.idWeapon === '' || !value.name || value.value === null ? 'WeaponList requires idWeapon, name, and value.' : ''),
      getRecordLabel: (record) => record.name || `(Weapon ${record.idWeapon})`,
      getRecordMeta: (record) => `Damage ${record.damage ?? 0} | Range ${record.range ?? 0} | Value ${record.value ?? 0} gp`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idWeapon) === Number(payload.idWeapon));
        return match ? String(match.idWeapon) : '';
      },
    },
    WornList: {
      title: 'Worn List Editor',
      copy: 'Select a worn list row to edit it, or add a new row.',
      listTitle: 'Worn List',
      idField: 'idWorn',
      emptyFactory: createEmptyWornList,
      selectAll: cdoWornList.selectAll,
      create: cdoWornList.create,
      update: cdoWornList.update,
      fields: [
        { key: 'idWorn', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'class', label: 'Class', type: 'number' },
        { key: 'value', label: 'Value GP', type: 'number' },
        {
          key: 'wornWithBodyPart',
          label: 'Worn With Body Part',
          type: 'number',
          options: getMasterTypeRangeOptions(4000, 4200),
        },
      ],
      normalize: (value) => ({
        idWorn: value.idWorn === '' ? '' : Number(value.idWorn),
        name: value.name ?? '',
        class: value.class === '' ? null : Number(value.class),
        wornWithBodyPart: value.wornWithBodyPart === '' ? null : Number(value.wornWithBodyPart),
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) => (value.idWorn === '' || !value.name || value.value === null ? 'WornList requires idWorn, name, and value.' : ''),
      getRecordLabel: (record) => record.name || `(Worn ${record.idWorn})`,
      getRecordMeta: (record) => `Class ${record.class ?? 0} | Value ${record.value ?? 0} gp`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idWorn) === Number(payload.idWorn));
        return match ? String(match.idWorn) : '';
      },
    },
    ContainerList: {
      title: 'Container List Editor',
      copy: 'Select a container list row to edit it, or add a new row.',
      listTitle: 'Container List',
      idField: 'idContainer',
      emptyFactory: createEmptyContainerList,
      selectAll: cdoContainerList.selectAll,
      create: cdoContainerList.create,
      update: cdoContainerList.update,
      fields: [
        { key: 'idContainer', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'capacityLow', label: 'Capacity Low', type: 'number' },
        { key: 'capacityHigh', label: 'Capacity High', type: 'number' },
        { key: 'value', label: 'Value GP', type: 'number' },
      ],
      normalize: (value) => ({
        idContainer: value.idContainer === '' ? '' : Number(value.idContainer),
        name: value.name ?? '',
        capacityLow: value.capacityLow === '' ? null : Number(value.capacityLow),
        capacityHigh: value.capacityHigh === '' ? null : Number(value.capacityHigh),
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) =>
        value.idContainer === '' || !value.name || value.value === null ? 'ContainerList requires idContainer, name, and value.' : '',
      getRecordLabel: (record) => record.name || `(Container ${record.idContainer})`,
      getRecordMeta: (record) => `${record.capacityLow ?? 0} to ${record.capacityHigh ?? 0} | Value ${record.value ?? 0} gp`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idContainer) === Number(payload.idContainer));
        return match ? String(match.idContainer) : '';
      },
    },
    GeneralList: {
      title: 'General List Editor',
      copy: 'Select a general list row to edit it, or add a new row.',
      listTitle: 'General List',
      idField: 'idGeneral',
      emptyFactory: createEmptyGeneralList,
      selectAll: cdoGeneralList.selectAll,
      create: cdoGeneralList.create,
      update: cdoGeneralList.update,
      fields: [
        { key: 'idGeneral', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'value', label: 'Value GP', type: 'number' },
      ],
      normalize: (value) => ({
        idGeneral: value.idGeneral === '' ? '' : Number(value.idGeneral),
        name: value.name ?? '',
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) => (value.idGeneral === '' || !value.name || value.value === null ? 'GeneralList requires idGeneral, name, and value.' : ''),
      getRecordLabel: (record) => record.name || `(General ${record.idGeneral})`,
      getRecordMeta: (record) => `Value ${record.value ?? 0} gp`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idGeneral) === Number(payload.idGeneral));
        return match ? String(match.idGeneral) : '';
      },
    },
    CurrencyList: {
      title: 'Currency List Editor',
      copy: 'Select a currency row to edit it, or add a new row.',
      listTitle: 'Currency List',
      idField: 'idCurrency',
      emptyFactory: createEmptyCurrencyList,
      selectAll: cdoCurrencyList.selectAll,
      create: cdoCurrencyList.create,
      update: cdoCurrencyList.update,
      fields: [
        { key: 'idCurrency', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'value', label: 'Value', type: 'number' },
      ],
      normalize: (value) => ({
        idCurrency: value.idCurrency === '' ? '' : Number(value.idCurrency),
        name: value.name ?? '',
        value: value.value === '' ? null : Number(value.value),
      }),
      validate: (value) =>
        value.idCurrency === '' || !value.name || value.value === null
          ? 'CurrencyList requires idCurrency, name, and value.'
          : '',
      getRecordLabel: (record) => record.name || `(Currency ${record.idCurrency})`,
      getRecordMeta: (record) => `Value ${record.value ?? 0}`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idCurrency) === Number(payload.idCurrency));
        return match ? String(match.idCurrency) : '';
      },
    },
    EventList: {
      title: 'Event List Editor',
      copy: 'Select an event type row to edit it, or add a new row.',
      listTitle: 'Event List',
      idField: 'idEventType',
      emptyFactory: createEmptyEventList,
      selectAll: cdoEventList.selectAll,
      create: cdoEventList.create,
      update: cdoEventList.update,
      fields: [
        { key: 'idEventType', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'category', label: 'Category', type: 'text' },
        { key: 'description', label: 'Description', type: 'textarea' },
        { key: 'defaultImportance', label: 'Default Importance', type: 'number' },
        { key: 'requiresDialog', label: 'Requires Dialog', type: 'number' },
        { key: 'requiresTransaction', label: 'Requires Transaction', type: 'number' },
        { key: 'requiresCombat', label: 'Requires Combat', type: 'number' },
      ],
      normalize: (value) => ({
        idEventType: value.idEventType === '' ? '' : Number(value.idEventType),
        name: value.name ?? '',
        category: value.category ?? '',
        description: value.description ?? '',
        defaultImportance: value.defaultImportance === '' ? 3 : Number(value.defaultImportance),
        requiresDialog: value.requiresDialog === '' ? 0 : Number(value.requiresDialog),
        requiresTransaction: value.requiresTransaction === '' ? 0 : Number(value.requiresTransaction),
        requiresCombat: value.requiresCombat === '' ? 0 : Number(value.requiresCombat),
      }),
      validate: (value) =>
        value.idEventType === '' || !value.name || !value.category
          ? 'EventList requires idEventType, name, and category.'
          : '',
      getRecordLabel: (record) => record.name || `(Event ${record.idEventType})`,
      getRecordMeta: (record) => `${record.category || 'Uncategorized'} | Importance ${record.defaultImportance ?? 3}`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idEventType) === Number(payload.idEventType));
        return match ? String(match.idEventType) : '';
      },
    },
    SpellList: {
      title: 'Spell List Editor',
      copy: 'Select a spell list row to edit it, or add a new row.',
      listTitle: 'Spell List',
      idField: 'idSpellList',
      emptyFactory: createEmptySpellList,
      selectAll: cdoSpellList.selectAll,
      create: cdoSpellList.create,
      update: cdoSpellList.update,
      fields: [
        { key: 'idSpellList', label: 'ID', type: 'number', columnWidth: '72px' },
        { key: 'name', label: 'Name', type: 'text', columnWidth: 'minmax(120px, 0.8fr)' },
        { key: 'description', label: 'Description', type: 'textarea', columnWidth: 'minmax(260px, 1.15fr)' },
        { key: 'gmNotes', label: 'GM Notes', type: 'textarea', columnWidth: 'minmax(260px, 1.15fr)' },
        { key: 'factor', label: 'Factor', type: 'number', columnWidth: '88px', align: 'center' },
        {
          key: 'realm',
          label: 'Realm',
          type: 'number',
          columnWidth: '96px',
          options: [
            { value: 1, label: 'Primary' },
            { value: 2, label: 'Channeling' },
            { value: 3, label: 'Psionics' },
          ],
        },
      ],
      normalize: (value) => ({
        idSpellList: value.idSpellList === '' ? '' : Number(value.idSpellList),
        name: value.name ?? '',
        description: value.description ?? '',
        gmNotes: value.gmNotes ?? '',
        factor: value.factor === '' ? null : Number(value.factor),
        realm: value.realm === '' ? null : Number(value.realm),
      }),
      validate: (value) => (value.idSpellList === '' || !value.name ? 'SpellList requires idSpellList and name.' : ''),
      getRecordLabel: (record) => record.name || `(SpellList ${record.idSpellList})`,
      getRecordMeta: (record) => `Realm ${record.realm ?? 0} | Factor ${record.factor ?? 0}`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idSpellList) === Number(payload.idSpellList));
        return match ? String(match.idSpellList) : '';
      },
    },
    SpellUsage: {
      title: 'Spell Usage Editor',
      copy: 'Select a spell usage row to edit it, or add a new row.',
      listTitle: 'Spell Usage',
      idField: 'idSpellUsage',
      emptyFactory: createEmptySpellUsage,
      selectAll: cdoSpellUsage.selectAll,
      create: cdoSpellUsage.create,
      update: cdoSpellUsage.update,
      fields: [
        { key: 'idSpellUsage', label: 'ID', type: 'number' },
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'enchantmentCostGP', label: 'Enchantment Cost GP', type: 'number' },
      ],
      normalize: (value) => ({
        idSpellUsage: value.idSpellUsage === '' ? '' : Number(value.idSpellUsage),
        name: value.name ?? '',
        enchantmentCostGP: value.enchantmentCostGP === '' ? null : Number(value.enchantmentCostGP),
      }),
      validate: (value) =>
        value.idSpellUsage === '' || !value.name ? 'SpellUsage requires idSpellUsage and name.' : '',
      getRecordLabel: (record) => record.name || `(SpellUsage ${record.idSpellUsage})`,
      getRecordMeta: (record) => `Enchantment Cost ${record.enchantmentCostGP ?? 0} GP`,
      findSavedRecordId: (records, payload) => {
        const match = records.find((record) => Number(record.idSpellUsage) === Number(payload.idSpellUsage));
        return match ? String(match.idSpellUsage) : '';
      },
    },
  }),
    [getMasterTypeRangeOptions]
  );

  const loadItemMetadata = () => {
    cdoItem.selectMetadata((err, response) => {
      if (err || !response || typeof response !== 'object') {
        return;
      }

      setItemMetadata({
        weapons: Array.isArray(response.weapons) ? response.weapons : [],
        worn: Array.isArray(response.worn) ? response.worn : [],
        materials: Array.isArray(response.materials) ? response.materials : [],
        provisionMaterials: Array.isArray(response.provisionMaterials) ? response.provisionMaterials : [],
        containers: Array.isArray(response.containers) ? response.containers : [],
        general: Array.isArray(response.general) ? response.general : [],
      });
    });
  };

  const loadMasterTypes = (onComplete) => {
    cdoMasterType.selectAll((err, response) => {
      if (err || !Array.isArray(response)) {
        if (onComplete) {
          onComplete(err || response);
        }
        return;
      }

      setMasterTypes(response);

      if (onComplete) {
        onComplete(null, response);
      }
    });
  };

  useEffect(() => {
    loadMasterTypes();
  }, []);

  useEffect(() => {
    cdoSpellList.selectAll((err, response) => {
      if (err || !Array.isArray(response)) {
        return;
      }

      setSpellLists(response);
    });
  }, []);

  useEffect(() => {
    cdoSpellUsage.selectAll((err, response) => {
      if (err || !Array.isArray(response)) {
        return;
      }

      setSpellUsages(response);
    });
  }, []);

  useEffect(() => {
    cdoCurrencyList.selectAll((err, response) => {
      if (err || !Array.isArray(response)) {
        return;
      }

      setCurrencyLists(response);
    });
  }, []);

  useEffect(() => {
    loadItemMetadata();
  }, []);

  useEffect(() => {
    if (generatorType === 'Item' || editExistingTab === 'Item') {
      loadItemMetadata();
    }
  }, [generatorType, editExistingTab]);

  const loadExistingBeings = useCallback(() => {
    setIsLoadingExistingBeingList(true);
    cdoBeing.selectAll((err, response) => {
      setIsLoadingExistingBeingList(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingBeings(normalizeEntityList(response, '(Unnamed Being)'));
    });
  }, []);

  const loadExistingItems = useCallback(() => {
    setIsLoadingExistingItemList(true);
    cdoItem.selectAll((err, response) => {
      setIsLoadingExistingItemList(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingItems(normalizeEntityList(response, '(Unnamed Item)'));
    });
  }, []);

  const loadExistingPlaces = useCallback(() => {
    setIsLoadingExistingPlaceList(true);
    cdoPlace.selectAll((err, response) => {
      setIsLoadingExistingPlaceList(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingPlaces(normalizePlaceList(response));
    });
  }, []);

  const loadMythosChapters = useCallback(() => {
    setIsLoadingMythos(true);
    setMythosError('');

    cdoMythos.selectAll((err, response) => {
      setIsLoadingMythos(false);

      if (err || response?.error) {
        setMythosError(formatErrorMessage(err, response));
        return;
      }

      const chapters = (Array.isArray(response) ? response : [])
        .filter((chapter) => chapter?.chapterNumber)
        .sort((left, right) => Number(left.chapterNumber) - Number(right.chapterNumber));

      setMythosChapters(chapters);
    });
  }, []);

  const activeReferenceConfig = referenceConfigs[referenceTable];

  const loadReferenceRecords = useCallback(
    (tableKey = referenceTable, onComplete) => {
      const config = referenceConfigs[tableKey];
      if (!config) {
        return;
      }

      setIsLoadingReferenceList(true);
      config.selectAll((err, response) => {
        setIsLoadingReferenceList(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        const rows = Array.isArray(response) ? response : [];
        setReferenceRecords(rows);

        if (onComplete) {
          onComplete(rows);
        }
      });
    },
    [referenceConfigs, referenceTable]
  );

  useEffect(() => {
    loadExistingBeings();
    loadExistingItems();
    loadExistingPlaces();
  }, [loadExistingBeings, loadExistingItems, loadExistingPlaces]);

  useEffect(() => {
    if (activeTab !== 'Mythos' || mythosChapters.length > 0 || isLoadingMythos) {
      return;
    }

    loadMythosChapters();
  }, [activeTab, mythosChapters.length, isLoadingMythos, loadMythosChapters]);

  useEffect(() => {
    loadReferenceRecords(referenceTable, (rows) => {
      const config = referenceConfigs[referenceTable];
      if (rows.length > 0) {
        setSelectedReferenceId(String(rows[0][config.idField]));
      } else {
        setSelectedReferenceId('');
        setReferenceEditorValue(null);
      }
    });
  }, [loadReferenceRecords, referenceConfigs, referenceTable]);

  useEffect(() => {
    if (selectedMythosChapterNumber || mythosChapters.length === 0) {
      return;
    }

    setSelectedMythosChapterNumber(String(mythosChapters[0].chapterNumber));
  }, [mythosChapters, selectedMythosChapterNumber]);

  useEffect(() => {
    if (!selectedMythosChapterNumber) {
      return;
    }

    const selectedChapterStillExists = mythosChapters.some(
      (chapter) => String(chapter.chapterNumber) === String(selectedMythosChapterNumber)
    );

    if (!selectedChapterStillExists) {
      setSelectedMythosChapterNumber(mythosChapters[0] ? String(mythosChapters[0].chapterNumber) : '');
    }
  }, [mythosChapters, selectedMythosChapterNumber]);

  useEffect(() => {
    if (!selectedCombatantOneId) {
      return;
    }

    const selectedBeingStillExists = existingBeings.some((being) => being.idEntity === selectedCombatantOneId);
    if (!selectedBeingStillExists) {
      setSelectedCombatantOneId('');
    }
  }, [existingBeings, selectedCombatantOneId]);

  useEffect(() => {
    if (!selectedCombatantTwoId) {
      return;
    }

    const selectedBeingStillExists = existingBeings.some((being) => being.idEntity === selectedCombatantTwoId);
    if (!selectedBeingStillExists) {
      setSelectedCombatantTwoId('');
    }
  }, [existingBeings, selectedCombatantTwoId]);

  useEffect(() => {
    if (selectedExistingItemId || existingItems.length === 0) {
      return;
    }

    setSelectedExistingItemId(existingItems[0].idEntity);
  }, [existingItems, selectedExistingItemId]);

  useEffect(() => {
    if (!selectedExistingBeingId) {
      setExistingBeingPortrait(createEmptyBeingPortraitState());
      return;
    }

    setIsLoadingExistingBeing(true);
    setExistingBeingSaveMessage('');
    setExistingBeingPortrait(createEmptyBeingPortraitState());

    cdoBeing.select(selectedExistingBeingId, (err, response) => {
      setIsLoadingExistingBeing(false);

      if (err || !response) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingBeing(toEditableBeing(response));
      loadBeingPortrait(selectedExistingBeingId, setExistingBeingPortrait, true, existingBeingPortraitLoadRef);
    });
  }, [loadBeingPortrait, selectedExistingBeingId]);

  useEffect(() => {
    if (!selectedExistingItemId) {
      return;
    }

    setIsLoadingExistingItem(true);
    setExistingItemSaveMessage('');

    cdoItem.select(selectedExistingItemId, (err, response) => {
      setIsLoadingExistingItem(false);

      if (err || !response) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingItem(toEditableItem(response));
    });
  }, [selectedExistingItemId]);

  const getMasterTypeOptions = useMemo(
    () => (column) =>
      masterTypes
        .filter((masterType) => masterType.column === column)
        .filter((masterType) => !(column === 'placeType' && masterType.value === 'Boundary'))
        .map((masterType) => ({
          value: masterType.value,
          label: masterType.value,
        })),
    [masterTypes]
  );

  const resolveMasterTypeDisplayValue = useCallback(
    (column, value) => {
      if (value === undefined || value === null || value === '') {
        return '';
      }

      const match = masterTypes.find(
        (masterType) =>
          masterType.column === column &&
          (String(masterType.idMasterType) === String(value) ||
            String(masterType.value).trim().toLowerCase() === String(value).trim().toLowerCase())
      );

      return match?.value ?? value;
    },
    [masterTypes]
  );

  const hydratePlaceMasterTypes = useCallback(
    (place) => ({
      ...place,
      createDateAge: resolveMasterTypeDisplayValue('age-multiple', place?.createDateAge),
      createDateSeason: resolveMasterTypeDisplayValue('season-multiple', place?.createDateSeason),
      destroyDateAge: resolveMasterTypeDisplayValue('age-multiple', place?.destroyDateAge),
      destroyDateSeason: resolveMasterTypeDisplayValue('season-multiple', place?.destroyDateSeason),
      placeType: resolveMasterTypeDisplayValue('placeType', place?.placeType),
      zoneType: resolveMasterTypeDisplayValue('zoneType', place?.zoneType),
      buildingType: resolveMasterTypeDisplayValue('buildingType', place?.buildingType),
      transitPointType: resolveMasterTypeDisplayValue('transitPointType', place?.transitPointType),
    }),
    [resolveMasterTypeDisplayValue]
  );

  useEffect(() => {
    if (!selectedExistingPlaceId) {
      setExistingPlace(createEmptyPlace());
      setExistingPlaceImage(createEmptyPlaceImageState());
      return;
    }

    setIsLoadingExistingPlace(true);
    setExistingPlaceSaveMessage('');
    setExistingPlaceImage(createEmptyPlaceImageState());

    cdoPlace.select(selectedExistingPlaceId, (err, response) => {
      setIsLoadingExistingPlace(false);

      if (err || !response) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setExistingPlace(hydratePlaceMasterTypes(toEditablePlace(response)));
      loadPlaceImage(selectedExistingPlaceId, setExistingPlaceImage, true, existingPlaceImageLoadRef);
    });
  }, [hydratePlaceMasterTypes, loadPlaceImage, selectedExistingPlaceId]);

  const spellListOptions = useMemo(
    () =>
      spellLists.map((spellList) => ({
        value: spellList.name,
        label: spellList.name,
      })),
    [spellLists]
  );

  const spellUsageOptions = useMemo(
    () =>
      spellUsages.map((spellUsage) => ({
        value: spellUsage.name,
        label: spellUsage.name,
      })),
    [spellUsages]
  );

  const currencyOptions = useMemo(
    () =>
      currencyLists.map((currency) => ({
        value: String(currency.idCurrency),
        label: currency.name,
        unitValue: currency.value,
      })),
    [currencyLists]
  );

  const routinePlaceOptions = useMemo(
    () =>
      existingPlaces.map((place) => ({
        value: place.idEntity,
        label: [place.name, place.title && place.title !== place.name ? place.title : ''].filter(Boolean).join(' - '),
      })),
    [existingPlaces]
  );

  const itemEditorOptions = useMemo(
    () => ({
      weaponOptions: mergeNamedOptions(
        itemMetadata.weapons.map((row) => row.name),
        [generatedItem?.weapon, existingItem?.weapon]
      ),
      wornOptions: mergeNamedOptions(
        itemMetadata.worn.map((row) => row.name),
        [generatedItem?.worn, existingItem?.worn]
      ),
      materialOptions: mergeNamedOptions(
        itemMetadata.materials.map((row) => row.name),
        generatedItem?.materials,
        existingItem?.materials
      ),
      provisionMaterialOptions: mergeNamedOptions(
        itemMetadata.provisionMaterials.map((row) => row.name),
        [generatedItem?.provisionMaterial, existingItem?.provisionMaterial]
      ),
      containerOptions: mergeNamedOptions(
        itemMetadata.containers.map((row) => row.name),
        [generatedItem?.container, existingItem?.container]
      ),
      generalOptions: mergeNamedOptions(
        itemMetadata.general.map((row) => row.name),
        [generatedItem?.general, existingItem?.general]
      ),
    }),
    [existingItem, generatedItem, itemMetadata]
  );

  const ownerOptions = useMemo(
    () =>
      existingBeings.map((being) => ({
        value: being.idEntity,
        label: being.title ? `${being.name} (${being.title})` : being.name,
      })),
    [existingBeings]
  );

  const itemRelationshipOptions = useMemo(
    () =>
      existingItems.map((item) => ({
        value: item.idEntity,
        label: item.title ? `${item.name} (${item.title})` : item.name,
      })),
    [existingItems]
  );

  const relateTypeOptions = useMemo(
    () =>
      masterTypes
        .filter((masterType) => masterType.column === 'relateType')
        .map((masterType) => ({
          value: masterType.value,
          label: masterType.value,
        }))
        .sort((left, right) => left.label.localeCompare(right.label)),
    [masterTypes]
  );

  const getBeingRelationshipTargetOptions = (currentBeingId) => [
    ...existingBeings
      .filter((being) => being.idEntity !== currentBeingId)
      .map((being) => ({
        value: being.idEntity,
        label: being.title ? `${being.name} (${being.title}) [Being]` : `${being.name} [Being]`,
        name: being.name ?? '',
        title: being.title ?? '',
        entityType: 'Being',
      })),
    ...existingPlaces.map((place) => ({
      value: place.idEntity,
      label: place.title ? `${place.name} (${place.title}) [Place]` : `${place.name} [Place]`,
      name: place.name ?? '',
      title: place.title ?? '',
      entityType: 'Place',
    })),
  ];

  const containedByOptions = useMemo(
    () =>
      existingItems
        .filter((item) => String(item.itemType ?? '').trim().toLowerCase() === 'container')
        .map((item) => ({
          value: item.idEntity,
          label: item.title ? `${item.name} (${item.title})` : item.name,
        })),
    [existingItems]
  );

  const combatantOptions = useMemo(
    () =>
      existingBeings.map((being) => ({
        value: being.idEntity,
        label: being.title ? `${being.name} (${being.title})` : being.name,
      })),
    [existingBeings]
  );
  const combatWinnerLabel = useMemo(() => {
    if (isCombatantDead(combatantOneDetail) && combatantTwoDetail) {
      return combatantLabel(combatantTwoDetail);
    }

    if (isCombatantDead(combatantTwoDetail) && combatantOneDetail) {
      return combatantLabel(combatantOneDetail);
    }

    return '';
  }, [combatantOneDetail, combatantTwoDetail]);
  const isCombatOver = useMemo(
    () => isCombatantDead(combatantOneDetail) || isCombatantDead(combatantTwoDetail),
    [combatantOneDetail, combatantTwoDetail]
  );
  const combatItemLocationEntries = useMemo(
    () =>
      Object.values(combatState?.itemLocations ?? {})
        .filter((entry) => entry?.idEntity)
        .sort((left, right) => String(left.label ?? '').localeCompare(String(right.label ?? ''))),
    [combatState]
  );
  const combatRollLogEntries = useMemo(() => {
    const historicalEntries = combatHistoryEntries.map((entry) => ({
      key: `round-${entry.roundNumber}`,
      title: `Round ${entry.roundNumber}`,
      subtitle:
        entry.startDistanceFeet !== null && entry.endDistanceFeet !== null
          ? `Distance ${formatCombatFeet(entry.startDistanceFeet)} ft -> ${formatCombatFeet(entry.endDistanceFeet)} ft`
          : '',
      playerActionDescription: entry.playerActionDescription ?? '',
      rollResults: entry.rollResults,
      pending: false,
    }));

    if (!combatRollResults) {
      return historicalEntries;
    }

    return [
      {
        key: `round-pending-${combatHistoryEntries.length + 1}`,
        title: `Round ${combatHistoryEntries.length + 1}`,
        subtitle: 'Pending narration',
        playerActionDescription: combatPendingActionDescription,
        rollResults: combatRollResults,
        pending: true,
      },
      ...historicalEntries,
    ];
  }, [combatHistoryEntries, combatPendingActionDescription, combatRollResults]);

  const selectedMythosChapter = useMemo(
    () =>
      mythosChapters.find(
        (chapter) => String(chapter.chapterNumber) === String(selectedMythosChapterNumber)
      ) ?? null,
    [mythosChapters, selectedMythosChapterNumber]
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedPrompt = prompt.trim();
    const parsedYear = Number(aogYear);

    if (!Number.isInteger(parsedYear) || parsedYear < 0 || parsedYear > 21000) {
      setFormError('AoG Year must be a whole number between 0 and 21000.');
      return;
    }

    if (!trimmedPrompt) {
      setFormError('Prompt is required.');
      return;
    }

    setFormError('');
    setGeneratedSaveMessage('');
    setGeneratedBeing(null);
    setGeneratedItem(null);
    setGeneratedPlace(null);
    setGeneratedImage(null);
    setGeneratedBeingPortrait(createEmptyBeingPortraitState());
    setGeneratedPlaceImage(createEmptyPlaceImageState());
    setIsSubmitting(true);

    if (generatorType === 'Place') {
      cdoPlace.generatePlace(
        {
          aogYear: parsedYear,
          prompt: trimmedPrompt,
          parentIdEntity: selectedGeneratedPlaceParentId || '',
        },
        (err, response) => {
          setIsSubmitting(false);

          if (err) {
            window.alert(formatErrorMessage(err, response));
            return;
          }

          setGeneratedPlace({
            ...(response ?? {}),
            parentIdEntity: response?.parentIdEntity ?? selectedGeneratedPlaceParentId ?? '',
          });
          setGeneratedBeing(null);
          setGeneratedItem(null);
          setGeneratedImage(null);
          setGeneratedBeingPortrait(createEmptyBeingPortraitState());
          setGeneratedPlaceImage({ ...createEmptyPlaceImageState(), hasCheckedSavedImage: Boolean(response?.idEntity) });
        }
      );
      return;
    }

    if (generatorType === 'Image') {
      cdoAI.generateImage(
        {
          aogYear: parsedYear,
          prompt: trimmedPrompt,
        },
        (err, response) => {
          setIsSubmitting(false);

          if (err || response?.error) {
            window.alert(formatErrorMessage(err, response));
            return;
          }

          if (!response?.imageBase64) {
            setFormError('Image generation returned no image data.');
            return;
          }

          setGeneratedImage(response);
          setGeneratedBeing(null);
          setGeneratedItem(null);
          setGeneratedPlace(null);
          setGeneratedBeingPortrait(createEmptyBeingPortraitState());
          setGeneratedPlaceImage(createEmptyPlaceImageState());
        }
      );
      return;
    }

    cdoAI.chat(
      {
        aogYear: parsedYear,
        generatorType,
        prompt: trimmedPrompt,
        ...(generatorType === 'Being'
          ? { limitExistingBeingsToGods: limitExistingBeingContextToGods }
          : {}),
      },
      (err, response) => {
        setIsSubmitting(false);

        if (err) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        if (generatorType === 'Item') {
          setGeneratedItem(toEditableItem(response ?? {}));
          setGeneratedBeing(null);
          setGeneratedPlace(null);
          setGeneratedImage(null);
          setGeneratedBeingPortrait(createEmptyBeingPortraitState());
          setGeneratedPlaceImage(createEmptyPlaceImageState());
          return;
        }

        setGeneratedBeing(toEditableBeing(response ?? {}));
        setGeneratedItem(null);
        setGeneratedPlace(null);
        setGeneratedImage(null);
        setGeneratedBeingPortrait({ ...createEmptyBeingPortraitState(), hasCheckedSavedImage: Boolean(response?.idEntity) });
        setGeneratedPlaceImage(createEmptyPlaceImageState());
      }
    );
  };

  const executeCombatRound = async (firstActionResult, secondActionResult, firstActionDescription = '') => {
    if (!combatantOneDetail || !combatantTwoDetail || !firstActionResult || !secondActionResult) {
      return;
    }

    if (isCombatantDead(combatantOneDetail) || isCombatantDead(combatantTwoDetail)) {
      return;
    }

    const localFirstCombatant = cloneCombatantDetail(combatantOneDetail);
    const localSecondCombatant = cloneCombatantDetail(combatantTwoDetail);
    const currentDistanceFeet = normalizeCombatDistanceFeet(combatState?.distanceFeet);
    let localCombatState = {
      distanceFeet: currentDistanceFeet,
      firstCombatantPosition: { ...(combatState?.firstCombatantPosition ?? { x: 0, y: 0, z: 0 }) },
      secondCombatantPosition: {
        ...(combatState?.secondCombatantPosition ?? { x: currentDistanceFeet, y: 0, z: 0 }),
      },
      itemLocations: buildCombatItemLocations(
        localFirstCombatant,
        localSecondCombatant,
        combatState?.itemLocations ?? {}
      ),
      activeSpellEffects: Array.isArray(combatState?.activeSpellEffects)
        ? combatState.activeSpellEffects.map((effect) => cloneCombatSpellEffect(effect))
        : [],
      spellEffectHistory: Array.isArray(combatState?.spellEffectHistory)
        ? combatState.spellEffectHistory.map((effect) => cloneCombatSpellEffect(effect))
        : [],
      roundNumber: Number(combatState?.roundNumber) || 0,
    };
    const currentRoundNumber = localCombatState.roundNumber + 1;

    const firstInitiative = calculateInitiativeRoll(
      localFirstCombatant,
      firstActionResult,
      localCombatState,
      'firstCombatant'
    );
    const secondInitiative = calculateInitiativeRoll(
      localSecondCombatant,
      secondActionResult,
      localCombatState,
      'secondCombatant'
    );
    const firstActionRoll = calculateCombatActionRoll(
      localFirstCombatant,
      firstActionResult,
      localCombatState,
      'firstCombatant'
    );
    const secondActionRoll = calculateCombatActionRoll(
      localSecondCombatant,
      secondActionResult,
      localCombatState,
      'secondCombatant'
    );
    const firstPositiveTicks = getPositiveInitiativeTicks(firstInitiative);
    const secondPositiveTicks = getPositiveInitiativeTicks(secondInitiative);
    const initiativeGapTicks = getInitiativeGapTicks(firstInitiative, secondInitiative);
    const firstRoundLockout = await consumeCombatLockoutRound(localFirstCombatant);
    const secondRoundLockout = await consumeCombatLockoutRound(localSecondCombatant);
    const firstNoInitiativeAction = Number(firstInitiative?.total) <= 0;
    const secondNoInitiativeAction = Number(secondInitiative?.total) <= 0;

    const actingFirst =
      firstInitiative.total >= secondInitiative.total ? 'firstCombatant' : 'secondCombatant';

    const rollResults = {
      firstCombatant: {
        initiative: firstInitiative,
        positiveTicks: firstPositiveTicks,
        actionCount: getInitiativeActionCount(firstInitiative),
        action: firstActionRoll,
        outcome: null,
        skipped: Boolean(firstRoundLockout) || firstNoInitiativeAction,
        skipReason:
          firstRoundLockout?.description ||
          (firstNoInitiativeAction ? 'No action this round due to negative initiative.' : ''),
        movement: null,
      },
      secondCombatant: {
        initiative: secondInitiative,
        positiveTicks: secondPositiveTicks,
        actionCount: getInitiativeActionCount(secondInitiative),
        action: secondActionRoll,
        outcome: null,
        skipped: Boolean(secondRoundLockout) || secondNoInitiativeAction,
        skipReason:
          secondRoundLockout?.description ||
          (secondNoInitiativeAction ? 'No action this round due to negative initiative.' : ''),
        movement: null,
      },
      actingFirst,
      initiativeGapTicks,
      startState: {
        distanceFeet: localCombatState.distanceFeet,
        firstCombatantPosition: { ...localCombatState.firstCombatantPosition },
        secondCombatantPosition: { ...localCombatState.secondCombatantPosition },
        itemLocations: { ...(localCombatState.itemLocations ?? {}) },
        activeSpellEffects: (localCombatState.activeSpellEffects ?? []).map((effect) =>
          cloneCombatSpellEffect(effect)
        ),
        spellEffectHistory: (localCombatState.spellEffectHistory ?? []).map((effect) =>
          cloneCombatSpellEffect(effect)
        ),
        roundNumber: localCombatState.roundNumber,
      },
      endState: null,
    };

    try {
      localCombatState = applyDroppedCurrentItem(
        'firstCombatant',
        localFirstCombatant,
        firstActionDescription,
        localCombatState
      );

      if (actingFirst === 'firstCombatant') {
        if (!rollResults.firstCombatant.skipped && String(firstActionResult?.action ?? '').trim() === 'Physical') {
          const ticksBeforeSecondAction = Math.min(firstPositiveTicks, initiativeGapTicks);
          const movement = resolvePhysicalMovement(
            'firstCombatant',
            localCombatState,
            firstActionRoll,
            ticksBeforeSecondAction
          );
          localCombatState = movement.nextState;
          rollResults.firstCombatant.movement = {
            feetMovedBeforeOpponent: movement.feetMoved,
            feetMovedAfterOpponent: 0,
            feetMoved: movement.feetMoved,
            ticksUsedBeforeOpponent: ticksBeforeSecondAction,
            ticksUsedAfterOpponent: 0,
            ticksUsed: ticksBeforeSecondAction,
            distanceFeet: localCombatState.distanceFeet,
            position: { ...localCombatState.firstCombatantPosition },
          };
        } else if (!rollResults.firstCombatant.skipped) {
          if (canEngageMeleeFromCurrentDistance(firstActionResult, localCombatState)) {
            localCombatState = engageIntoMelee('firstCombatant', localCombatState).nextState;
          }
          updateCombatantReadiedItem(localFirstCombatant, firstActionResult);
          localCombatState = refreshCombatOwnedItemLocations(
            localCombatState,
            localFirstCombatant,
            localSecondCombatant
          );
          localCombatState = syncCombatantReadiedItemLocations(
            localCombatState,
            'firstCombatant',
            localFirstCombatant
          );
          if (String(firstActionResult?.action ?? '').trim() === 'Magic') {
            const magicResolution = await resolveCombatMagicActionOutcome(
              localFirstCombatant,
              localSecondCombatant,
              firstActionResult,
              secondActionResult,
              firstActionRoll,
              localCombatState,
              'firstCombatant',
              currentRoundNumber,
              'secondCombatant'
            );
            localCombatState = magicResolution.combatState;
            rollResults.firstCombatant.outcome = magicResolution.outcome;
          } else {
            rollResults.firstCombatant.outcome = await resolveCombatActionOutcome(
              localFirstCombatant,
              localSecondCombatant,
              firstActionResult,
              secondActionResult,
              firstActionRoll,
              localCombatState,
              'secondCombatant'
            );
            const spentAmmo = consumeCombatAmmoItem(localFirstCombatant, firstActionResult);
            localCombatState = applySpentAmmoLocation(
              localCombatState,
              spentAmmo,
              'secondCombatant',
              rollResults.firstCombatant.outcome
            );
          }
        }

        const firstCritCumulative = rollResults.firstCombatant.outcome?.critResult?.cumulative;
        const cancelsSecondAction =
          Boolean(firstCritCumulative?.loseCurrentRoundActions || firstCritCumulative?.instantDeath);
        const secondCombatantIncapacitation = getCombatantIncapacitation(localSecondCombatant);

        if (cancelsSecondAction) {
          rollResults.secondCombatant.skipped = true;
          rollResults.secondCombatant.skipReason = 'Lost this round action due to a critical result.';
        } else if (secondCombatantIncapacitation) {
          rollResults.secondCombatant.skipped = true;
          rollResults.secondCombatant.skipReason = secondCombatantIncapacitation.description;
        } else {
          if (
            !rollResults.secondCombatant.skipped &&
            String(secondActionResult?.action ?? '').trim() === 'Physical'
          ) {
            const movement = resolvePhysicalMovement(
              'secondCombatant',
              localCombatState,
              secondActionRoll,
              secondPositiveTicks
            );
            localCombatState = movement.nextState;
            rollResults.secondCombatant.movement = {
              feetMoved: movement.feetMoved,
              ticksUsed: secondPositiveTicks,
              distanceFeet: localCombatState.distanceFeet,
              position: { ...localCombatState.secondCombatantPosition },
            };
          } else if (!rollResults.secondCombatant.skipped) {
            if (canEngageMeleeFromCurrentDistance(secondActionResult, localCombatState)) {
              localCombatState = engageIntoMelee('secondCombatant', localCombatState).nextState;
            }
            updateCombatantReadiedItem(localSecondCombatant, secondActionResult);
            localCombatState = refreshCombatOwnedItemLocations(
              localCombatState,
              localFirstCombatant,
              localSecondCombatant
            );
            localCombatState = syncCombatantReadiedItemLocations(
              localCombatState,
              'secondCombatant',
              localSecondCombatant
            );
            if (String(secondActionResult?.action ?? '').trim() === 'Magic') {
              const magicResolution = await resolveCombatMagicActionOutcome(
                localSecondCombatant,
                localFirstCombatant,
                secondActionResult,
                firstActionResult,
                secondActionRoll,
                localCombatState,
                'secondCombatant',
                currentRoundNumber,
                'firstCombatant'
              );
              localCombatState = magicResolution.combatState;
              rollResults.secondCombatant.outcome = magicResolution.outcome;
            } else {
              rollResults.secondCombatant.outcome = await resolveCombatActionOutcome(
                localSecondCombatant,
                localFirstCombatant,
                secondActionResult,
                firstActionResult,
                secondActionRoll,
                localCombatState,
                'firstCombatant'
              );
              const spentAmmo = consumeCombatAmmoItem(localSecondCombatant, secondActionResult);
              localCombatState = applySpentAmmoLocation(
                localCombatState,
                spentAmmo,
                'firstCombatant',
                rollResults.secondCombatant.outcome
              );
            }
          }
        }

        if (rollResults.firstCombatant.movement && !rollResults.firstCombatant.skipped) {
          const remainingTicksAfterSecondAction = Math.max(
            0,
            firstPositiveTicks - (rollResults.firstCombatant.movement.ticksUsedBeforeOpponent || 0)
          );

          if (remainingTicksAfterSecondAction > 0 && localCombatState.distanceFeet > 0) {
            const movementAfterSecondAction = resolvePhysicalMovement(
              'firstCombatant',
              localCombatState,
              firstActionRoll,
              remainingTicksAfterSecondAction
            );
            localCombatState = movementAfterSecondAction.nextState;
            rollResults.firstCombatant.movement.feetMovedAfterOpponent =
              movementAfterSecondAction.feetMoved;
            rollResults.firstCombatant.movement.feetMoved += movementAfterSecondAction.feetMoved;
            rollResults.firstCombatant.movement.ticksUsedAfterOpponent = remainingTicksAfterSecondAction;
            rollResults.firstCombatant.movement.ticksUsed =
              (rollResults.firstCombatant.movement.ticksUsedBeforeOpponent || 0) +
              remainingTicksAfterSecondAction;
            rollResults.firstCombatant.movement.distanceFeet = localCombatState.distanceFeet;
            rollResults.firstCombatant.movement.position = {
              ...localCombatState.firstCombatantPosition,
            };
            const ticksNeededToReachOpponent = calculateTicksNeededToReachDistance(
              firstActionRoll,
              rollResults.startState.distanceFeet -
                (rollResults.firstCombatant.movement.feetMovedBeforeOpponent || 0)
            );
            rollResults.firstCombatant.movement.followUpActionAvailable = Boolean(
              firstActionResult?.associatedItem &&
                movementAfterSecondAction.feetMoved > 0 &&
                ticksNeededToReachOpponent <
                  (rollResults.firstCombatant.movement.ticksUsedBeforeOpponent || 0) +
                    remainingTicksAfterSecondAction &&
                localCombatState.distanceFeet === 0
            );
          }
        }
      } else {
        if (
          !rollResults.secondCombatant.skipped &&
          String(secondActionResult?.action ?? '').trim() === 'Physical'
        ) {
          const ticksBeforeFirstAction = Math.min(secondPositiveTicks, initiativeGapTicks);
          const movement = resolvePhysicalMovement(
            'secondCombatant',
            localCombatState,
            secondActionRoll,
            ticksBeforeFirstAction
          );
          localCombatState = movement.nextState;
          rollResults.secondCombatant.movement = {
            feetMovedBeforeOpponent: movement.feetMoved,
            feetMovedAfterOpponent: 0,
            feetMoved: movement.feetMoved,
            ticksUsedBeforeOpponent: ticksBeforeFirstAction,
            ticksUsedAfterOpponent: 0,
            ticksUsed: ticksBeforeFirstAction,
            distanceFeet: localCombatState.distanceFeet,
            position: { ...localCombatState.secondCombatantPosition },
          };
        } else if (!rollResults.secondCombatant.skipped) {
          if (canEngageMeleeFromCurrentDistance(secondActionResult, localCombatState)) {
            localCombatState = engageIntoMelee('secondCombatant', localCombatState).nextState;
          }
          updateCombatantReadiedItem(localSecondCombatant, secondActionResult);
          localCombatState = refreshCombatOwnedItemLocations(
            localCombatState,
            localFirstCombatant,
            localSecondCombatant
          );
          localCombatState = syncCombatantReadiedItemLocations(
            localCombatState,
            'secondCombatant',
            localSecondCombatant
          );
          if (String(secondActionResult?.action ?? '').trim() === 'Magic') {
            const magicResolution = await resolveCombatMagicActionOutcome(
              localSecondCombatant,
              localFirstCombatant,
              secondActionResult,
              firstActionResult,
              secondActionRoll,
              localCombatState,
              'secondCombatant',
              currentRoundNumber,
              'firstCombatant'
            );
            localCombatState = magicResolution.combatState;
            rollResults.secondCombatant.outcome = magicResolution.outcome;
          } else {
            rollResults.secondCombatant.outcome = await resolveCombatActionOutcome(
              localSecondCombatant,
              localFirstCombatant,
              secondActionResult,
              firstActionResult,
              secondActionRoll,
              localCombatState,
              'firstCombatant'
            );
            const spentAmmo = consumeCombatAmmoItem(localSecondCombatant, secondActionResult);
            localCombatState = applySpentAmmoLocation(
              localCombatState,
              spentAmmo,
              'firstCombatant',
              rollResults.secondCombatant.outcome
            );
          }
        }

        const secondCritCumulative = rollResults.secondCombatant.outcome?.critResult?.cumulative;
        const cancelsFirstAction =
          Boolean(secondCritCumulative?.loseCurrentRoundActions || secondCritCumulative?.instantDeath);
        const firstCombatantIncapacitation = getCombatantIncapacitation(localFirstCombatant);

        if (cancelsFirstAction) {
          rollResults.firstCombatant.skipped = true;
          rollResults.firstCombatant.skipReason = 'Lost this round action due to a critical result.';
        } else if (firstCombatantIncapacitation) {
          rollResults.firstCombatant.skipped = true;
          rollResults.firstCombatant.skipReason = firstCombatantIncapacitation.description;
        } else {
          if (!rollResults.firstCombatant.skipped && String(firstActionResult?.action ?? '').trim() === 'Physical') {
            const movement = resolvePhysicalMovement(
              'firstCombatant',
              localCombatState,
              firstActionRoll,
              firstPositiveTicks
            );
            localCombatState = movement.nextState;
            rollResults.firstCombatant.movement = {
              feetMoved: movement.feetMoved,
              ticksUsed: firstPositiveTicks,
              distanceFeet: localCombatState.distanceFeet,
              position: { ...localCombatState.firstCombatantPosition },
            };
          } else if (!rollResults.firstCombatant.skipped) {
            if (canEngageMeleeFromCurrentDistance(firstActionResult, localCombatState)) {
              localCombatState = engageIntoMelee('firstCombatant', localCombatState).nextState;
            }
            updateCombatantReadiedItem(localFirstCombatant, firstActionResult);
            localCombatState = refreshCombatOwnedItemLocations(
              localCombatState,
              localFirstCombatant,
              localSecondCombatant
            );
            localCombatState = syncCombatantReadiedItemLocations(
              localCombatState,
              'firstCombatant',
              localFirstCombatant
            );
            if (String(firstActionResult?.action ?? '').trim() === 'Magic') {
              const magicResolution = await resolveCombatMagicActionOutcome(
                localFirstCombatant,
                localSecondCombatant,
                firstActionResult,
                secondActionResult,
                firstActionRoll,
                localCombatState,
                'firstCombatant',
                currentRoundNumber,
                'secondCombatant'
              );
              localCombatState = magicResolution.combatState;
              rollResults.firstCombatant.outcome = magicResolution.outcome;
            } else {
              rollResults.firstCombatant.outcome = await resolveCombatActionOutcome(
                localFirstCombatant,
                localSecondCombatant,
                firstActionResult,
                secondActionResult,
                firstActionRoll,
                localCombatState,
                'secondCombatant'
              );
              const spentAmmo = consumeCombatAmmoItem(localFirstCombatant, firstActionResult);
              localCombatState = applySpentAmmoLocation(
                localCombatState,
                spentAmmo,
                'secondCombatant',
                rollResults.firstCombatant.outcome
              );
            }
          }
        }

        if (rollResults.secondCombatant.movement && !rollResults.secondCombatant.skipped) {
          const remainingTicksAfterFirstAction = Math.max(
            0,
            secondPositiveTicks - (rollResults.secondCombatant.movement.ticksUsedBeforeOpponent || 0)
          );

          if (remainingTicksAfterFirstAction > 0 && localCombatState.distanceFeet > 0) {
            const movementAfterFirstAction = resolvePhysicalMovement(
              'secondCombatant',
              localCombatState,
              secondActionRoll,
              remainingTicksAfterFirstAction
            );
            localCombatState = movementAfterFirstAction.nextState;
            rollResults.secondCombatant.movement.feetMovedAfterOpponent =
              movementAfterFirstAction.feetMoved;
            rollResults.secondCombatant.movement.feetMoved += movementAfterFirstAction.feetMoved;
            rollResults.secondCombatant.movement.ticksUsedAfterOpponent = remainingTicksAfterFirstAction;
            rollResults.secondCombatant.movement.ticksUsed =
              (rollResults.secondCombatant.movement.ticksUsedBeforeOpponent || 0) +
              remainingTicksAfterFirstAction;
            rollResults.secondCombatant.movement.distanceFeet = localCombatState.distanceFeet;
            rollResults.secondCombatant.movement.position = {
              ...localCombatState.secondCombatantPosition,
            };
            const ticksNeededToReachOpponent = calculateTicksNeededToReachDistance(
              secondActionRoll,
              rollResults.startState.distanceFeet -
                (rollResults.secondCombatant.movement.feetMovedBeforeOpponent || 0)
            );
            rollResults.secondCombatant.movement.followUpActionAvailable = Boolean(
              secondActionResult?.associatedItem &&
                movementAfterFirstAction.feetMoved > 0 &&
                ticksNeededToReachOpponent <
                  (rollResults.secondCombatant.movement.ticksUsedBeforeOpponent || 0) +
                    remainingTicksAfterFirstAction &&
                localCombatState.distanceFeet === 0
            );
          }
        }
      }

      localCombatState = syncCombatantReadiedItemLocations(
        localCombatState,
        'firstCombatant',
        localFirstCombatant
      );
      localCombatState = syncCombatantReadiedItemLocations(
        localCombatState,
        'secondCombatant',
        localSecondCombatant
      );
      localCombatState = advanceCombatSpellEffects(localCombatState, currentRoundNumber);

      rollResults.endState = {
        distanceFeet: localCombatState.distanceFeet,
        firstCombatantPosition: { ...localCombatState.firstCombatantPosition },
        secondCombatantPosition: { ...localCombatState.secondCombatantPosition },
        itemLocations: { ...(localCombatState.itemLocations ?? {}) },
        activeSpellEffects: (localCombatState.activeSpellEffects ?? []).map((effect) =>
          cloneCombatSpellEffect(effect)
        ),
        spellEffectHistory: (localCombatState.spellEffectHistory ?? []).map((effect) =>
          cloneCombatSpellEffect(effect)
        ),
        roundNumber: localCombatState.roundNumber,
      };

      setCombatantOneDetail(localFirstCombatant);
      setCombatantTwoDetail(localSecondCombatant);
      setCombatState(localCombatState);
      setCombatRollResults(rollResults);
      setCombatPendingActionDescription(firstActionDescription);
      setCombatNarration(null);
      setIsGeneratingCombatNarration(true);

      cdoAI.describeCombatRound(
        {
          combatState: rollResults.endState,
          startState: rollResults.startState,
          firstCombatant: localFirstCombatant,
          secondCombatant: localSecondCombatant,
          firstCombatantAction: firstActionResult,
          secondCombatantAction: secondActionResult,
          rollResults,
        },
        (err, response) => {
          setIsGeneratingCombatNarration(false);

          if (err) {
            window.alert(formatErrorMessage(err, response));
            return;
          }

          const narration = response?.response ?? response ?? null;
          setCombatHistoryEntries((current) => [
            ...current,
            {
              roundNumber: current.length + 1,
              startDistanceFeet: rollResults.startState?.distanceFeet ?? null,
              endDistanceFeet: rollResults.endState?.distanceFeet ?? null,
              playerActionDescription: firstActionDescription,
              roundDescription: narration?.roundDescription || '',
              rollResults,
            },
          ]);
          setCombatAction('');
          setCombatActionResult(null);
          setCombatResponseActionResult(null);
          setCombatRollResults(null);
          setCombatPendingActionDescription('');
          setCombatNarration(null);
        }
      );
    } catch (error) {
      setCombatPendingActionDescription('');
      setIsGeneratingCombatNarration(false);
      window.alert(formatErrorMessage(error?.err || error, error?.response));
    }
  };

  const handleCombatActionSubmit = () => {
    const trimmedAction = combatAction.trim();

    if (!selectedCombatantOneId || !selectedCombatantTwoId) {
      window.alert('Select both combatants before submitting an action.');
      return;
    }

    if (!trimmedAction) {
      window.alert('Describe the action before submitting it.');
      return;
    }

    if (isCombatOver) {
      const winnerLabel = combatWinnerLabel ? `${combatWinnerLabel} wins.` : 'Combat is over.';
      window.alert(`Combat has ended. ${winnerLabel}`);
      return;
    }

    setCombatActionResult(null);
    setCombatResponseActionResult(null);
    setCombatRollResults(null);
    setCombatNarration(null);
    setIsSubmittingCombatAction(true);

    cdoAI.determineAction(
      {
        idEntity: selectedCombatantOneId,
        idTargetEntity: selectedCombatantTwoId,
        prompt: trimmedAction,
        combatState,
        actorContext: combatantOneDetail,
        targetContext: combatantTwoDetail,
      },
      (err, response) => {
        if (err) {
          setIsSubmittingCombatAction(false);
          window.alert(formatErrorMessage(err, response));
          return;
        }

        const firstActionRaw = response?.response ?? response ?? null;
        if (firstActionRaw?.intent === 'question') {
          setIsSubmittingCombatAction(false);
          window.alert(firstActionRaw?.responseMessage || 'Ask a combat question before acting.');
          return;
        }

        if (firstActionRaw?.intent === 'invalid') {
          setIsSubmittingCombatAction(false);
          window.alert(firstActionRaw?.responseMessage || 'That action is not currently allowed.');
          return;
        }

        const firstActionResult = normalizeCombatActionForStatus(combatantOneDetail, firstActionRaw);
        const firstActionValidation = validateCombatActionSelection(combatantOneDetail, firstActionResult);
        if (!firstActionValidation.isValid) {
          setIsSubmittingCombatAction(false);
          setCombatActionResult(null);
          setCombatResponseActionResult(null);
          window.alert(firstActionValidation.message);
          return;
        }

        if (
          isBowLikeActionItem(firstActionResult?.associatedItem) &&
          !hasRequiredCombatAmmo(combatantOneDetail, firstActionResult)
        ) {
          setIsSubmittingCombatAction(false);
          setCombatActionResult(null);
          setCombatResponseActionResult(null);
          window.alert('That being is out of arrows for that bow attack. Choose another action description.');
          return;
        }

        cdoAI.chooseCombatAction(
          {
            idEntity: selectedCombatantTwoId,
            idTargetEntity: selectedCombatantOneId,
            combatState,
            actorContext: combatantTwoDetail,
            targetContext: combatantOneDetail,
          },
          async (responseErr, responseAction) => {
            if (responseErr) {
              setIsSubmittingCombatAction(false);
              window.alert(formatErrorMessage(responseErr, responseAction));
              return;
            }

            const secondActionResult = normalizeCombatActionForStatus(
              combatantTwoDetail,
              responseAction?.response ?? responseAction ?? null
            );
            const secondActionValidation = validateCombatActionSelection(
              combatantTwoDetail,
              secondActionResult
            );
            if (!secondActionValidation.isValid) {
              setIsSubmittingCombatAction(false);
              window.alert(secondActionValidation.message);
              return;
            }

            try {
              await executeCombatRound(firstActionResult, secondActionResult, trimmedAction);
            } finally {
              setIsSubmittingCombatAction(false);
            }
          }
        );
      }
    );
  };

  const handleCombatantRefresh = () => {
    setCombatAction('');
    setCombatActionResult(null);
    setCombatResponseActionResult(null);
    setCombatRollResults(null);
    setCombatPendingActionDescription('');
    setCombatNarration(null);
    setCombatState(createInitialCombatState());
    setCombatHistoryEntries([]);
    setIsGeneratingCombatNarration(false);
    setIsSubmittingCombatAction(false);
    setCombatRefreshToken((current) => current + 1);
  };

  useEffect(() => {
    if (!selectedCombatantOneId) {
      setCombatantOneDetail(null);
      return undefined;
    }

    let isCancelled = false;

    callCdoSelect(cdoBeing, selectedCombatantOneId)
      .then(async (being) => {
        const ownedItems = Array.isArray(being?.ownedItems) ? being.ownedItems : [];
        const ownedItemDetails = await Promise.all(
          ownedItems
            .filter((item) => item?.idEntity)
            .map((item) => callCdoSelect(cdoItem, item.idEntity).catch(() => item))
        );

        if (!isCancelled) {
          setCombatantOneDetail(createCombatReadyBeing({
            ...being,
            ownedItems: ownedItemDetails,
          }));
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setCombatantOneDetail(null);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [selectedCombatantOneId, combatRefreshToken]);

  useEffect(() => {
    if (!selectedCombatantTwoId) {
      setCombatantTwoDetail(null);
      return undefined;
    }

    let isCancelled = false;

    callCdoSelect(cdoBeing, selectedCombatantTwoId)
      .then(async (being) => {
        const ownedItems = Array.isArray(being?.ownedItems) ? being.ownedItems : [];
        const ownedItemDetails = await Promise.all(
          ownedItems
            .filter((item) => item?.idEntity)
            .map((item) => callCdoSelect(cdoItem, item.idEntity).catch(() => item))
        );

        if (!isCancelled) {
          setCombatantTwoDetail(createCombatReadyBeing({
            ...being,
            ownedItems: ownedItemDetails,
          }));
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setCombatantTwoDetail(null);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [selectedCombatantTwoId, combatRefreshToken]);

  useEffect(() => {
    if (!selectedCombatantOneId || !selectedCombatantTwoId) {
      return;
    }

    const nextPairKey = `${selectedCombatantOneId}::${selectedCombatantTwoId}`;
    if (previousCombatantPairRef.current === nextPairKey) {
      return;
    }

    previousCombatantPairRef.current = nextPairKey;
    setCombatActionResult(null);
    setCombatResponseActionResult(null);
    setCombatRollResults(null);
    setCombatNarration(null);
    setCombatState(createInitialCombatState());
    setCombatHistoryEntries([]);
  }, [selectedCombatantOneId, selectedCombatantTwoId]);

  useEffect(() => {
    if (!combatantOneDetail || !combatantTwoDetail) {
      return;
    }

    setCombatState((current) => {
      if (Object.keys(current?.itemLocations ?? {}).length > 0) {
        return current;
      }

      return {
        ...current,
        itemLocations: buildCombatItemLocations(combatantOneDetail, combatantTwoDetail, {}),
      };
    });
  }, [combatantOneDetail, combatantTwoDetail]);

  useEffect(() => {
    if (!combatAction.trim()) {
      return;
    }

    setCombatActionResult(null);
    setCombatResponseActionResult(null);
    setCombatRollResults(null);
    setCombatNarration(null);
  }, [combatAction]);

  useEffect(() => {
    combatHistoryEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [combatHistoryEntries, isGeneratingCombatNarration]);

  const removeFormRow = (setBeing, index, formRow) => {
    if (formRow?.idEntityForms) {
      cdoForm.delete({ idEntityForms: formRow.idEntityForms }, (err, response) => {
        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setBeing((current) => ({
          ...current,
          multipleForms: current.forms.filter((_, currentIndex) => currentIndex !== index).length > 1,
          forms: current.forms.filter((_, currentIndex) => currentIndex !== index),
        }));
      });
      return;
    }

    setBeing((current) => ({
      ...current,
      multipleForms: current.forms.filter((_, currentIndex) => currentIndex !== index).length > 1,
      forms: current.forms.filter((_, currentIndex) => currentIndex !== index),
    }));
  };

  const removeSpellRow = (setValue, index, spellRow) => {
    if (spellRow?.idSpell) {
      cdoSpell.delete({ idSpell: spellRow.idSpell }, (err, response) => {
        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setValue((current) => ({
          ...current,
          spells: current.spells.filter((_, currentIndex) => currentIndex !== index),
        }));
      });
      return;
    }

    setValue((current) => ({
      ...current,
      spells: current.spells.filter((_, currentIndex) => currentIndex !== index),
    }));
  };

  const assignItemOwner = (item, setItem, setIsSaving, setSaveMessage, nextOwnerId, onComplete) => {
    if (!item?.idEntity) {
      setSaveMessage('Save the item before assigning ownership.');
      return;
    }

    if (!nextOwnerId) {
      setSaveMessage('Select a being to assign ownership.');
      return;
    }

    const previousOwnerId = item.ownerId || '';
    const nextOwner = existingBeings.find((being) => being.idEntity === nextOwnerId);

    if (previousOwnerId === nextOwnerId && item.ownerName) {
      setSaveMessage(`Owned By: ${item.ownerName}`);
      if (onComplete) {
        onComplete();
      }
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoEntityRelate.replaceOwner(
      { idRelated: item.idEntity, nextOwnerId },
      (replaceErr, replaceResponse) => {
        setIsSaving(false);

        if (replaceErr || replaceResponse?.error) {
          window.alert(formatErrorMessage(replaceErr, replaceResponse));
          return;
        }

        const ownerName = nextOwner?.name || '';
        setItem((current) => ({
          ...current,
          ownerId: nextOwnerId,
          ownerName,
        }));
        setSaveMessage(ownerName ? `Owned By: ${ownerName}` : 'Owner updated.');

        if (onComplete) {
          onComplete();
        }
      }
    );
  };

  const replaceItemContainedBy = (item, setItem, setIsSaving, setSaveMessage, nextContainerId, onComplete) => {
    if (!item?.idEntity) {
      setSaveMessage('Save the item before setting containment.');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoEntityRelate.replace(
      {
        idRelated: item.idEntity,
        nextEntityId: nextContainerId || null,
        relateType: RELATE_TYPE_CONTAINS,
      },
      (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        const nextContainer = existingItems.find((existingItem) => existingItem.idEntity === nextContainerId);
        setItem((current) => ({
          ...current,
          containedById: nextContainerId || '',
          containedByName: nextContainer?.name || '',
        }));
        setSaveMessage(nextContainerId ? `Contained By: ${nextContainer?.name || ''}` : 'Contained By removed.');

        if (onComplete) {
          onComplete();
        }
      }
    );
  };

  const addItemContains = (item, setItem, setIsSaving, setSaveMessage, relatedItemId, onComplete) => {
    if (!item?.idEntity) {
      setSaveMessage('Save the item before adding contains relationships.');
      return;
    }

    if (!relatedItemId) {
      setSaveMessage('Select an item to contain.');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoEntityRelate.replace(
      {
        idRelated: relatedItemId,
        nextEntityId: item.idEntity,
        relateType: RELATE_TYPE_CONTAINS,
      },
      (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        const relatedItem = existingItems.find((existingItem) => existingItem.idEntity === relatedItemId);
        setItem((current) => {
          const nextContainsItems = [
            ...(current.containsItems ?? []).filter((existingItem) => existingItem.idEntity !== relatedItemId),
            {
              idEntity: relatedItemId,
              name: relatedItem?.name || '',
              title: relatedItem?.title || '',
            },
          ];

          nextContainsItems.sort((left, right) => left.name.localeCompare(right.name));

          return {
            ...current,
            containsItems: nextContainsItems,
          };
        });
        setSaveMessage(relatedItem?.name ? `Contains: ${relatedItem.name}` : 'Contains relationship updated.');

        if (onComplete) {
          onComplete();
        }
      }
    );
  };

  const removeItemContains = (item, setItem, setIsSaving, setSaveMessage, relatedItem, onComplete) => {
    if (!item?.idEntity || !relatedItem?.idEntity) {
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoEntityRelate.delete(
      {
        idEntity: item.idEntity,
        idRelated: relatedItem.idEntity,
        relateType: RELATE_TYPE_CONTAINS,
      },
      (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setItem((current) => ({
          ...current,
          containsItems: (current.containsItems ?? []).filter(
            (currentRelatedItem) => currentRelatedItem.idEntity !== relatedItem.idEntity
          ),
        }));
        setSaveMessage(relatedItem.name ? `Removed contains: ${relatedItem.name}` : 'Contains relationship removed.');

        if (onComplete) {
          onComplete();
        }
      }
    );
  };

  const deleteBeingRelationship = (relationship, index, setBeing, setIsSaving, setSaveMessage) => {
    const deleteRelateType = relationship?.storedRelateType || relationship?.relateType;

    if (!relationship?.idEntity || !relationship?.idRelated || !deleteRelateType) {
      setSaveMessage('Relationship is missing required delete data.');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoEntityRelate.delete(
      {
        idEntity: relationship.idEntity,
        idRelated: relationship.idRelated,
        relateType: getRelateTypeId(deleteRelateType),
      },
      (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setBeing((current) => ({
          ...current,
          relationships: Array.isArray(current?.relationships)
            ? current.relationships.filter((entry, entryIndex) =>
                entryIndex !== index ||
                entry.idEntity !== relationship.idEntity ||
                entry.idRelated !== relationship.idRelated ||
                entry.relateType !== relationship.relateType
              )
            : [],
        }));
        setSaveMessage('Relationship deleted.');
      }
    );
  };

  const createPendingBeingRelationships = (savedId, relationships = []) => {
    const pendingRelationships = (Array.isArray(relationships) ? relationships : [])
      .filter((relationship) => relationship?.isNew && relationship.otherEntityId && relationship.relateType);

    if (!savedId || pendingRelationships.length === 0) {
      return Promise.resolve(0);
    }

    return Promise.all(
      pendingRelationships.map((relationship) =>
        new Promise((resolve, reject) => {
          cdoEntityRelate.create(
            {
              idEntity: savedId,
              idRelated: relationship.otherEntityId,
              relateType: getRelateTypeId(relationship.relateType),
              score: Number.isFinite(Number(relationship.score)) ? Number(relationship.score) : 50,
            },
            (err, response) => {
              if (err || response?.error) {
                reject(new Error(formatErrorMessage(err, response)));
                return;
              }

              resolve(response);
            }
          );
        })
      )
    ).then((results) => results.length);
  };

  const saveBeing = (being, setBeing, setIsSaving, setSaveMessage, afterSave) => {
    const payload = normalizeBeingPayload(being);
    const validationMessage = validateBeingForSave(payload);

    if (validationMessage) {
      setSaveMessage(validationMessage);
      return;
    }

    const incompleteRelationship = (Array.isArray(being?.relationships) ? being.relationships : [])
      .some((relationship) => relationship?.isNew && (!relationship.otherEntityId || !relationship.relateType));

    if (incompleteRelationship) {
      setSaveMessage('Complete or remove new relationship rows before saving.');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    const saveFn = payload.idEntity ? cdoBeing.update : cdoBeing.create;

    saveFn(payload, (err, response) => {
      if (err || response?.error) {
        setIsSaving(false);
        window.alert(formatErrorMessage(err, response));
        return;
      }

      const savedId = response?.idEntity || payload.idEntity;
      const finalizeSave = (relationshipsCreated = 0) => {
        loadExistingBeings();

        if (!savedId) {
          setIsSaving(false);
          setSaveMessage('Save completed.');
          if (afterSave) {
            afterSave(savedId);
          }
          return;
        }

        cdoBeing.select(savedId, (selectErr, selectResponse) => {
          setIsSaving(false);

          if (selectErr || !selectResponse) {
            window.alert(formatErrorMessage(selectErr, selectResponse));
            return;
          }

          setBeing(toEditableBeing(selectResponse));
          setSaveMessage(`Saved being ${savedId}.${relationshipsCreated > 0 ? ` Added ${relationshipsCreated} relationship(s).` : ''}`);

          if (afterSave) {
            afterSave(savedId);
          }
        });
      };

      loadMasterTypes((masterTypeError) => {
        if (masterTypeError) {
          window.alert(formatErrorMessage(masterTypeError));
        }

        createPendingBeingRelationships(savedId, being.relationships)
          .then((relationshipsCreated) => finalizeSave(relationshipsCreated))
          .catch((relationshipError) => {
            setIsSaving(false);
            window.alert(relationshipError.message || 'Failed to save relationship.');
          });
      });
    });
  };

  const saveItem = (item, setItem, setIsSaving, setSaveMessage, afterSave) => {
    const payload = normalizeItemPayload(item);
    const validationMessage = validateItemForSave(payload);

    if (validationMessage) {
      setSaveMessage(validationMessage);
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    const saveFn = payload.idEntity ? cdoItem.update : cdoItem.create;

    saveFn(payload, (err, response) => {
      setIsSaving(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      const savedId = response?.idEntity || payload.idEntity;
      const finalizeSave = () => {
        loadExistingItems();

        if (!savedId) {
          setSaveMessage('Save completed.');
          if (afterSave) {
            afterSave(savedId);
          }
          return;
        }

        cdoItem.select(savedId, (selectErr, selectResponse) => {
          if (selectErr || !selectResponse) {
            window.alert(formatErrorMessage(selectErr, selectResponse));
            return;
          }

          setItem(toEditableItem(selectResponse));
          setSaveMessage(`Saved item ${savedId}.`);

          if (afterSave) {
            afterSave(savedId);
          }
        });
      };

      loadMasterTypes((masterTypeError) => {
        if (masterTypeError) {
          window.alert(formatErrorMessage(masterTypeError));
        }

        finalizeSave();
      });
    });
  };

  const savePlace = (place, setPlace, setIsSaving, setSaveMessage, afterSave) => {
    const payload = normalizePlacePayload(place);
    const validationMessage = validatePlaceForSave(payload);

    if (validationMessage) {
      setSaveMessage(validationMessage);
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    const saveFn = payload.idEntity ? cdoPlace.update : cdoPlace.create;

    saveFn(payload, (err, response) => {
      setIsSaving(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      const savedId = response?.idEntity || payload.idEntity;
      const finalizeSave = () => {
        loadExistingPlaces();

        if (!savedId) {
          setSaveMessage('Save completed.');
          if (afterSave) {
            afterSave(savedId);
          }
          return;
        }

        cdoPlace.select(savedId, (selectErr, selectResponse) => {
          if (selectErr || !selectResponse) {
            window.alert(formatErrorMessage(selectErr, selectResponse));
            return;
          }

          setPlace(hydratePlaceMasterTypes(toEditablePlace(selectResponse)));
          setSaveMessage(`Saved place ${savedId}.`);

          if (afterSave) {
            afterSave(savedId);
          }
        });
      };

      loadMasterTypes((masterTypeError) => {
        if (masterTypeError) {
          window.alert(formatErrorMessage(masterTypeError));
        }

        finalizeSave();
      });
    });
  };

  const samePlaceSuggestion = (left, right) =>
    String(left?.name ?? '').trim().toLowerCase() === String(right?.name ?? '').trim().toLowerCase() &&
    String(left?.placeType ?? '').trim().toLowerCase() === String(right?.placeType ?? '').trim().toLowerCase() &&
    String(left?.zoneType ?? '').trim().toLowerCase() === String(right?.zoneType ?? '').trim().toLowerCase() &&
    String(left?.buildingType ?? '').trim().toLowerCase() === String(right?.buildingType ?? '').trim().toLowerCase() &&
    String(left?.description ?? '').trim().toLowerCase() === String(right?.description ?? '').trim().toLowerCase();

  const reloadPlaceAfterChildSave = (idEntity, setPlace, onError) => {
    if (!idEntity) {
      return;
    }

    cdoPlace.select(idEntity, (err, response) => {
      if (err || !response) {
        if (onError) {
          onError(err, response);
        } else {
          window.alert(formatErrorMessage(err, response));
        }
        return;
      }

      const refreshedPlace = hydratePlaceMasterTypes(toEditablePlace(response));
      setPlace((current) => ({
        ...refreshedPlace,
        childPlaceSuggestions: Array.isArray(current?.childPlaceSuggestions)
          ? current.childPlaceSuggestions
          : [],
      }));
    });
  };

  const saveMovedOverviewPlace = (movedPlace, setSaveMessage) => {
    if (!movedPlace?.idEntity) {
      return;
    }

    const movedPlaces = getMovedOverviewPlaces(movedPlace);
    setSaveMessage(movedPlaces.length > 1 ? 'Saving overview geometry for moved places...' : 'Saving overview geometry...');
    overviewGeometrySaverRef.current(movedPlace)
      .then(() => {
        setSaveMessage(
          movedPlaces.length > 1
            ? `Overview geometry for "${movedPlace.title || movedPlace.name || movedPlace.idEntity}" and descendants saved.`
            : `Overview geometry for "${movedPlace.title || movedPlace.name || movedPlace.idEntity}" saved.`
        );
      })
      .catch(({ err, response }) => {
        window.alert(formatErrorMessage(err, response));
        setSaveMessage('Failed to save overview geometry.');
      });
  };

  const duplicateOverviewChildPlace = (
    parentPlace,
    sourcePlace,
    duplicateName,
    setPlace,
    setSaveMessage,
    afterSave,
    onDone
  ) => {
    const parentIdEntity = parentPlace?.idEntity;
    const sourceIdEntity = sourcePlace?.idEntity;
    const trimmedName = String(duplicateName ?? '').trim();

    if (!parentIdEntity || !sourceIdEntity || !trimmedName) {
      const error = { message: 'Select a child place and provide a name before duplicating.' };
      setSaveMessage(error.message);
      onDone?.(error);
      return;
    }

    setSaveMessage('Duplicating overview place...');
    cdoPlace.duplicateChild(
      {
        parentIdEntity,
        sourceIdEntity,
        name: trimmedName,
      },
      (err, response) => {
        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          setSaveMessage('Failed to duplicate overview place.');
          onDone?.(err || response?.error || { message: 'Failed to duplicate overview place.' }, response);
          return;
        }

        onDone?.(null, response);
        reloadPlaceAfterChildSave(
          parentIdEntity,
          setPlace,
          (reloadErr, reloadResponse) => window.alert(formatErrorMessage(reloadErr, reloadResponse))
        );
        setSaveMessage(`Duplicated "${response?.name || trimmedName}".`);

        if (afterSave) {
          afterSave();
        }
      }
    );
  };

  const regenerateOverviewPlacePath = (roadPlace, setSaveMessage, onDone) => {
    if (!roadPlace?.idEntity) {
      const error = { message: 'Save the road before regenerating its path.' };
      setSaveMessage(error.message);
      onDone?.(error);
      return;
    }

    setSaveMessage(`Generating a terrain-aware path for "${roadPlace.name || roadPlace.entityName || 'road'}"...`);
    cdoPlace.generateRoute(
      {
        place: roadPlace,
        parentIdEntity:
          roadPlace.parentIdEntity ||
          roadPlace.parentPlace?.idEntity ||
          roadPlace.composedOfParents?.[0]?.idEntity ||
          '',
        aogYear: Number(aogYear) || 0,
      },
      (err, response) => {
        if (err || response?.error) {
          const routeError = err || response?.error || { message: 'Failed to generate road path.' };
          window.alert(formatErrorMessage(routeError, response));
          setSaveMessage('Failed to generate terrain-aware road path.');
          onDone?.(routeError, response);
          return;
        }

        setSaveMessage('Terrain-aware road path generated in memory. Review it, then Save to persist it.');
        onDone?.(null, response);
      }
    );
  };

  const loadOverviewContext = useCallback((place, onDone) => {
    cdoPlace.selectOverviewContext({ place: { idEntity: place.idEntity, location: place.location, shape: place.shape,
      imageReference: place.imageReference === true } }, onDone);
  }, []);

  const loadOverviewPlace = useCallback((idEntity, onDone) => {
    if (!idEntity) {
      onDone?.(new Error('Missing place id'));
      return;
    }

    cdoPlace.select(idEntity, (err, response) => {
      if (err || !response) {
        onDone?.(err ?? new Error('Failed to load overview place'), response);
        return;
      }

      onDone?.(null, hydratePlaceMasterTypes(toEditablePlace(response)));
    });
  }, [hydratePlaceMasterTypes]);

  const generateBeingItemSuggestions = (idEntity, setBeing, setIsLoading, setSaveMessage) => {
    if (!idEntity) {
      setSaveMessage('Save the being before generating item suggestions.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');

    cdoBeing.generateItemSuggestions({ idEntity, aogYear: Number(aogYear) || 0 }, (err, response) => {
      setIsLoading(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setBeing(toEditableBeing(response ?? {}));
      setSaveMessage('Item suggestions refreshed.');
    });
  };

  const getRoutineGenerationPlaceIds = (being) => {
    const ids = [
      ...(Array.isArray(being?.routines)
        ? being.routines
            .filter((routine) => {
              const sourceHash = String(routine?.sourceHash ?? '').trim().toLowerCase();
              return !sourceHash || sourceHash === 'editor';
            })
            .map((routine) => routine?.idPlace)
        : []),
      ...(Array.isArray(being?.relationships)
        ? being.relationships
            .filter((relationship) => String(relationship?.otherEntityType ?? '').toLowerCase() === 'place')
            .map((relationship) => relationship?.otherEntityId)
        : []),
    ];

    return [...new Set(ids.map((id) => String(id ?? '').trim()).filter(Boolean))];
  };

  const generateBeingRoutines = (being, setBeing, setIsLoading, setSaveMessage) => {
    if (!being?.idEntity) {
      setSaveMessage('Save the being before generating routines.');
      return;
    }

    const placeIds = getRoutineGenerationPlaceIds(being);
    if (placeIds.length === 0) {
      setSaveMessage('Add a routine row with a place, or add a place relationship, before generating routines.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('Generating routines...');

    cdoBeing.generateRoutines(
      {
        idEntity: being.idEntity,
        placeIds,
        currentTimeMinutes: 600,
        currentTimeLabel: '10:00 AM',
      },
      (err, response) => {
        setIsLoading(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          setSaveMessage('Failed to generate routines.');
          return;
        }

        const stats = response?.routineGenerationStats ?? {};
        setBeing(toEditableBeing(response ?? {}));
        setSaveMessage(`Generated ${stats.routinesGenerated ?? 0} routine(s).`);
      }
    );
  };

  const generateBeingSuggestedItem = (
    beingId,
    suggestion,
    index,
    setBeing,
    setSaveMessage,
    onDone,
    options = {}
  ) => {
    if (!beingId) {
      setSaveMessage('Save the being before creating items from suggestions.');
      if (onDone) {
        onDone({ ok: false, message: 'Save the being before creating items from suggestions.', suggestion });
      }
      return;
    }

    cdoBeing.generateSuggestedItem(
      { beingId, suggestion, aogYear: Number(aogYear) || 0 },
      (err, response) => {
        if (err || response?.error) {
          const message = formatErrorMessage(err, response);
          if (!options.suppressAlert) {
            window.alert(message);
          }
          if (onDone) {
            onDone({ ok: false, err, response, message, suggestion });
          }
          return;
        }

        setBeing((current) => ({
          ...current,
          itemSuggestions: Array.isArray(current?.itemSuggestions)
            ? current.itemSuggestions.filter((_, entryIndex) => entryIndex !== index)
            : [],
          ownedItems: [
            ...(Array.isArray(current?.ownedItems) ? current.ownedItems : []),
            {
              idEntity: response?.idEntity ?? '',
              name: response?.name ?? response?.entityName ?? '',
              title: response?.title ?? response?.entityTitle ?? '',
            },
          ],
        }));
        loadExistingItems();
        setSaveMessage(`Item "${response?.title || response?.name || suggestion?.name || 'Unnamed Item'}" generated and saved.`);
        if (onDone) {
          onDone({ ok: true, response, suggestion });
        }
      }
    );
  };

  const generateAllBeingSuggestedItems = (being, suggestions, setBeing, setSaveMessage, onDone) => {
    const queue = Array.isArray(suggestions) ? suggestions.map((suggestion) => ({ ...suggestion })) : [];

    if (!being?.idEntity) {
      setSaveMessage('Save the being before creating items from suggestions.');
      if (onDone) onDone();
      return;
    }

    if (queue.length === 0) {
      if (onDone) onDone();
      return;
    }

    const failures = [];
    let successCount = 0;

    const createNext = () => {
      if (queue.length === 0) {
        if (failures.length > 0) {
          const summary = failures
            .map(({ suggestion, message }) => `${suggestion?.name || 'Unnamed suggestion'}: ${message}`)
            .join('\n');
          setSaveMessage(`Created ${successCount} item(s). ${failures.length} failed.`);
          window.alert(`Create All finished with partial failures.\n\n${summary}`);
        } else {
          setSaveMessage(`Created ${successCount} item(s).`);
        }
        if (onDone) onDone();
        return;
      }

      const nextSuggestion = queue.shift();
      generateBeingSuggestedItem(
        being.idEntity,
        nextSuggestion,
        0,
        setBeing,
        setSaveMessage,
        (result) => {
          if (result?.ok) {
            successCount += 1;
          } else {
            failures.push({
              suggestion: nextSuggestion,
              message: result?.message || 'Request failed.',
            });
          }
          createNext();
        },
        { suppressAlert: true }
      );
    };

    createNext();
  };

  const generatePlaceSuggestions = (
    idEntity,
    setPlace,
    setIsLoading,
    setSaveMessage,
    suggestionPrompt = '',
    existingChildPlaceSuggestions = []
  ) => {
    if (!idEntity) {
      setSaveMessage('Save the place before generating child place suggestions.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');
    const trimmedPrompt = String(suggestionPrompt ?? '').trim();

    cdoPlace.generateChildSuggestions({
      idEntity,
      aogYear: Number(aogYear) || 0,
      existingChildPlaceSuggestions: Array.isArray(existingChildPlaceSuggestions)
        ? existingChildPlaceSuggestions
        : [],
      ...(trimmedPrompt ? { prompt: trimmedPrompt } : {}),
    }, (err, response) => {
      setIsLoading(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setPlace(hydratePlaceMasterTypes(toEditablePlace(response ?? {})));
      setSaveMessage('Child place suggestions refreshed.');
    });
  };

  const generateParentPlaceDescription = (place, setPlace, setIsLoading, setSaveMessage, guidance = '') => {
    if (!place || (!place.idEntity && !place.name && !place.title)) {
      setSaveMessage('Add place context before generating a description.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('Generating description...');
    const trimmedGuidance = String(guidance ?? '').trim();

    cdoPlace.generateDescription(
      {
        idEntity: place.idEntity,
        parentPlace: place,
        childPlaces: Array.isArray(place.composedOfChildren) ? place.composedOfChildren : [],
        aogYear: Number(aogYear) || 0,
        ...(trimmedGuidance ? { prompt: trimmedGuidance } : {}),
      },
      (err, response) => {
        setIsLoading(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          setSaveMessage('Failed to generate description.');
          return;
        }

        const description = String(response?.description ?? '').trim();
        if (!description) {
          setSaveMessage('The AI did not return a description.');
          return;
        }

        setPlace((current) => ({
          ...current,
          description,
        }));
        setSaveMessage('Description generated. Save to persist.');
      }
    );
  };

  const generatePlaceInhabitantSuggestions = (idEntity, setPlace, setIsLoading, setSaveMessage) => {
    if (!idEntity) {
      setSaveMessage('Save the place before generating inhabitant suggestions.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');

    cdoPlace.generateInhabitantSuggestions({ idEntity, aogYear: Number(aogYear) || 0 }, (err, response) => {
      setIsLoading(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setPlace(hydratePlaceMasterTypes(toEditablePlace(response ?? {})));
      setSaveMessage('Inhabitant suggestions refreshed.');
    });
  };

  const getRelateTypeId = (relateType) => {
    const match = masterTypes.find(
      (masterType) =>
        masterType.column === 'relateType' &&
        String(masterType.value).trim().toLowerCase() === String(relateType ?? '').trim().toLowerCase()
    );

    return match?.idMasterType ?? relateType;
  };

  const enrichRelationshipSuggestions = (suggestions, inhabitants) => {
    const byId = new Map(
      (Array.isArray(inhabitants) ? inhabitants : [])
        .filter((being) => being?.idEntity)
        .map((being) => [String(being.idEntity), being])
    );

    return (Array.isArray(suggestions) ? suggestions : []).map((suggestion) => {
      const source = byId.get(String(suggestion?.sourceEntityId));
      const target = byId.get(String(suggestion?.targetEntityId));

      return {
        sourceEntityId: suggestion?.sourceEntityId ?? '',
        sourceName: source?.title || source?.name || suggestion?.sourceEntityId || '',
        targetEntityId: suggestion?.targetEntityId ?? '',
        targetName: target?.title || target?.name || suggestion?.targetEntityId || '',
        relateType: suggestion?.relateType ?? '',
        reason: suggestion?.reason ?? '',
      };
    });
  };

  const enrichInhabitantPlaceRelationshipSuggestions = (suggestions, place) => {
    const inhabitantsById = new Map(
      (Array.isArray(place?.savedInhabitants) ? place.savedInhabitants : [])
        .filter((being) => being?.idEntity)
        .map((being) => [String(being.idEntity), being])
    );
    const placesById = new Map(
      [place, ...(Array.isArray(place?.composedOfChildren) ? place.composedOfChildren : [])]
        .filter((entry) => entry?.idEntity)
        .map((entry) => [String(entry.idEntity), entry])
    );

    return (Array.isArray(suggestions) ? suggestions : []).map((suggestion) => {
      const source = inhabitantsById.get(String(suggestion?.sourceEntityId));
      const targetPlaceId = suggestion?.targetPlaceId ?? suggestion?.targetEntityId ?? '';
      const target = placesById.get(String(targetPlaceId));

      return {
        sourceEntityId: suggestion?.sourceEntityId ?? '',
        sourceName: source?.title || source?.name || suggestion?.sourceEntityId || '',
        targetEntityId: targetPlaceId,
        targetName: target?.title || target?.name || targetPlaceId || '',
        relateType: suggestion?.relateType ?? '',
        reason: suggestion?.reason ?? '',
      };
    });
  };

  const closeRelationshipModal = () => {
    if (isCreatingRelationshipSuggestions) {
      return;
    }

    setIsRelationshipModalOpen(false);
    setRelationshipSuggestions([]);
    setRelationshipModalMessage('');
  };

  const generatePlaceInhabitantRelationships = (place, setIsLoading, setSaveMessage) => {
    if (!place?.idEntity) {
      setSaveMessage('Save the place before generating inhabitant relationships.');
      return;
    }

    if (!Array.isArray(place?.savedInhabitants) || place.savedInhabitants.length < 2) {
      setSaveMessage('At least two saved inhabitants are required to generate relationships.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');

    const requestData = { idEntity: place.idEntity, aogYear: Number(aogYear) || 0 };
    const requestInhabitantRelationships = () => new Promise((resolve, reject) => {
      cdoPlace.generateInhabitantRelationshipSuggestions(requestData, (err, response) => {
        if (err || response?.error) {
          reject({ err, response });
          return;
        }

        resolve(response);
      });
    });
    const requestInhabitantPlaceRelationships = () => new Promise((resolve, reject) => {
      cdoPlace.generateInhabitantPlaceRelationshipSuggestions(requestData, (err, response) => {
        if (err || response?.error) {
          reject({ err, response });
          return;
        }

        resolve(response);
      });
    });

    Promise.all([
      requestInhabitantRelationships(),
      requestInhabitantPlaceRelationships(),
    ])
      .then(([inhabitantResponse, inhabitantPlaceResponse]) => {
        setRelationshipSuggestions([
          ...enrichRelationshipSuggestions(
            inhabitantResponse?.relationshipSuggestions,
            place.savedInhabitants
          ),
          ...enrichInhabitantPlaceRelationshipSuggestions(
            inhabitantPlaceResponse?.relationshipSuggestions,
            place
          ),
        ]);
        setRelationshipModalTitle('Being Relationships');
        setRelationshipModalCopy('Review suggested relationships among saved inhabitants and to their place tree.');
        setRelationshipModalMessage('');
        setIsRelationshipModalOpen(true);
      })
      .catch(({ err, response }) => {
        window.alert(formatErrorMessage(err, response));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const generatePlaceInhabitantPlaceRelationships = (place, setIsLoading, setSaveMessage) => {
    if (!place?.idEntity) {
      setSaveMessage('Save the place before generating inhabitant/place relationships.');
      return;
    }

    if (!Array.isArray(place?.savedInhabitants) || place.savedInhabitants.length === 0) {
      setSaveMessage('At least one saved inhabitant is required to generate place relationships.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');

    cdoPlace.generateInhabitantPlaceRelationshipSuggestions(
      { idEntity: place.idEntity, aogYear: Number(aogYear) || 0 },
      (err, response) => {
        setIsLoading(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setRelationshipSuggestions(
          enrichInhabitantPlaceRelationshipSuggestions(response?.relationshipSuggestions, place)
        );
        setRelationshipModalTitle('Inhabitant Place Relationships');
        setRelationshipModalCopy('Review suggested relationships between saved inhabitants and the current place tree.');
        setRelationshipModalMessage('');
        setIsRelationshipModalOpen(true);
      }
    );
  };

  const createAllRelationshipSuggestions = () => {
    const queue = Array.isArray(relationshipSuggestions)
      ? relationshipSuggestions.map((suggestion) => ({ ...suggestion }))
      : [];

    if (queue.length === 0) {
      setRelationshipModalMessage('No relationship suggestions to create.');
      return;
    }

    setIsCreatingRelationshipSuggestions(true);
    setRelationshipModalMessage('');

    const failures = [];
    let successCount = 0;

    const createNext = () => {
      if (queue.length === 0) {
        setIsCreatingRelationshipSuggestions(false);

        if (failures.length > 0) {
          const summary = failures
            .map(({ suggestion, message }) =>
              `${suggestion.sourceName} -> ${suggestion.targetName} (${suggestion.relateType}): ${message}`
            )
            .join('\n');
          setRelationshipModalMessage(`Created ${successCount} relationship(s). ${failures.length} failed.`);
          window.alert(`Create All finished with partial failures.\n\n${summary}`);
          setRelationshipSuggestions(failures.map(({ suggestion }) => suggestion));
          return;
        }

        setRelationshipModalMessage(`Created ${successCount} relationship(s).`);
        setRelationshipSuggestions([]);
        return;
      }

      const nextSuggestion = queue.shift();
      cdoEntityRelate.create(
        {
          idEntity: nextSuggestion.sourceEntityId,
          idRelated: nextSuggestion.targetEntityId,
          relateType: getRelateTypeId(nextSuggestion.relateType),
        },
        (err, response) => {
          if (err || response?.error) {
            failures.push({
              suggestion: nextSuggestion,
              message: formatErrorMessage(err, response),
            });
          } else {
            successCount += 1;
          }

          createNext();
        }
      );
    };

    createNext();
  };

  const generatePlaceInhabitant = (idEntity, suggestion, index, setPlace, setSaveMessage, onDone) => {
    if (!idEntity) {
      setSaveMessage('Save the place before generating beings from inhabitant suggestions.');
      if (onDone) onDone();
      return;
    }

    const memberOfPlaceId = suggestion?.memberOfPlaceId || idEntity;

    cdoPlace.generateInhabitant(
      { parentIdEntity: memberOfPlaceId, suggestion, aogYear: Number(aogYear) || 0 },
      (err, response) => {
        if (onDone) onDone();

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        setPlace((current) => {
          const savedInCurrentPlace = String(memberOfPlaceId) === String(idEntity);
          return {
            ...current,
            inhabitantSuggestions: Array.isArray(current?.inhabitantSuggestions)
              ? current.inhabitantSuggestions.filter((_, entryIndex) => entryIndex !== index)
              : [],
            savedInhabitants: savedInCurrentPlace
              ? [
                  ...(Array.isArray(current?.savedInhabitants) ? current.savedInhabitants : []),
                  {
                    idEntity: response?.idEntity ?? '',
                    name: response?.name ?? response?.entityName ?? '',
                    title: response?.title ?? response?.entityTitle ?? '',
                    description: response?.description ?? '',
                    level: response?.level ?? '',
                    beingType: response?.beingType ?? '',
                    alignment: response?.alignment ?? '',
                    personality: response?.personality ?? '',
                  },
                ]
              : current?.savedInhabitants ?? [],
          };
        });
        loadExistingBeings();
        setSaveMessage(`Being "${response?.title || response?.name || suggestion?.name || 'Unnamed Being'}" generated and saved.`);
      }
    );
  };

  const generateAllPlaceInhabitants = (place, suggestions, setPlace, setSaveMessage, onDone) => {
    const placeIdEntity = place?.idEntity;
    const queue = Array.isArray(suggestions) ? suggestions.map((suggestion) => ({ ...suggestion })) : [];

    if (!placeIdEntity) {
      setSaveMessage('Save the place before creating beings from inhabitant suggestions.');
      if (onDone) onDone();
      return;
    }

    if (queue.length === 0) {
      if (onDone) onDone();
      return;
    }

    const failures = [];
    let successCount = 0;

    const createNext = () => {
      if (queue.length === 0) {
        if (failures.length > 0) {
          const summary = failures
            .map(({ suggestion, message }) => `${suggestion?.name || 'Unnamed suggestion'}: ${message}`)
            .join('\n');
          setSaveMessage(`Created ${successCount} inhabitant(s). ${failures.length} failed.`);
          window.alert(`Create All finished with partial failures.\n\n${summary}`);
        } else {
          setSaveMessage(`Created ${successCount} inhabitant(s).`);
        }
        if (onDone) onDone();
        return;
      }

      const nextSuggestion = queue.shift();
      const memberOfPlaceId = nextSuggestion?.memberOfPlaceId || placeIdEntity;

      cdoPlace.generateInhabitant(
        { parentIdEntity: memberOfPlaceId, suggestion: nextSuggestion, aogYear: Number(aogYear) || 0 },
        (err, response) => {
          if (err || response?.error) {
            failures.push({
              suggestion: nextSuggestion,
              message: formatErrorMessage(err, response),
            });
            createNext();
            return;
          }

          successCount += 1;
          setPlace((current) => {
            const savedInCurrentPlace = String(memberOfPlaceId) === String(placeIdEntity);
            return {
              ...current,
              inhabitantSuggestions: Array.isArray(current?.inhabitantSuggestions)
                ? current.inhabitantSuggestions.filter((_, entryIndex) => entryIndex !== 0)
                : [],
              savedInhabitants: savedInCurrentPlace
                ? [
                    ...(Array.isArray(current?.savedInhabitants) ? current.savedInhabitants : []),
                    {
                      idEntity: response?.idEntity ?? '',
                      name: response?.name ?? response?.entityName ?? '',
                      title: response?.title ?? response?.entityTitle ?? '',
                      description: response?.description ?? '',
                      level: response?.level ?? '',
                      beingType: response?.beingType ?? '',
                      alignment: response?.alignment ?? '',
                      personality: response?.personality ?? '',
                    },
                  ]
                : current?.savedInhabitants ?? [],
            };
          });
          loadExistingBeings();
          createNext();
        }
      );
    };

    createNext();
  };

  const generatePlaceItemSuggestions = (idEntity, setPlace, setIsLoading, setSaveMessage) => {
    if (!idEntity) {
      setSaveMessage('Save the place before generating item suggestions.');
      return;
    }

    setIsLoading(true);
    setSaveMessage('');

    cdoPlace.generateItemSuggestions({ idEntity, aogYear: Number(aogYear) || 0 }, (err, response) => {
      setIsLoading(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      setPlace(hydratePlaceMasterTypes(toEditablePlace(response ?? {})));
      setSaveMessage('Item suggestions refreshed.');
    });
  };

  const generatePlaceContainedItem = (placeId, suggestion, index, setPlace, setSaveMessage, onDone, options = {}) => {
    if (!placeId) {
      setSaveMessage('Save the place before creating items from suggestions.');
      if (onDone) {
        onDone({ ok: false, message: 'Save the place before creating items from suggestions.', suggestion });
      }
      return;
    }

    cdoPlace.generateContainedItem(
      { placeId, suggestion, aogYear: Number(aogYear) || 0 },
      (err, response) => {
        if (err || response?.error) {
          const message = formatErrorMessage(err, response);
          if (!options.suppressAlert) {
            window.alert(message);
          }
          if (onDone) {
            onDone({ ok: false, err, response, message, suggestion });
          }
          return;
        }

        setPlace((current) => ({
          ...current,
          itemSuggestions: Array.isArray(current?.itemSuggestions)
            ? current.itemSuggestions.filter((_, entryIndex) => entryIndex !== index)
            : [],
          containedItems: [
            ...(Array.isArray(current?.containedItems) ? current.containedItems : []),
            {
              idEntity: response?.idEntity ?? '',
              name: response?.name ?? response?.entityName ?? '',
              title: response?.title ?? response?.entityTitle ?? '',
              description: response?.description ?? response?.entityDesc ?? '',
              level: response?.level ?? '',
            },
          ],
        }));
        loadExistingItems();
        setSaveMessage(`Item "${response?.title || response?.name || suggestion?.name || 'Unnamed Item'}" created and saved.`);
        if (onDone) {
          onDone({ ok: true, response, suggestion });
        }
      }
    );
  };

  const generateAllPlaceContainedItems = (place, suggestions, setPlace, setSaveMessage, onDone) => {
    const queue = Array.isArray(suggestions) ? suggestions.map((suggestion) => ({ ...suggestion })) : [];

    if (!place?.idEntity) {
      setSaveMessage('Save the place before creating items from suggestions.');
      if (onDone) onDone();
      return;
    }

    if (queue.length === 0) {
      if (onDone) onDone();
      return;
    }

    const failures = [];
    let successCount = 0;

    const createNext = () => {
      if (queue.length === 0) {
        if (failures.length > 0) {
          const summary = failures
            .map(({ suggestion, message }) => `${suggestion?.name || 'Unnamed suggestion'}: ${message}`)
            .join('\n');
          setSaveMessage(`Created ${successCount} item(s). ${failures.length} failed.`);
          window.alert(`Create All finished with partial failures.\n\n${summary}`);
        } else {
          setSaveMessage(`Created ${successCount} item(s).`);
        }
        if (onDone) onDone();
        return;
      }

      const nextSuggestion = queue.shift();
      generatePlaceContainedItem(
        place.idEntity,
        nextSuggestion,
        0,
        setPlace,
        setSaveMessage,
        (result) => {
          if (result?.ok) {
            successCount += 1;
          } else {
            failures.push({
              suggestion: nextSuggestion,
              message: result?.message || 'Request failed.',
            });
          }
          createNext();
        },
        { suppressAlert: true }
      );
    };

    createNext();
  };

  const generateAllPlaceSuggestionChildren = (parentPlace, suggestions, setPlace, setSaveMessage, onDone, sourcePrompt = '') => {
    const parentIdEntity = parentPlace?.idEntity;
    const suggestionList = Array.isArray(suggestions) ? suggestions.filter(Boolean) : [];

    if (!parentIdEntity) {
      setSaveMessage('Save the place before generating child places.');
      if (onDone) onDone();
      return;
    }

    if (suggestionList.length === 0) {
      setSaveMessage('No child place suggestions to generate.');
      if (onDone) onDone();
      return;
    }

    setSaveMessage(`Generating ${suggestionList.length} child place suggestions...`);

    const generateChildFromSuggestion = (suggestion) =>
      new Promise((resolve) => {
        cdoPlace.generateChild(
          { parentIdEntity, suggestion, aogYear: Number(aogYear) || 0, prompt: sourcePrompt },
          (err, response) => {
            resolve({ suggestion, err, response });
          }
        );
      });

    suggestionList
      .reduce(
        (chain, suggestion) =>
          chain.then(async (results) => {
            const result = await generateChildFromSuggestion(suggestion);
            return [...results, result];
          }),
        Promise.resolve([])
      )
      .then((results) => {
        const successfulResults = results.filter(({ err, response }) => !err && !response?.error);
        const failedResults = results.filter(({ err, response }) => err || response?.error);

        if (failedResults.length > 0) {
          const failureText = failedResults
            .map(({ err, response, suggestion }) => `${suggestion?.name || 'Unnamed suggestion'}: ${formatErrorMessage(err, response)}`)
            .join('\n');
          window.alert(`Some child places failed to generate:\n${failureText}`);
        }

        if (successfulResults.length === 0) {
          setSaveMessage('No child places were generated.');
          return;
        }

        return new Promise((resolve) => {
          cdoPlace.select(parentIdEntity, (err, response) => {
            if (err || !response) {
              window.alert(formatErrorMessage(err, response));
              setSaveMessage(
                `Generated ${successfulResults.length} child place${successfulResults.length === 1 ? '' : 's'}, but failed to reload the parent.`
              );
              resolve();
              return;
            }

            const refreshedPlace = hydratePlaceMasterTypes(toEditablePlace(response));
            const successfulSuggestions = successfulResults.map(({ suggestion }) => suggestion);
            setPlace((current) => ({
              ...refreshedPlace,
              childPlaceSuggestions: Array.isArray(current?.childPlaceSuggestions)
                ? current.childPlaceSuggestions.filter(
                    (suggestion) => !successfulSuggestions.some((savedSuggestion) => samePlaceSuggestion(suggestion, savedSuggestion))
                  )
                : [],
            }));
            setSaveMessage(
              `Generated ${successfulResults.length} child place${successfulResults.length === 1 ? '' : 's'}${
                failedResults.length > 0 ? `; ${failedResults.length} failed` : ''
              }.`
            );
            resolve();
          });
        });
      })
      .finally(() => {
        if (onDone) onDone();
      });
  };

  const deletePlace = useCallback(
    (place, setIsSaving, setSaveMessage, afterDelete) => {
      if (!place?.idEntity) {
        setSaveMessage('Select a saved place before deleting.');
        return;
      }

      const placeLabel = place.name || place.title || place.idEntity;
      if (!window.confirm(
        `Delete place "${placeLabel}" and all of its sub-places, inhabitants, and associated items?\n\nThis cannot be undone.`
      )) {
        return;
      }

      setIsSaving(true);
      setSaveMessage('');

      cdoPlace.delete({ idEntity: place.idEntity }, (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        if (afterDelete) {
          afterDelete(place.idEntity);
        }

        loadExistingPlaces();
        loadExistingBeings();
        loadExistingItems();
        const deletedCounts = response?.deleted;
        setSaveMessage(
          deletedCounts
            ? `Deleted ${deletedCounts.places} place${deletedCounts.places === 1 ? '' : 's'}, ${deletedCounts.inhabitants} inhabitant${deletedCounts.inhabitants === 1 ? '' : 's'}, and ${deletedCounts.items} item${deletedCounts.items === 1 ? '' : 's'}.`
            : `Deleted place ${place.idEntity}.`
        );
      });
    },
    [loadExistingBeings, loadExistingItems, loadExistingPlaces]
  );

  const handleExistingPlaceDeleted = useCallback(
    (deletedId) => {
      setExistingPlace(createEmptyPlace());
      setExistingPlaces([]);
      if (selectedExistingPlaceId === deletedId) {
        setSelectedExistingPlaceId('');
      }
    },
    [selectedExistingPlaceId]
  );

  const duplicateItem = (item, setItem, setIsSaving, setSaveMessage, afterDuplicate) => {
    if (!item?.idEntity) {
      setSaveMessage('Save the item before duplicating it.');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    cdoItem.duplicate({ idEntity: item.idEntity }, (err, response) => {
      setIsSaving(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      const duplicatedId = response?.idEntity;
      loadExistingItems();

      if (!duplicatedId) {
        setSaveMessage('Item duplicated.');
        if (afterDuplicate) {
          afterDuplicate('');
        }
        return;
      }

      cdoItem.select(duplicatedId, (selectErr, selectResponse) => {
        if (selectErr || !selectResponse) {
          window.alert(formatErrorMessage(selectErr, selectResponse));
          return;
        }

        setItem(toEditableItem(selectResponse));
        setSaveMessage(`Duplicated item ${duplicatedId}.`);

        if (afterDuplicate) {
          afterDuplicate(duplicatedId);
        }
      });
    });
  };

  const deleteItem = useCallback(
    (item, setIsSaving, setSaveMessage, afterDelete) => {
      if (!item?.idEntity) {
        setSaveMessage('Select a saved item before deleting.');
        return;
      }

      const itemLabel = item.name || item.title || item.idEntity;
      if (!window.confirm(`Delete item "${itemLabel}"?`)) {
        return;
      }

      setIsSaving(true);
      setSaveMessage('');

      cdoItem.delete({ idEntity: item.idEntity }, (err, response) => {
        setIsSaving(false);

        if (err || response?.error) {
          window.alert(formatErrorMessage(err, response));
          return;
        }

        if (afterDelete) {
          afterDelete(item.idEntity);
        }

        loadExistingItems();
        setSaveMessage(`Deleted item ${item.idEntity}.`);
      });
    },
    [loadExistingItems]
  );

  const handleExistingItemDeleted = useCallback(
    (deletedId) => {
      setExistingItem(createEmptyItem());
      setExistingItems([]);
      if (selectedExistingItemId === deletedId) {
        setSelectedExistingItemId('');
      }
    },
    [selectedExistingItemId]
  );

  const copyJson = async (value, emptyFactory, setSaveMessage, label) => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(value ?? emptyFactory(), null, 2));
      setSaveMessage(`Copied ${label} JSON to clipboard.`);
    } catch {
      window.alert('Unable to copy JSON to the clipboard.');
    }
  };

  const formatStoredJson = (jsonText) => {
    if (!jsonText) {
      return '';
    }

    try {
      return JSON.stringify(JSON.parse(jsonText), null, 2);
    } catch {
      return String(jsonText);
    }
  };

  const openTokenUsageLog = () => {
    setIsTokenUsageLogOpen(true);
    setTokenUsageCopyMessage('');
    loadTokenUsageLog();
  };

  const closeTokenUsageLog = () => {
    setIsTokenUsageLogOpen(false);
    setTokenUsageCopyMessage('');
  };

  const loadTokenUsageLog = () => {
    setIsTokenUsageLogLoading(true);
    setTokenUsageLogError('');

    cdoAITokenUsage.recent(50, (err, response) => {
      setIsTokenUsageLogLoading(false);

      if (err || response?.error) {
        setTokenUsageLogError(formatErrorMessage(err, response));
        return;
      }

      setTokenUsageLog(Array.isArray(response) ? response : []);
    });
  };

  const copyTokenUsageJson = async (jsonText, label) => {
    try {
      await navigator.clipboard.writeText(formatStoredJson(jsonText));
      setTokenUsageCopyMessage(`Copied ${label} JSON to clipboard.`);
    } catch {
      window.alert(`Unable to copy ${label} JSON to the clipboard.`);
    }
  };

  const openBeingJsonModal = (target) => {
    setBeingJsonTarget(target);
    setBeingJsonDraft('');
    setBeingJsonError('');
    setIsBeingJsonModalOpen(true);
  };

  const closeBeingJsonModal = () => {
    setIsBeingJsonModalOpen(false);
    setBeingJsonDraft('');
    setBeingJsonError('');
  };

  const applyBeingJson = () => {
    try {
      const parsed = JSON.parse(beingJsonDraft);
      const nextBeing = toEditableBeing(parsed);

      if (beingJsonTarget === 'existing') {
        setExistingBeing(nextBeing);
        setExistingBeingSaveMessage('Loaded being JSON into the editor.');
      } else {
        setGeneratedBeing(nextBeing);
        setGeneratedItem(null);
        setGeneratedSaveMessage('Loaded being JSON into the editor.');
      }

      closeBeingJsonModal();
    } catch {
      setBeingJsonError('Invalid JSON. Check the pasted content and try again.');
    }
  };

  const updateReferenceField = (field, nextValue) => {
    setReferenceEditorValue((current) => ({
      ...(current ?? activeReferenceConfig.emptyFactory()),
      [field]: nextValue,
    }));
  };

  const selectReferenceRow = (recordId) => {
    setSelectedReferenceId(recordId);
    setReferenceSaveMessage('');
    setReferenceEditorValue(null);
  };

  const editReferenceRow = (recordId) => {
    const config = referenceConfigs[referenceTable];
    const record = referenceRecords.find((row) => String(row[config.idField]) === String(recordId));

    if (!record) {
      return;
    }

    setSelectedReferenceId(recordId);
    setReferenceSaveMessage('');
    setReferenceEditorValue({ ...config.emptyFactory(), ...record });
  };

  const addNewReferenceRow = () => {
    setSelectedReferenceId('__new__');
    setReferenceSaveMessage('');
    setReferenceEditorValue(activeReferenceConfig.emptyFactory());
  };

  const saveReferenceRecord = () => {
    if (!referenceEditorValue) {
      return;
    }

    const config = activeReferenceConfig;
    const payload = config.normalize(referenceEditorValue);
    const validationMessage = config.validate(payload);

    if (validationMessage) {
      setReferenceSaveMessage(validationMessage);
      return;
    }

    setIsReferenceSaving(true);
    setReferenceSaveMessage('');

    const isNewReference = selectedReferenceId === '__new__';
    const saveFn = isNewReference ? config.create : config.update;

    saveFn(payload, (err, response) => {
      setIsReferenceSaving(false);

      if (err || response?.error) {
        window.alert(formatErrorMessage(err, response));
        return;
      }

      const responseInsertId =
        response && typeof response.insertId === 'number' && response.insertId > 0 ? response.insertId : null;
      const savedRecord = {
        ...payload,
        ...(response?.[config.idField] ? { [config.idField]: response[config.idField] } : {}),
        ...(isNewReference && responseInsertId !== null ? { [config.idField]: responseInsertId } : {}),
      };
      const savedId = String(savedRecord[config.idField] ?? '');

      setReferenceRecords((current) => {
        if (isNewReference) {
          return [...current, savedRecord];
        }

        return current.map((record) =>
          String(record[config.idField]) === String(payload[config.idField]) ? { ...record, ...savedRecord } : record
        );
      });

      if (savedId) {
        setSelectedReferenceId(savedId);
      }

      setReferenceEditorValue(null);
      setReferenceSaveMessage(`Saved ${referenceTable} record.`);

      if (referenceTable === 'MasterType') {
        loadMasterTypes();
      }

      if (referenceTable === 'MaterialList') {
        loadItemMetadata();
      }
    });
  };

  const deleteReferenceRecord = (recordId) => {
    const config = activeReferenceConfig;
    if (!config.delete || !window.confirm(`Delete this ${referenceTable} record?`)) return;
    setIsReferenceSaving(true);
    config.delete({ [config.idField]: recordId }, (err, response) => {
      setIsReferenceSaving(false);
      if (err || response?.error) { setReferenceSaveMessage(formatErrorMessage(err, response)); return; }
      setReferenceRecords(current => current.filter(record => String(record[config.idField]) !== String(recordId)));
      setReferenceEditorValue(null);
      setSelectedReferenceId('');
      setReferenceSaveMessage(`Deleted ${referenceTable} record.`);
    });
  };

  return (
    <div className="App">
      <main className="generator-layout">
        <section className="panel app-tabs-panel">
          <div className="editor-mode-toolbar">
            <div className="app-tabs" role="tablist" aria-label="App mode">
              {appTabConfig.map((tab) => (
                <button
                  key={tab.label}
                  type="button"
                  role="tab"
                  className={`app-tab ${activeTab === tab.label ? 'active' : ''}`}
                  aria-selected={activeTab === tab.label}
                  onClick={() => setActiveTab(tab.label)}
                >
                  <span className="button-content">
                    {tab.icon}
                    <span>{tab.label}</span>
                  </span>
                </button>
              ))}
            </div>
            <button type="button" className="secondary-button button-with-icon" onClick={openTokenUsageLog}>
              <LogIcon /><span>AI Log</span>
            </button>
          </div>
        </section>

        {activeTab === 'Edit Existing' && (
          <section className="panel app-tabs-panel">
            <div className="app-tabs" role="tablist" aria-label="Existing editor type">
              {editExistingTabConfig.map((tab) => (
                <button
                  key={tab.label}
                  type="button"
                  role="tab"
                  className={`app-tab ${editExistingTab === tab.label ? 'active' : ''}`}
                  aria-selected={editExistingTab === tab.label}
                  onClick={() => setEditExistingTab(tab.label)}
                >
                  <span className="button-content edit-subtab-content">
                    {tab.icon}
                    <span>{tab.label}</span>
                  </span>
                </button>
              ))}
            </div>
          </section>
        )}

        {activeTab === 'Generate New' && (
          <section className="panel app-tabs-panel">
            <div className="app-tabs" role="tablist" aria-label="Generator type">
              {generatorTabConfig.map((tab) => (
                <button
                  key={tab.label}
                  type="button"
                  role="tab"
                  className={`app-tab ${generatorType === tab.label ? 'active' : ''}`}
                  aria-selected={generatorType === tab.label}
                  onClick={() => setGeneratorType(tab.label)}
                >
                  <span className="button-content edit-subtab-content">
                    {tab.icon}
                    <span>{tab.label}</span>
                  </span>
                </button>
              ))}
            </div>
          </section>
        )}

        {activeTab === 'Test' && (
          <section className="panel app-tabs-panel">
            <div className="app-tabs" role="tablist" aria-label="Test mode">
              {testTabConfig.map((tab) => (
                <button
                  key={tab.label}
                  type="button"
                  role="tab"
                  className={`app-tab ${testTab === tab.label ? 'active' : ''}`}
                  aria-selected={testTab === tab.label}
                  onClick={() => setTestTab(tab.label)}
                >
                  <span className="button-content">
                    <span>{tab.label}</span>
                  </span>
                </button>
              ))}
            </div>
          </section>
        )}

        {activeTab === 'Reference' && (
          <section className="panel app-tabs-panel">
            <div className="reference-toolbar">
              <label htmlFor="reference-table-select" className="editor-field reference-select-field">
                <span className="field-label">Reference Table</span>
                <select
                  id="reference-table-select"
                  className="select-input"
                  disabled={isReferenceSaving}
                  value={referenceTable}
                  onChange={(event) => setReferenceTable(event.target.value)}
                >
                  {referenceTableOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </section>
        )}

        {activeTab === 'Mythos' && (
          <section className="panel">
            <div className="panel-header-row">
              <div>
                <h2>Mythos</h2>
                <p className="panel-copy">Browse the Mythos chapters loaded from the server.</p>
              </div>
              <button
                type="button"
                className="secondary-button button-with-icon"
                onClick={loadMythosChapters}
                disabled={isLoadingMythos}
              >
                <RefreshIcon />
                <span>{isLoadingMythos ? 'Loading...' : 'Refresh'}</span>
              </button>
            </div>

            <div className="existing-layout">
              <aside className="existing-list-panel">
                <div className="existing-list-header">
                  <h3>Chapters</h3>
                </div>
                <div className="existing-list">
                  {mythosChapters.map((chapter) => (
                    <button
                      key={chapter.chapterNumber}
                      type="button"
                      className={`existing-list-item ${
                        String(selectedMythosChapterNumber) === String(chapter.chapterNumber) ? 'active' : ''
                      }`}
                      onClick={() => setSelectedMythosChapterNumber(String(chapter.chapterNumber))}
                    >
                      <span className="existing-list-name">{chapter.chapterTitle}</span>
                    </button>
                  ))}
                  {mythosChapters.length === 0 && !isLoadingMythos && !mythosError && (
                    <div className="empty-grid">No Mythos chapters found.</div>
                  )}
                </div>
              </aside>

              <div className="existing-editor-panel">
                {isLoadingMythos ? (
                  <div className="empty-grid">Loading Mythos chapters...</div>
                ) : mythosError ? (
                  <div className="form-error">{mythosError}</div>
                ) : selectedMythosChapter ? (
                  <section className="editor-section mythos-content-panel">
                    <div className="mythos-chapter-content">
                      {selectedMythosChapter.content.split(/\r?\n/).map((line, index) => {
                        if (!line.trim()) {
                          return (
                            <div
                              key={`${selectedMythosChapter.chapterNumber}-spacer-${index}`}
                              className="mythos-paragraph-spacer"
                              aria-hidden="true"
                            />
                          );
                        }

                        return (
                          <p
                            key={`${selectedMythosChapter.chapterNumber}-line-${index}`}
                            className={`mythos-paragraph ${index === 0 ? 'mythos-title-line' : ''}`}
                          >
                            {line}
                          </p>
                        );
                      })}
                    </div>
                  </section>
                ) : (
                  <div className="empty-grid">Select a chapter to read.</div>
                )}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Generate New' && (
          <>
            {(generatorType === 'Place Tree' || generatorType === 'Town') && (
              <GenerateTown placeOptions={routinePlaceOptions} />
            )}

            {generatorType !== 'Place Tree' && generatorType !== 'Town' && (
            <>
            <section className="panel">
              <div className="top-controls">
                <label htmlFor="aog-year-input" className="year-field">
                  <span className="field-label">AoG Year</span>
                  <input
                    id="aog-year-input"
                    className="text-input year-input"
                    type="number"
                    min="0"
                    max="21000"
                    step="1"
                    value={aogYear}
                    onChange={(event) => setAogYear(event.target.value)}
                    placeholder="0 to 21000"
                  />
                </label>
              </div>

              <form onSubmit={handleSubmit} className="generator-form">
                <label htmlFor="prompt-input" className="field-label">
                  Prompt
                </label>
                <textarea
                  id="prompt-input"
                  className="text-area input-area"
                  value={prompt}
                  onChange={(event) => setPrompt(event.target.value)}
                  placeholder="Describe what you want Adenrel Generator to produce..."
                />
                {generatorType === 'Place' && (
                  <label htmlFor="place-parent-input" className="field-label">
                    Parent Place
                    <select
                      id="place-parent-input"
                      className="select-input"
                      value={selectedGeneratedPlaceParentId}
                      onChange={(event) => setSelectedGeneratedPlaceParentId(event.target.value)}
                    >
                      <option value="">No parent selected</option>
                      {routinePlaceOptions.map((option) => (
                        <option key={`place-parent-${option.value}`} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </label>
                )}
                {generatorType === 'Being' && (
                  <label className="generator-switch-control">
                    <input
                      type="checkbox"
                      checked={limitExistingBeingContextToGods}
                      onChange={(event) => setLimitExistingBeingContextToGods(event.target.checked)}
                    />
                    <span className="generator-switch-track" aria-hidden="true">
                      <span className="generator-switch-thumb" />
                    </span>
                    <span>Use only gods for existing being context</span>
                  </label>
                )}
                {formError && <div className="form-error">{formError}</div>}
                <div className="button-row">
                  {generatorType === 'Being' && (
                    <button
                      type="button"
                      className="secondary-button button-with-icon"
                      onClick={() => openBeingJsonModal('generated')}
                    >
                      <PencilIcon />
                      <span>+ JSON</span>
                    </button>
                  )}
                  <button type="submit" disabled={isSubmitting} className="button-with-icon">
                    <SendIcon />
                    <span>{isSubmitting ? 'Submitting...' : 'Submit'}</span>
                  </button>
                </div>
              </form>
            </section>

            {generatedImage && generatorType === 'Image' && (
              <section className="panel generated-image-panel">
                <div className="panel-header-row">
                  <div>
                    <h2>Generated Image</h2>
                    <p className="panel-copy">Image generated from the prompt and Adenrel Mythos context.</p>
                  </div>
                </div>
                <div className="generated-image-frame">
                  <MediaImage
                    className="generated-image-preview"
                    src={`data:${generatedImage.mimeType || 'image/png'};base64,${generatedImage.imageBase64}`}
                    alt="Generated Adenrel scene."
                  />
                </div>
                {generatedImage.revisedPrompt && (
                  <p className="generated-image-prompt">{generatedImage.revisedPrompt}</p>
                )}
              </section>
            )}

            {generatedBeing && (
              <BeingEditor aogYear={aogYear}
                value={generatedBeing}
                onChange={setGeneratedBeing}
                onSave={() =>
                  saveBeing(
                    generatedBeing,
                    setGeneratedBeing,
                    setIsGeneratedSaving,
                    setGeneratedSaveMessage,
                    (savedId) => loadBeingPortrait(savedId, setGeneratedBeingPortrait, true, generatedBeingPortraitLoadRef)
                  )
                }
                onCopyJson={() => copyJson(generatedBeing, createEmptyBeing, setGeneratedSaveMessage, 'being')}
                isSaving={isGeneratedSaving}
                saveMessage={generatedSaveMessage}
                getMasterTypeOptions={getMasterTypeOptions}
                spellListOptions={spellListOptions}
                spellUsageOptions={spellUsageOptions}
                currencyOptions={currencyOptions}
                placeOptions={routinePlaceOptions}
                onRemoveForm={(index, form) => removeFormRow(setGeneratedBeing, index, form)}
                onRemoveSpell={(index, spell) => removeSpellRow(setGeneratedBeing, index, spell)}
                onGenerateItemSuggestions={() =>
                  generateBeingItemSuggestions(
                    generatedBeing.idEntity,
                    setGeneratedBeing,
                    setIsGeneratedBeingItemSuggestionLoading,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateSuggestedItem={(suggestion, index) =>
                  generateBeingSuggestedItem(
                    generatedBeing.idEntity,
                    suggestion,
                    index,
                    setGeneratedBeing,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateAllItemSuggestions={(suggestions) =>
                  {
                    setIsGeneratedBeingItemBulkCreating(true);
                    generateAllBeingSuggestedItems(
                      generatedBeing,
                      suggestions,
                      setGeneratedBeing,
                      setGeneratedSaveMessage,
                      () => setIsGeneratedBeingItemBulkCreating(false)
                    );
                  }
                }
                onGenerateRoutines={() =>
                  generateBeingRoutines(
                    generatedBeing,
                    setGeneratedBeing,
                    setIsGeneratedBeingRoutineGenerating,
                    setGeneratedSaveMessage
                  )
                }
                onDeleteRelationship={(relationship, index) =>
                  deleteBeingRelationship(
                    relationship,
                    index,
                    setGeneratedBeing,
                    setIsGeneratedSaving,
                    setGeneratedSaveMessage
                  )
                }
                relationshipTargetOptions={getBeingRelationshipTargetOptions(generatedBeing.idEntity)}
                relateTypeOptions={relateTypeOptions}
                isGeneratingItemSuggestions={isGeneratedBeingItemSuggestionLoading}
                isCreatingAllItemSuggestions={isGeneratedBeingItemBulkCreating}
                isGeneratingRoutines={isGeneratedBeingRoutineGenerating}
                portrait={generatedBeingPortrait}
                canGeneratePortrait={Boolean(generatedBeing.idEntity && !generatedBeingPortrait.isLoadingSavedImage)}
                canSavePortrait={Boolean(generatedBeing.idEntity && generatedBeingPortrait.src && !generatedBeingPortrait.isSaved)}
                onGeneratePortrait={() =>
                  generateBeingPortrait(generatedBeing, setGeneratedBeingPortrait, setGeneratedSaveMessage, {
                    onGenerated: (generatedPortrait) => {
                      if (generatedBeingPortrait.hasCheckedSavedImage && !generatedBeingPortrait.src) {
                        saveBeingPortrait(
                          generatedBeing,
                          generatedPortrait,
                          setGeneratedBeingPortrait,
                          setGeneratedSaveMessage
                        );
                      }
                    },
                  })
                }
                onSavePortrait={() =>
                  saveBeingPortrait(
                    generatedBeing,
                    generatedBeingPortrait,
                    setGeneratedBeingPortrait,
                    setGeneratedSaveMessage
                  )
                }
              />
            )}

            {generatedItem && generatorType === 'Item' && (
              <ItemEditor
                value={generatedItem}
                onChange={setGeneratedItem}
                onSave={() =>
                  saveItem(generatedItem, setGeneratedItem, setIsGeneratedSaving, setGeneratedSaveMessage)
                }
                onCopyJson={() => copyJson(generatedItem, createEmptyItem, setGeneratedSaveMessage, 'item')}
                onDuplicate={() =>
                  duplicateItem(generatedItem, setGeneratedItem, setIsGeneratedSaving, setGeneratedSaveMessage)
                }
                isSaving={isGeneratedSaving}
                saveMessage={generatedSaveMessage}
                getMasterTypeOptions={getMasterTypeOptions}
                spellListOptions={spellListOptions}
                spellUsageOptions={spellUsageOptions}
                ownerOptions={ownerOptions}
                containedByOptions={containedByOptions}
                itemRelationshipOptions={itemRelationshipOptions}
                onAssignOwner={(ownerId, onComplete) =>
                  assignItemOwner(
                    generatedItem,
                    setGeneratedItem,
                    setIsGeneratedItemOwnerSaving,
                    setGeneratedSaveMessage,
                    ownerId,
                    onComplete
                  )
                }
                onAssignContainedBy={(containedById, onComplete) =>
                  replaceItemContainedBy(
                    generatedItem,
                    setGeneratedItem,
                    setIsGeneratedItemOwnerSaving,
                    setGeneratedSaveMessage,
                    containedById,
                    onComplete
                  )
                }
                onAddContains={(relatedItemId, onComplete) =>
                  addItemContains(
                    generatedItem,
                    setGeneratedItem,
                    setIsGeneratedItemOwnerSaving,
                    setGeneratedSaveMessage,
                    relatedItemId,
                    onComplete
                  )
                }
                onRemoveContains={(relatedItem, onComplete) =>
                  removeItemContains(
                    generatedItem,
                    setGeneratedItem,
                    setIsGeneratedItemOwnerSaving,
                    setGeneratedSaveMessage,
                    relatedItem,
                    onComplete
                  )
                }
                isOwnerSaving={isGeneratedItemOwnerSaving}
                {...itemEditorOptions}
                onRemoveSpell={(index, spell) => removeSpellRow(setGeneratedItem, index, spell)}
              />
            )}

            {generatedPlace && generatorType === 'Place' && (
              <PlaceEditor
                value={generatedPlace}
                onChange={setGeneratedPlace}
                onSave={() => {
                  setIsGeneratedSaving(true);
                  setGeneratedSaveMessage('');
                  cdoPlace.saveGenerated(
                    {
                      ...generatedPlace,
                      parentIdEntity: generatedPlace.parentIdEntity || selectedGeneratedPlaceParentId || '',
                    },
                    (err, response) => {
                      setIsGeneratedSaving(false);
                      if (err || response?.error) {
                        window.alert(formatErrorMessage(err, response));
                        return;
                      }
                      setGeneratedPlace((prev) => ({
                        ...prev,
                        idEntity: response?.idEntity ?? prev?.idEntity,
                        parentIdEntity: response?.parentIdEntity ?? prev?.parentIdEntity ?? selectedGeneratedPlaceParentId ?? '',
                      }));
                      setGeneratedSaveMessage('Place saved successfully.');
                    }
                  );
                }}
                onGenerateDescription={(descriptionGuidance) =>
                  generateParentPlaceDescription(
                    generatedPlace,
                    setGeneratedPlace,
                    setIsGeneratedPlaceDescriptionLoading,
                    setGeneratedSaveMessage,
                    descriptionGuidance
                  )
                }
                onGenerateChild={(suggestion, onDone, sourcePrompt = '') => {
                  cdoPlace.generateChild(
                    {
                      parentIdEntity: generatedPlace.idEntity,
                      suggestion,
                      aogYear: Number(aogYear) || 0,
                      prompt: sourcePrompt,
                    },
                    (err, response) => {
                      onDone();
                      if (err || response?.error) {
                        window.alert(formatErrorMessage(err, response));
                        return;
                      }
                      reloadPlaceAfterChildSave(
                        generatedPlace.idEntity,
                        setGeneratedPlace,
                        (reloadErr, reloadResponse) => window.alert(formatErrorMessage(reloadErr, reloadResponse))
                      );
                      setGeneratedSaveMessage(`Child place "${response.name}" generated and saved.`);
                    }
                  );
                }}
                onGenerateAllSuggestions={(suggestions, onDone, sourcePrompt) =>
                  generateAllPlaceSuggestionChildren(
                    generatedPlace,
                    suggestions,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    onDone,
                    sourcePrompt
                  )
                }
                onMoveChildPlace={(movedChild) =>
                  saveMovedOverviewPlace(
                    movedChild,
                    setGeneratedSaveMessage
                  )
                }
                onMovePlace={(movedPlace) =>
                  saveMovedOverviewPlace(
                    movedPlace,
                    setGeneratedSaveMessage
                  )
                }
                onDuplicateChildPlace={(sourcePlace, duplicateName, onDone) =>
                  duplicateOverviewChildPlace(
                    generatedPlace,
                    sourcePlace,
                    duplicateName,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    null,
                    onDone
                  )
                }
                onRegeneratePath={(roadPlace, onDone) =>
                  regenerateOverviewPlacePath(
                    roadPlace,
                    setGeneratedSaveMessage,
                    onDone
                  )
                }
                onLoadOverviewPlace={loadOverviewPlace}
                onLoadOverviewContext={loadOverviewContext}
                onGenerateSuggestions={(suggestionPrompt) =>
                  generatePlaceSuggestions(
                    generatedPlace.idEntity,
                    setGeneratedPlace,
                    setIsGeneratedPlaceSuggestionLoading,
                    setGeneratedSaveMessage,
                    suggestionPrompt,
                    generatedPlace.childPlaceSuggestions
                  )
                }
                onGenerateInhabitantSuggestions={() =>
                  generatePlaceInhabitantSuggestions(
                    generatedPlace.idEntity,
                    setGeneratedPlace,
                    setIsGeneratedPlaceInhabitantSuggestionLoading,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateInhabitant={(suggestion, index, onDone) =>
                  generatePlaceInhabitant(
                    generatedPlace.idEntity,
                    suggestion,
                    index,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    onDone
                  )
                }
                onGenerateAllInhabitants={(suggestions, onDone) =>
                  generateAllPlaceInhabitants(
                    generatedPlace,
                    suggestions,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    onDone
                  )
                }
                onGenerateInhabitantRelationships={() =>
                  generatePlaceInhabitantRelationships(
                    generatedPlace,
                    setIsGeneratedPlaceInhabitantRelationshipLoading,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateInhabitantPlaceRelationships={() =>
                  generatePlaceInhabitantPlaceRelationships(
                    generatedPlace,
                    setIsGeneratedPlaceInhabitantRelationshipLoading,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateItemSuggestions={() =>
                  generatePlaceItemSuggestions(
                    generatedPlace.idEntity,
                    setGeneratedPlace,
                    setIsGeneratedPlaceItemSuggestionLoading,
                    setGeneratedSaveMessage
                  )
                }
                onGenerateContainedItem={(suggestion, index, onDone) =>
                  generatePlaceContainedItem(
                    generatedPlace.idEntity,
                    suggestion,
                    index,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    onDone
                  )
                }
                onGenerateAllContainedItems={(suggestions) => {
                  setIsGeneratedPlaceItemBulkCreating(true);
                  generateAllPlaceContainedItems(
                    generatedPlace,
                    suggestions,
                    setGeneratedPlace,
                    setGeneratedSaveMessage,
                    () => setIsGeneratedPlaceItemBulkCreating(false)
                  );
                }}
                isSaving={isGeneratedSaving}
                isGeneratingDescription={isGeneratedPlaceDescriptionLoading}
                isGeneratingSuggestions={isGeneratedPlaceSuggestionLoading}
                isGeneratingInhabitantSuggestions={isGeneratedPlaceInhabitantSuggestionLoading}
                isGeneratingInhabitantRelationships={isGeneratedPlaceInhabitantRelationshipLoading}
                isGeneratingItemSuggestions={isGeneratedPlaceItemSuggestionLoading}
                isCreatingAllContainedItems={isGeneratedPlaceItemBulkCreating}
                saveMessage={generatedSaveMessage}
                getMasterTypeOptions={getMasterTypeOptions}
                placeTypeOptions={getMasterTypeOptions('placeType')}
                zoneTypeOptions={getMasterTypeOptions('zoneType')}
                buildingTypeOptions={getMasterTypeOptions('buildingType')}
                transitPointTypeOptions={getMasterTypeOptions('transitPointType')}
                currencyOptions={currencyOptions}
                image={generatedPlaceImage}
                canGenerateImage={Boolean(generatedPlace.idEntity && !generatedPlaceImage.isLoadingSavedImage)}
                canSaveImage={Boolean(generatedPlace.idEntity && generatedPlaceImage.src && !generatedPlaceImage.isSaved)}
                onGenerateImage={(payload, options) =>
                  generatePlaceImage(payload, setGeneratedPlaceImage, setGeneratedSaveMessage, options)
                }
                onSaveImage={(imageOverride) =>
                  savePlaceImage(
                    generatedPlace,
                    imageOverride || generatedPlaceImage,
                    setGeneratedPlaceImage,
                    setGeneratedSaveMessage
                  )
                }
              />
            )}
            </>
            )}
          </>
        )}

        {activeTab === 'Edit Existing' && (
          <section className="panel">
            <div className="panel-header-row">
              <div>
                <h2>Edit Existing</h2>
                <p className="panel-copy">{['Template', 'Being', 'Place'].includes(editExistingTab) ? 'Filter the cards and select one to open its editor.' : 'Select a record on the left to load it into the editor.'}</p>
              </div>
            </div>

            {editExistingTab === 'Template' && <TemplateEditor masterTypes={masterTypes} aogYear={aogYear} />}

            {editExistingTab === 'Being' && (
              <EntityEditorCatalog kind="Being" records={existingBeings} selectedId={selectedExistingBeingId}
                onSelect={setSelectedExistingBeingId} loading={isLoadingExistingBeingList} onRefresh={loadExistingBeings} saving={isExistingBeingSaving}>

                <div className="existing-editor-panel">
                  {isLoadingExistingBeing ? (
                    <div className="empty-grid">Loading being...</div>
                  ) : selectedExistingBeingId ? (
                    <BeingEditor aogYear={aogYear}
                      title="Being Editor"
                      copy="Edit the selected being and save changes back to the database."
                      value={existingBeing}
                      onChange={setExistingBeing}
                      onSave={() =>
                        saveBeing(
                          existingBeing,
                          setExistingBeing,
                          setIsExistingBeingSaving,
                          setExistingBeingSaveMessage,
                          (savedId) => {
                            if (savedId) {
                              setSelectedExistingBeingId(savedId);
                              loadBeingPortrait(savedId, setExistingBeingPortrait, true, existingBeingPortraitLoadRef);
                            }
                          }
                        )
                      }
                      onCopyJson={() =>
                        copyJson(existingBeing, createEmptyBeing, setExistingBeingSaveMessage, 'being')
                      }
                      isSaving={isExistingBeingSaving}
                      saveMessage={existingBeingSaveMessage}
                      getMasterTypeOptions={getMasterTypeOptions}
                      spellListOptions={spellListOptions}
                      spellUsageOptions={spellUsageOptions}
                      currencyOptions={currencyOptions}
                      placeOptions={routinePlaceOptions}
                      onRemoveForm={(index, form) => removeFormRow(setExistingBeing, index, form)}
                      onRemoveSpell={(index, spell) => removeSpellRow(setExistingBeing, index, spell)}
                      onGenerateItemSuggestions={() =>
                        generateBeingItemSuggestions(
                          existingBeing.idEntity,
                          setExistingBeing,
                          setIsExistingBeingItemSuggestionLoading,
                          setExistingBeingSaveMessage
                        )
                      }
                      onGenerateSuggestedItem={(suggestion, index) =>
                        generateBeingSuggestedItem(
                          existingBeing.idEntity,
                          suggestion,
                          index,
                          setExistingBeing,
                          setExistingBeingSaveMessage
                        )
                      }
                      onGenerateAllItemSuggestions={(suggestions) =>
                        {
                          setIsExistingBeingItemBulkCreating(true);
                          generateAllBeingSuggestedItems(
                            existingBeing,
                            suggestions,
                            setExistingBeing,
                            setExistingBeingSaveMessage,
                            () => setIsExistingBeingItemBulkCreating(false)
                          );
                        }
                      }
                      onGenerateRoutines={() =>
                        generateBeingRoutines(
                          existingBeing,
                          setExistingBeing,
                          setIsExistingBeingRoutineGenerating,
                          setExistingBeingSaveMessage
                        )
                      }
                      onDeleteRelationship={(relationship, index) =>
                        deleteBeingRelationship(
                          relationship,
                          index,
                          setExistingBeing,
                          setIsExistingBeingSaving,
                          setExistingBeingSaveMessage
                        )
                      }
                      relationshipTargetOptions={getBeingRelationshipTargetOptions(existingBeing.idEntity)}
                      relateTypeOptions={relateTypeOptions}
                      isGeneratingItemSuggestions={isExistingBeingItemSuggestionLoading}
                      isCreatingAllItemSuggestions={isExistingBeingItemBulkCreating}
                      isGeneratingRoutines={isExistingBeingRoutineGenerating}
                      portrait={existingBeingPortrait}
                      canGeneratePortrait={Boolean(existingBeing.idEntity && !isLoadingExistingBeing && !existingBeingPortrait.isLoadingSavedImage)}
                      canSavePortrait={Boolean(existingBeing.idEntity && existingBeingPortrait.src && !existingBeingPortrait.isSaved)}
                      onGeneratePortrait={() =>
                        generateBeingPortrait(existingBeing, setExistingBeingPortrait, setExistingBeingSaveMessage, {
                          onGenerated: (generatedPortrait) => {
                            if (existingBeingPortrait.hasCheckedSavedImage && !existingBeingPortrait.src) {
                              saveBeingPortrait(
                                existingBeing,
                                generatedPortrait,
                                setExistingBeingPortrait,
                                setExistingBeingSaveMessage
                              );
                            }
                          },
                        })
                      }
                      onSavePortrait={() =>
                        saveBeingPortrait(
                          existingBeing,
                          existingBeingPortrait,
                          setExistingBeingPortrait,
                          setExistingBeingSaveMessage
                        )
                      }
                    />
                  ) : (
                    <div className="empty-grid">Select a being to begin editing.</div>
                  )}
                </div>
              </EntityEditorCatalog>
            )}

            {editExistingTab === 'Item' && (
              <div className="existing-layout existing-scroll-layout">
                <aside className="existing-list-panel">
                  <div className="existing-list-header">
                    <h3>Items</h3>
                    <button
                      type="button"
                      className="secondary-button button-with-icon"
                      onClick={loadExistingItems}
                      disabled={isLoadingExistingItemList}
                    >
                      <RefreshIcon />
                      <span>{isLoadingExistingItemList ? 'Loading...' : 'Refresh'}</span>
                    </button>
                  </div>
                  <div className="existing-list">
                    {existingItems.map((item) => (
                      <button
                        key={item.idEntity}
                        type="button"
                        className={`existing-list-item ${selectedExistingItemId === item.idEntity ? 'active' : ''}`}
                        onClick={() => setSelectedExistingItemId(item.idEntity)}
                      >
                        <span className="existing-list-name">{item.name}</span>
                        {item.title && <span className="existing-list-title">{item.title}</span>}
                      </button>
                    ))}
                    {existingItems.length === 0 && !isLoadingExistingItemList && (
                      <div className="empty-grid">No items found.</div>
                    )}
                  </div>
                </aside>

                <div className="existing-editor-panel">
                  {isLoadingExistingItem ? (
                    <div className="empty-grid">Loading item...</div>
                  ) : selectedExistingItemId ? (
                    <ItemEditor
                      title="Item Editor"
                      copy="Edit the selected item and save changes back to the database."
                      value={existingItem}
                      onChange={setExistingItem}
                      onSave={() =>
                        saveItem(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemSaving,
                          setExistingItemSaveMessage,
                          (savedId) => {
                            if (savedId) {
                              setSelectedExistingItemId(savedId);
                            }
                          }
                        )
                      }
                      onCopyJson={() =>
                        copyJson(existingItem, createEmptyItem, setExistingItemSaveMessage, 'item')
                      }
                      onDuplicate={() =>
                        duplicateItem(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemSaving,
                          setExistingItemSaveMessage,
                          (duplicatedId) => {
                            if (duplicatedId) {
                              setSelectedExistingItemId(duplicatedId);
                            }
                          }
                        )
                      }
                      onDelete={() =>
                        deleteItem(
                          existingItem,
                          setIsExistingItemSaving,
                          setExistingItemSaveMessage,
                          handleExistingItemDeleted
                        )
                      }
                      isSaving={isExistingItemSaving}
                      saveMessage={existingItemSaveMessage}
                      getMasterTypeOptions={getMasterTypeOptions}
                      spellListOptions={spellListOptions}
                      spellUsageOptions={spellUsageOptions}
                      ownerOptions={ownerOptions}
                      containedByOptions={containedByOptions}
                      itemRelationshipOptions={itemRelationshipOptions}
                      onAssignOwner={(ownerId, onComplete) =>
                        assignItemOwner(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemOwnerSaving,
                          setExistingItemSaveMessage,
                          ownerId,
                          onComplete
                        )
                      }
                      onAssignContainedBy={(containedById, onComplete) =>
                        replaceItemContainedBy(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemOwnerSaving,
                          setExistingItemSaveMessage,
                          containedById,
                          onComplete
                        )
                      }
                      onAddContains={(relatedItemId, onComplete) =>
                        addItemContains(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemOwnerSaving,
                          setExistingItemSaveMessage,
                          relatedItemId,
                          onComplete
                        )
                      }
                      onRemoveContains={(relatedItem, onComplete) =>
                        removeItemContains(
                          existingItem,
                          setExistingItem,
                          setIsExistingItemOwnerSaving,
                          setExistingItemSaveMessage,
                          relatedItem,
                          onComplete
                        )
                      }
                      isOwnerSaving={isExistingItemOwnerSaving}
                      {...itemEditorOptions}
                      onRemoveSpell={(index, spell) => removeSpellRow(setExistingItem, index, spell)}
                    />
                  ) : (
                    <div className="empty-grid">Select an item to begin editing.</div>
                  )}
                </div>
              </div>
            )}

            {editExistingTab === 'Place' && (
              <EntityEditorCatalog kind="Place" records={existingPlaces} selectedId={selectedExistingPlaceId}
                onSelect={setSelectedExistingPlaceId} loading={isLoadingExistingPlaceList} onRefresh={loadExistingPlaces} saving={isExistingPlaceSaving}>

                <div className="existing-editor-panel">
                  {isLoadingExistingPlace ? (
                    <div className="empty-grid">Loading place...</div>
                  ) : selectedExistingPlaceId ? (
                    <PlaceEditor
                      title="Place Editor"
                      copy="Edit the selected place and save changes back to the database."
                      value={existingPlace}
                      onChange={setExistingPlace}
                      onSave={() =>
                        savePlace(
                          existingPlace,
                          setExistingPlace,
                          setIsExistingPlaceSaving,
                          setExistingPlaceSaveMessage,
                          (savedId) => {
                            if (savedId) {
                              setSelectedExistingPlaceId(savedId);
                            }
                          }
                        )
                      }
                      onDelete={() =>
                        deletePlace(
                          existingPlace,
                          setIsExistingPlaceSaving,
                          setExistingPlaceSaveMessage,
                          handleExistingPlaceDeleted
                        )
                      }
                      onGenerateDescription={(descriptionGuidance) =>
                        generateParentPlaceDescription(
                          existingPlace,
                          setExistingPlace,
                          setIsExistingPlaceDescriptionLoading,
                          setExistingPlaceSaveMessage,
                          descriptionGuidance
                        )
                      }
                      isSaving={isExistingPlaceSaving}
                      isGeneratingDescription={isExistingPlaceDescriptionLoading}
                      saveMessage={existingPlaceSaveMessage}
                      getMasterTypeOptions={getMasterTypeOptions}
                      placeTypeOptions={getMasterTypeOptions('placeType')}
                      zoneTypeOptions={getMasterTypeOptions('zoneType')}
                      buildingTypeOptions={getMasterTypeOptions('buildingType')}
                      transitPointTypeOptions={getMasterTypeOptions('transitPointType')}
                      onGenerateChild={(suggestion, onDone, sourcePrompt = '') => {
                        cdoPlace.generateChild(
                          {
                            parentIdEntity: existingPlace.idEntity,
                            suggestion,
                            aogYear: Number(aogYear) || 0,
                            prompt: sourcePrompt,
                          },
                          (err, response) => {
                            onDone();
                            if (err || response?.error) {
                              window.alert(formatErrorMessage(err, response));
                              return;
                            }
                            reloadPlaceAfterChildSave(
                              existingPlace.idEntity,
                              setExistingPlace,
                              (reloadErr, reloadResponse) => window.alert(formatErrorMessage(reloadErr, reloadResponse))
                            );
                            loadExistingPlaces();
                            setExistingPlaceSaveMessage(`Child place "${response.name}" generated and saved.`);
                          }
                        );
                      }}
                      onGenerateAllSuggestions={(suggestions, onDone, sourcePrompt) =>
                        generateAllPlaceSuggestionChildren(
                          existingPlace,
                          suggestions,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          () => {
                            loadExistingPlaces();
                            onDone();
                          },
                          sourcePrompt
                        )
                      }
                      onMoveChildPlace={(movedChild) =>
                        saveMovedOverviewPlace(
                          movedChild,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onMovePlace={(movedPlace) =>
                        saveMovedOverviewPlace(
                          movedPlace,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onDuplicateChildPlace={(sourcePlace, duplicateName, onDone) =>
                        duplicateOverviewChildPlace(
                          existingPlace,
                          sourcePlace,
                          duplicateName,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          loadExistingPlaces,
                          onDone
                        )
                      }
                      onRegeneratePath={(roadPlace, onDone) =>
                        regenerateOverviewPlacePath(
                          roadPlace,
                          setExistingPlaceSaveMessage,
                          onDone
                        )
                      }
                      onLoadOverviewPlace={loadOverviewPlace}
                      onLoadOverviewContext={loadOverviewContext}
                      onGenerateSuggestions={(suggestionPrompt) =>
                        generatePlaceSuggestions(
                          existingPlace.idEntity,
                          setExistingPlace,
                          setIsExistingPlaceSuggestionLoading,
                          setExistingPlaceSaveMessage,
                          suggestionPrompt,
                          existingPlace.childPlaceSuggestions
                        )
                      }
                      onGenerateInhabitantSuggestions={() =>
                        generatePlaceInhabitantSuggestions(
                          existingPlace.idEntity,
                          setExistingPlace,
                          setIsExistingPlaceInhabitantSuggestionLoading,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onGenerateInhabitant={(suggestion, index, onDone) =>
                        generatePlaceInhabitant(
                          existingPlace.idEntity,
                          suggestion,
                          index,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          onDone
                        )
                      }
                      onGenerateAllInhabitants={(suggestions, onDone) =>
                        generateAllPlaceInhabitants(
                          existingPlace,
                          suggestions,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          onDone
                        )
                      }
                      onGenerateInhabitantRelationships={() =>
                        generatePlaceInhabitantRelationships(
                          existingPlace,
                          setIsExistingPlaceInhabitantRelationshipLoading,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onGenerateInhabitantPlaceRelationships={() =>
                        generatePlaceInhabitantPlaceRelationships(
                          existingPlace,
                          setIsExistingPlaceInhabitantRelationshipLoading,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onGenerateItemSuggestions={() =>
                        generatePlaceItemSuggestions(
                          existingPlace.idEntity,
                          setExistingPlace,
                          setIsExistingPlaceItemSuggestionLoading,
                          setExistingPlaceSaveMessage
                        )
                      }
                      onGenerateContainedItem={(suggestion, index, onDone) =>
                        generatePlaceContainedItem(
                          existingPlace.idEntity,
                          suggestion,
                          index,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          onDone
                        )
                      }
                      onGenerateAllContainedItems={(suggestions) => {
                        setIsExistingPlaceItemBulkCreating(true);
                        generateAllPlaceContainedItems(
                          existingPlace,
                          suggestions,
                          setExistingPlace,
                          setExistingPlaceSaveMessage,
                          () => setIsExistingPlaceItemBulkCreating(false)
                        );
                      }}
                      isGeneratingSuggestions={isExistingPlaceSuggestionLoading}
                      isGeneratingInhabitantSuggestions={isExistingPlaceInhabitantSuggestionLoading}
                      isGeneratingInhabitantRelationships={isExistingPlaceInhabitantRelationshipLoading}
                      isGeneratingItemSuggestions={isExistingPlaceItemSuggestionLoading}
                      isCreatingAllContainedItems={isExistingPlaceItemBulkCreating}
                      currencyOptions={currencyOptions}
                      image={existingPlaceImage}
                      canGenerateImage={Boolean(existingPlace.idEntity && !isLoadingExistingPlace && !existingPlaceImage.isLoadingSavedImage)}
                      canSaveImage={Boolean(existingPlace.idEntity && existingPlaceImage.src && !existingPlaceImage.isSaved)}
                      onGenerateImage={(payload, options) =>
                        generatePlaceImage(payload, setExistingPlaceImage, setExistingPlaceSaveMessage, options)
                      }
                      onSaveImage={(imageOverride) =>
                        savePlaceImage(
                          existingPlace,
                          imageOverride || existingPlaceImage,
                          setExistingPlaceImage,
                          setExistingPlaceSaveMessage
                        )
                      }
                    />
                  ) : (
                    <div className="empty-grid">Select a place to begin editing.</div>
                  )}
                </div>
              </EntityEditorCatalog>
            )}
            {editExistingTab === 'Event' && <div className="empty-grid">Event editor coming next.</div>}
          </section>
        )}

        {activeTab === 'Test' && (
          <section className="panel">
            <div className="panel-header-row">
              <div>
                <h2>{testTab === 'Play' ? 'Intent Test' : testTab}</h2>
                {testTab === 'Explore' && (
                  <p className="panel-copy">Browse saved settlements and inspect their place trees, inhabitants, items, and relationships.</p>
                )}
              </div>
            </div>

            {testTab === 'Combat' && (
              <CombatTestPanel
                selectedCombatantOneId={selectedCombatantOneId}
                selectedCombatantTwoId={selectedCombatantTwoId}
                setSelectedCombatantOneId={setSelectedCombatantOneId}
                setSelectedCombatantTwoId={setSelectedCombatantTwoId}
                combatState={combatState}
                combatItemLocationEntries={combatItemLocationEntries}
                combatantOptions={combatantOptions}
                combatantOneDetail={combatantOneDetail}
                combatantTwoDetail={combatantTwoDetail}
                combatActionResult={combatActionResult}
                combatResponseActionResult={combatResponseActionResult}
                calculateCombatantDbForAction={calculateCombatantDbForAction}
                buildCombatStatusLine={buildCombatStatusLine}
                combatHistoryEntries={combatHistoryEntries}
                combatHistoryEndRef={combatHistoryEndRef}
                combatAction={combatAction}
                setCombatAction={setCombatAction}
                isCombatOver={isCombatOver}
                handleCombatActionSubmit={handleCombatActionSubmit}
                isSubmittingCombatAction={isSubmittingCombatAction}
                combatWinnerLabel={combatWinnerLabel}
                isGeneratingCombatNarration={isGeneratingCombatNarration}
                handleCombatantRefresh={handleCombatantRefresh}
                combatRollLogEntries={combatRollLogEntries}
                buildInitiativeLogLine={buildInitiativeLogLine}
                buildActionLogLine={buildActionLogLine}
                buildMovementLogLine={buildMovementLogLine}
                buildOutcomeLogLine={buildOutcomeLogLine}
                formatCombatFeet={formatCombatFeet}
              />
            )}
            {/* THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY. */}
            {testTab === 'Explore' && <Explore />}
            {testTab === 'Play' && <GameplayPlayTestPanel />}
          </section>
        )}

        {activeTab === 'Reference' && (
          <ReferenceEditor
            title={activeReferenceConfig.title}
            copy={activeReferenceConfig.copy}
            listTitle={activeReferenceConfig.listTitle}
            records={referenceRecords.map((record) => ({
              id: record[activeReferenceConfig.idField],
              raw: record,
            }))} 
            selectedId={selectedReferenceId}
            onSelect={selectReferenceRow}
            onEdit={editReferenceRow}
            onAddNew={addNewReferenceRow}
            onDelete={activeReferenceConfig.delete ? deleteReferenceRecord : undefined}
            isLoadingList={isLoadingReferenceList}
            value={referenceEditorValue}
            onChange={updateReferenceField}
            onSave={saveReferenceRecord}
            isSaving={isReferenceSaving}
            saveMessage={referenceSaveMessage}
            fields={activeReferenceConfig.fields}
          />
        )}
      </main>

      {isRelationshipModalOpen && (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="relationship-modal-title">
          <div className="modal-panel relationship-modal-panel">
            <div className="panel-header-row">
              <div>
                <h2 id="relationship-modal-title">{relationshipModalTitle}</h2>
                <p className="panel-copy">{relationshipModalCopy}</p>
              </div>
            </div>
            {relationshipModalMessage && <div className="panel-status">{relationshipModalMessage}</div>}
            <div className="editor-table relationship-suggestions-table">
              <div className="editor-table-row editor-table-head relationship-suggestions-grid">
                <span>Source</span>
                <span>Relate Type</span>
                <span>Target</span>
                <span>Reason</span>
              </div>
              {relationshipSuggestions.map((suggestion, index) => (
                <div key={`relationship-suggestion-${index}`} className="editor-table-row relationship-suggestions-grid">
                  <span>{suggestion.sourceName || suggestion.sourceEntityId}</span>
                  <span>{suggestion.relateType}</span>
                  <span>{suggestion.targetName || suggestion.targetEntityId}</span>
                  <span>{suggestion.reason}</span>
                </div>
              ))}
              {relationshipSuggestions.length === 0 && (
                <div className="empty-grid">No relationship suggestions.</div>
              )}
            </div>
            <div className="button-row">
              <button
                type="button"
                className="secondary-button"
                onClick={closeRelationshipModal}
                disabled={isCreatingRelationshipSuggestions}
              >
                Close
              </button>
              <button
                type="button"
                className="button-with-icon"
                onClick={createAllRelationshipSuggestions}
                disabled={isCreatingRelationshipSuggestions || relationshipSuggestions.length === 0}
              >
                <SparklesIcon />
                <span>{isCreatingRelationshipSuggestions ? 'Creating...' : 'Create All'}</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {isTokenUsageLogOpen && (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="token-usage-log-title">
          <div className="modal-panel token-usage-modal-panel">
            <div className="panel-header-row">
              <div>
                <h2 id="token-usage-log-title">AI Token Usage</h2>
                <p className="panel-copy">Recent AI calls with token totals and stored JSON payloads.</p>
              </div>
              <button
                type="button"
                className="secondary-button button-with-icon"
                onClick={loadTokenUsageLog}
                disabled={isTokenUsageLogLoading}
              >
                <RefreshIcon />
                <span>{isTokenUsageLogLoading ? 'Loading...' : 'Refresh'}</span>
              </button>
            </div>

            {tokenUsageCopyMessage && <div className="panel-status">{tokenUsageCopyMessage}</div>}
            {tokenUsageLogError && <div className="form-error">{tokenUsageLogError}</div>}

            <div className="token-usage-log-list">
              {tokenUsageLog.map((entry) => {
                const inputJson = formatStoredJson(entry.inputJson);
                const outputJson = formatStoredJson(entry.outputJson);

                return (
                  <article key={entry.idAiTokenUsage} className="token-usage-log-entry">
                    <div className="token-usage-entry-header">
                      <div>
                        <h3>{entry.operation || 'chat_completion'}</h3>
                        <div className="token-usage-entry-meta">
                          <span>{entry.model || 'Unknown model'}</span>
                          <span>{entry.status || 'unknown'}</span>
                          <span>{entry.dtCreated ? new Date(entry.dtCreated).toLocaleString() : 'Unknown time'}</span>
                        </div>
                      </div>
                      <div className="token-usage-token-grid" aria-label="Token usage">
                        <span>Input {entry.inputTokens ?? '-'}</span>
                        <span>Output {entry.outputTokens ?? '-'}</span>
                        <span>Total {entry.totalTokens ?? '-'}</span>
                        <span>{entry.durationMs ?? '-'}ms</span>
                      </div>
                    </div>

                    {entry.errorMessage && <div className="form-error">{entry.errorMessage}</div>}

                    <div className="token-json-grid">
                      <section className="token-json-panel">
                        <div className="token-json-panel-header">
                          <h4>Input JSON</h4>
                          <button
                            type="button"
                            className="secondary-button compact-button"
                            onClick={() => copyTokenUsageJson(entry.inputJson, 'input')}
                            disabled={!inputJson}
                          >
                            Copy Input
                          </button>
                        </div>
                        <pre className="token-json-pre">{inputJson || 'No input JSON stored.'}</pre>
                      </section>

                      <section className="token-json-panel">
                        <div className="token-json-panel-header">
                          <h4>Output JSON</h4>
                          <button
                            type="button"
                            className="secondary-button compact-button"
                            onClick={() => copyTokenUsageJson(entry.outputJson, 'output')}
                            disabled={!outputJson}
                          >
                            Copy Output
                          </button>
                        </div>
                        <pre className="token-json-pre">{outputJson || 'No output JSON stored.'}</pre>
                      </section>
                    </div>
                  </article>
                );
              })}

              {!isTokenUsageLogLoading && tokenUsageLog.length === 0 && (
                <div className="empty-grid">No AI token usage records found.</div>
              )}
            </div>

            <div className="button-row">
              <button type="button" className="secondary-button" onClick={closeTokenUsageLog}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isBeingJsonModalOpen && (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="being-json-modal-title">
          <div className="modal-panel">
            <div className="panel-header-row">
              <div>
                <h2 id="being-json-modal-title">Load Being JSON</h2>
                <p className="panel-copy">Paste a being JSON payload to replace the current editor state.</p>
              </div>
            </div>
            <label htmlFor="being-json-input" className="editor-field">
              <span className="field-label">Being JSON</span>
              <textarea
                id="being-json-input"
                className="text-area modal-textarea"
                value={beingJsonDraft}
                onChange={(event) => setBeingJsonDraft(event.target.value)}
              />
            </label>
            {beingJsonError && <div className="form-error">{beingJsonError}</div>}
            <div className="button-row">
              <button type="button" className="secondary-button" onClick={closeBeingJsonModal}>
                Cancel
              </button>
              <button type="button" className="button-with-icon" onClick={applyBeingJson}>
                <span>Load JSON</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
